function mgSelectText(el) {
  if (!el) return "";
  try {
    el.hidden = false;
  } catch (_) { }
  try {
    el.focus({ preventScroll: false });
  } catch (_) {
    try { el.focus(); } catch (_) { }
  }
  try {
    el.removeAttribute("readonly");
  } catch (_) { }
  try {
    el.select();
  } catch (_) { }
  try {
    el.setSelectionRange(0, String(el.value || "").length);
  } catch (_) { }
  try {
    el.setAttribute("readonly", "readonly");
  } catch (_) { }
  return String(el.value || "");
}

async function mgSelectAndCopyText(el) {
  const text = mgSelectText(el);
  if (!text) return false;
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (_) { }
  try {
    return !!document.execCommand("copy");
  } catch (_) { }
  return false;
}

(() => {
  "use strict";

  const MGPS_DEBUG_BUILD = "2026-04-11b";

  const R = window.__MGProductSwatchesRuntime || (window.__MGProductSwatchesRuntime = {});
  if (R.__installed) {
    try {
      if (typeof R.ensure === "function") {
        const cs = document.currentScript;
        const ctx = cs && cs.closest ? cs.closest(".shopify-section") : null;
        R.ensure(ctx || document);
      } else if (typeof R.refresh === "function" && document.readyState === "complete") {
        const cs = document.currentScript;
        const ctx = cs && cs.closest ? cs.closest(".shopify-section") : null;
        R.refresh(ctx || document);
      }
    } catch (_) { }
    return;
  }
  R.__installed = true;
  R.__rawSpecs = R.__rawSpecs || Object.create(null);

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn, { once: true });
    else fn();
  }

  const mgpsPreloadedPopupImageSrcs = new Set();
  const mgpsQueuedPopupImageSrcs = new Set();
  let mgpsPopupPreloadFlushQueued = false;
  const mgpsDebugFlags = (() => {
    const flags = {
      textFit: false,
      appearance: false,
      presetFit: false
    };
    try {
      const params = new URLSearchParams(window.location.search || "");
      const parseFlag = (name) => {
        const value = String(params.get(name) || "").trim().toLowerCase();
        return value === "1" || value === "true" || value === "yes" || value === "on";
      };
      flags.textFit = parseFlag("mgps_debug_text_fit");
      flags.appearance = parseFlag("mgps_debug_appearance");
      flags.presetFit = parseFlag("mgps_debug_preset_fit");
    } catch (_) { }
    return flags;
  })();

  function popupItemImageSrc(meta) {
    const baseSrc = rawImageSrc(meta?.thumbnail || meta?.image || meta?.img || "");
    if (!baseSrc) return "";
    try {
      return cappedShopifyImageUrl(baseSrc, 2400, 1200);
    } catch (_) {
      return baseSrc;
    }
  }

  function flushPopupImagePreloadQueue() {
    mgpsPopupPreloadFlushQueued = false;
    const sources = Array.from(mgpsQueuedPopupImageSrcs);
    mgpsQueuedPopupImageSrcs.clear();
    sources.forEach((src) => {
      if (!src || mgpsPreloadedPopupImageSrcs.has(src)) return;
      mgpsPreloadedPopupImageSrcs.add(src);
      try {
        const img = new Image();
        try { img.fetchPriority = "high"; } catch (_) { }
        img.decoding = "async";
        img.src = src;
      } catch (_) { }
    });
  }

  function queuePopupImagePreload(items) {
    const arr = Array.isArray(items) ? items : [];
    arr.forEach((meta) => {
      const src = popupItemImageSrc(meta);
      if (src) mgpsQueuedPopupImageSrcs.add(src);
    });
    if (mgpsPopupPreloadFlushQueued) return;
    mgpsPopupPreloadFlushQueued = true;
    ready(() => {
      try {
        if ("requestIdleCallback" in window) {
          window.requestIdleCallback(() => flushPopupImagePreloadQueue(), { timeout: 1200 });
        } else {
          setTimeout(() => flushPopupImagePreloadQueue(), 120);
        }
      } catch (_) {
        flushPopupImagePreloadQueue();
      }
    });
  }

  function safeJsonParse(text) {
    try { return JSON.parse(text); } catch (_) { return null; }
  }

  function setStyleImportant(el, prop, value) {
    if (!el) return;
    try {
      if (value == null || value === "") el.style.removeProperty(prop);
      else el.style.setProperty(prop, String(value), "important");
    } catch (_) { }
  }

  function getDataAttr(root, name) {
    try {
      if (!root || !root.getAttribute) return "";
      return String(root.getAttribute(name) || "").trim();
    } catch (_) {
      return "";
    }
  }

  function isNonEmptyObject(value) {
    return !!(value && typeof value === "object" && !Array.isArray(value) && Object.keys(value).length);
  }

  function appearanceHasVisualOverrides(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) return false;
    const keys = [
      "border_color",
      "borderColor",
      "border_size",
      "borderSize",
      "background_color",
      "backgroundColor",
      "background_image",
      "backgroundImage",
      "background_image_style",
      "backgroundImageStyle",
      "product_image_padding",
      "productImagePadding",
      "border_scope",
      "borderScope",
      "shadow_size",
      "shadowSize",
      "corner_radius_px",
      "cornerRadiusPx",
      "border_radius_px",
      "borderRadiusPx",
      "image_radius_px",
      "imageRadiusPx",
      "gradient_color",
      "gradientColor",
      "gradient_angle",
      "gradientAngle",
      "text_color",
      "textColor",
      "text_size_mobile",
      "textSizeMobile",
      "text_size_desktop",
      "textSizeDesktop",
      "text_style",
      "textStyle",
      "selected_text_style",
      "selectedTextStyle"
    ];
    return keys.some((key) => Object.prototype.hasOwnProperty.call(value, key) && value[key] !== null && value[key] !== "");
  }

  function rootHasExplicitAppearance(root) {
    try {
      const appearanceJson = safeJsonParse(getDataAttr(root, "data-mgps-appearance") || "{}") || {};
      const selectedJson = safeJsonParse(getDataAttr(root, "data-mgps-selected-appearance") || "{}") || {};
      if (appearanceHasVisualOverrides(appearanceJson) || appearanceHasVisualOverrides(selectedJson)) return true;
      const attrs = [
        "data-mgps-border-color",
        "data-mgps-border-size",
        "data-mgps-background-color",
        "data-mgps-background-image",
        "data-mgps-background-image-style",
        "data-mgps-product-image-padding",
        "data-mgps-border-scope",
        "data-mgps-selected-border-color",
        "data-mgps-selected-border-size",
        "data-mgps-selected-border-scope",
        "data-mgps-selected-background-color",
        "data-mgps-selected-background-image",
        "data-mgps-selected-background-image-style",
        "data-mgps-selected-product-image-padding",
        "data-mgps-corner-radius"
      ];
      return attrs.some((name) => getDataAttr(root, name) !== "");
    } catch (_) {
      return false;
    }
  }

  function collapseWhitespace(value) {
    return String(value == null ? "" : value).replace(/\s+/g, " ").trim();
  }

  function isDebugTextFitEnabled() {
    return mgpsDebugFlags.textFit;
  }

  function appearanceHasExplicitBorderOverrides(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) return false;
    const keys = [
      "border_color",
      "borderColor",
      "border_size",
      "borderSize",
      "border_scope",
      "borderScope",
      "shadow_size",
      "shadowSize",
      "corner_radius_px",
      "cornerRadiusPx",
      "border_radius_px",
      "borderRadiusPx",
      "image_radius_px",
      "imageRadiusPx"
    ];
    return keys.some((key) => Object.prototype.hasOwnProperty.call(value, key) && value[key] !== null && value[key] !== "");
  }

  function rootHasExplicitBorderAppearance(root) {
    try {
      const appearanceJson = safeJsonParse(getDataAttr(root, "data-mgps-appearance") || "{}") || {};
      const selectedJson = safeJsonParse(getDataAttr(root, "data-mgps-selected-appearance") || "{}") || {};
      if (appearanceHasExplicitBorderOverrides(appearanceJson) || appearanceHasExplicitBorderOverrides(selectedJson)) return true;
      const attrs = [
        "data-mgps-border-color",
        "data-mgps-border-size",
        "data-mgps-border-scope",
        "data-mgps-selected-border-color",
        "data-mgps-selected-border-size",
        "data-mgps-selected-border-scope",
        "data-mgps-border-radius",
        "data-mgps-image-radius",
        "data-mgps-corner-radius"
      ];
      return attrs.some((name) => getDataAttr(root, name) !== "");
    } catch (_) {
      return false;
    }
  }

  function rootTextBehaviorOverride(root) {
    const raw = getDataAttr(root, "data-mgps-text-behavior");
    const normalized = String(raw || "").trim().toLowerCase();
    if (!normalized || normalized === "wrap_text") return "";
    return normalized;
  }

  function textContentExcludingNode(el, excludedNode) {
    if (!el) return "";
    try {
      return collapseWhitespace(Array.from(el.childNodes || [])
        .filter((node) => node && node !== excludedNode)
        .map((node) => String(node.textContent || ""))
        .join(" "));
    } catch (_) {
      return collapseWhitespace(String(el.textContent || ""));
    }
  }

  function measuredTextWidth(text, sourceEl) {
    const content = collapseWhitespace(text);
    if (!content || !sourceEl || !document.body) return 0;
    try {
      const probe = document.createElement("span");
      const computed = window.getComputedStyle ? window.getComputedStyle(sourceEl) : null;
      probe.textContent = content;
      probe.style.position = "fixed";
      probe.style.left = "-99999px";
      probe.style.top = "0";
      probe.style.visibility = "hidden";
      probe.style.pointerEvents = "none";
      probe.style.display = "inline-block";
      probe.style.width = "auto";
      probe.style.minWidth = "0";
      probe.style.maxWidth = "none";
      probe.style.margin = "0";
      probe.style.padding = "0";
      probe.style.border = "0";
      probe.style.whiteSpace = "nowrap";
      probe.style.wordBreak = "normal";
      probe.style.overflowWrap = "normal";
      probe.style.textTransform = "none";
      probe.style.transform = "none";
      probe.style.letterSpacing = "normal";
      if (computed) {
        probe.style.font = computed.font;
        probe.style.fontFamily = computed.fontFamily;
        probe.style.fontSize = computed.fontSize;
        probe.style.fontStyle = computed.fontStyle;
        probe.style.fontWeight = computed.fontWeight;
        probe.style.fontStretch = computed.fontStretch;
        probe.style.fontKerning = computed.fontKerning;
        probe.style.fontVariantLigatures = computed.fontVariantLigatures;
        probe.style.lineHeight = computed.lineHeight;
        probe.style.textTransform = computed.textTransform;
        probe.style.wordSpacing = computed.wordSpacing;
      }
      document.body.appendChild(probe);
      const width = Math.ceil(probe.getBoundingClientRect().width || probe.scrollWidth || probe.offsetWidth || 0);
      probe.remove();
      return width;
    } catch (_) {
      return 0;
    }
  }

  function squeezeLetterSpacingEm(scaleX) {
    const scale = clampNumber(scaleX, 0.4, 1, 1);
    if (scale >= 0.999) return "normal";
    const deficit = 1 - scale;
    const spacing = Math.max(-0.035, Math.min(-0.008, -(deficit * 0.42)));
    return spacing.toFixed(3) + "em";
  }

  function squeezeVisualReservePx(el) {
    if (!el) return 10;
    try {
      const computed = window.getComputedStyle ? window.getComputedStyle(el) : null;
      const fontSize = computed ? (parseFloat(computed.fontSize || "0") || 0) : 0;
      return Math.max(8, Math.min(12, Math.round(fontSize * 0.9) || 10));
    } catch (_) {
      return 10;
    }
  }

  function unwrapFittedTextInner(el) {
    if (!el || !el.querySelector) return;
    try {
      const inner = el.querySelector(':scope > [data-mgps-fit-text]');
      if (!inner) return;
      const sourceText = collapseWhitespace(inner.textContent || textContentExcludingNode(el, inner) || el.textContent || "");
      if (sourceText) el.textContent = sourceText;
      else inner.remove();
    } catch (_) { }
  }

  function ensureFittedTextInner(el, text) {
    if (!el || !document.createElement) return null;
    try {
      let inner = el.querySelector(':scope > [data-mgps-fit-text]');
      if (!inner) {
        inner = document.createElement("span");
        inner.setAttribute("data-mgps-fit-text", "true");
        while (el.firstChild) inner.appendChild(el.firstChild);
        el.appendChild(inner);
      }
      inner.textContent = text;
      return inner;
    } catch (_) {
      return null;
    }
  }

  function applySqueezedTextFit(el, enabled) {
    if (!el) return;
    try {
      unwrapFittedTextInner(el);
      const baseFontSize = (() => {
        const raw = el.dataset.mgpsBaseFontSize || "";
        if (raw) return raw;
        const computed = window.getComputedStyle ? window.getComputedStyle(el) : null;
        const value = computed ? String(computed.fontSize || "") : "";
        return value || "";
      })();
      const baseLineHeight = (() => {
        const raw = el.dataset.mgpsBaseLineHeight || "";
        if (raw) return raw;
        const computed = window.getComputedStyle ? window.getComputedStyle(el) : null;
        const value = computed ? String(computed.lineHeight || "") : "";
        return value || "";
      })();

      try {
        if (baseFontSize) el.dataset.mgpsBaseFontSize = baseFontSize;
        if (baseLineHeight) el.dataset.mgpsBaseLineHeight = baseLineHeight;
      } catch (_) { }

      if (!enabled) {
        unwrapFittedTextInner(el);
        setStyleImportant(el, "transform-origin", "center center");
        setStyleImportant(el, "display", "block");
        setStyleImportant(el, "width", "100%");
        setStyleImportant(el, "max-width", "100%");
        setStyleImportant(el, "margin", "0");
        setStyleImportant(el, "justify-self", "");
        setStyleImportant(el, "align-self", "center");
        setStyleImportant(el, "text-align", "center");
        setStyleImportant(el, "letter-spacing", "normal");
        setStyleImportant(el, "font-size", baseFontSize || "");
        setStyleImportant(el, "line-height", baseLineHeight || "");
        setStyleImportant(el, "transform", "none");
        try {
          el.dataset.mgpsFitEnabled = "false";
          el.dataset.mgpsFitApplied = "false";
          el.dataset.mgpsFitScale = "1";
          el.dataset.mgpsFitNaturalWidth = "0";
          el.dataset.mgpsFitAvailableWidth = String(Math.floor(el.clientWidth || el.getBoundingClientRect().width || 0) || 0);
        } catch (_) { }
        return;
      }
      const measuredAvailableWidth = Math.floor(
        (el.parentElement && (el.parentElement.clientWidth || (el.parentElement.getBoundingClientRect && el.parentElement.getBoundingClientRect().width) || 0))
        || el.clientWidth
        || el.getBoundingClientRect().width
        || 0
      );
      const availableWidth = Math.max(0, measuredAvailableWidth - squeezeVisualReservePx(el));
      setStyleImportant(el, "display", "block");
      setStyleImportant(el, "width", "100%");
      setStyleImportant(el, "max-width", "100%");
      setStyleImportant(el, "margin", "0");
      setStyleImportant(el, "justify-self", "");
      setStyleImportant(el, "align-self", "center");
      setStyleImportant(el, "transform-origin", "center center");
      setStyleImportant(el, "text-align", "center");
      setStyleImportant(el, "white-space", "nowrap");
      setStyleImportant(el, "overflow", "visible");
      const text = collapseWhitespace(el.textContent || "");
      if (!text || !(availableWidth > 0)) {
        setStyleImportant(el, "display", "block");
        setStyleImportant(el, "width", "100%");
        setStyleImportant(el, "max-width", "100%");
        setStyleImportant(el, "margin", "0");
        setStyleImportant(el, "justify-self", "");
        setStyleImportant(el, "align-self", "center");
        setStyleImportant(el, "text-align", "center");
        setStyleImportant(el, "letter-spacing", "normal");
        setStyleImportant(el, "font-size", baseFontSize || "");
        setStyleImportant(el, "line-height", baseLineHeight || "");
        setStyleImportant(el, "transform", "none");
        setStyleImportant(el, "overflow", "visible");
        const emptyInner = ensureFittedTextInner(el, "");
        if (emptyInner) {
          setStyleImportant(emptyInner, "display", "inline-block");
          setStyleImportant(emptyInner, "margin", "0");
          setStyleImportant(emptyInner, "transform-origin", "left center");
          setStyleImportant(emptyInner, "letter-spacing", "normal");
          setStyleImportant(emptyInner, "transform", "none");
        }
        try {
          el.dataset.mgpsFitEnabled = "true";
          el.dataset.mgpsFitApplied = "false";
          el.dataset.mgpsFitScale = "1";
          el.dataset.mgpsFitNaturalWidth = "0";
          el.dataset.mgpsFitAvailableWidth = String(availableWidth || 0);
        } catch (_) { }
        return;
      }

      const naturalWidth = measuredTextWidth(text, el);
      const scaleX = naturalWidth > 0 && availableWidth > 0
        ? Math.max(0.4, Math.min(1, availableWidth / naturalWidth))
        : 1;
      const inner = ensureFittedTextInner(el, text);
      setStyleImportant(el, "margin", "0");
      setStyleImportant(el, "justify-self", "");
      setStyleImportant(el, "align-self", "center");
      setStyleImportant(el, "text-align", "center");
      setStyleImportant(el, "font-size", baseFontSize || "");
      setStyleImportant(el, "line-height", baseLineHeight || "");
      setStyleImportant(el, "transform", "none");
      setStyleImportant(el, "overflow", "visible");
      if (inner) {
        setStyleImportant(inner, "display", "inline-block");
        setStyleImportant(inner, "margin", "0");
        setStyleImportant(inner, "transform-origin", "left center");
        setStyleImportant(inner, "vertical-align", "top");
        setStyleImportant(inner, "letter-spacing", squeezeLetterSpacingEm(scaleX));
        setStyleImportant(inner, "transform", scaleX < 0.999 ? ("scaleX(" + scaleX.toFixed(3) + ")") : "none");
      }
      try {
        el.dataset.mgpsFitEnabled = "true";
        el.dataset.mgpsFitApplied = scaleX < 0.999 ? "true" : "false";
        el.dataset.mgpsFitScale = scaleX.toFixed(3);
        el.dataset.mgpsFitNaturalWidth = String(naturalWidth || 0);
        el.dataset.mgpsFitAvailableWidth = String(availableWidth || 0);
      } catch (_) { }
    } catch (_) { }
  }

  function updateTextFitDebugCard(card, textBehavior) {
    if (!card) return;
    try {
      let badge = card.querySelector(":scope > .mgps-debug-text-fit");
      if (!isDebugTextFitEnabled()) {
        if (badge) badge.remove();
        return;
      }

      const titleEl = card.querySelector(".mgps-title");
      const scale = titleEl ? String(titleEl.dataset.mgpsFitScale || "") : "";
      const applied = titleEl ? String(titleEl.dataset.mgpsFitApplied || "") : "";
      const natural = titleEl ? String(titleEl.dataset.mgpsFitNaturalWidth || "") : "";
      const available = titleEl ? String(titleEl.dataset.mgpsFitAvailableWidth || "") : "";

      if (!badge) {
        badge = document.createElement("div");
        badge.className = "mgps-debug-text-fit";
        badge.style.position = "absolute";
        badge.style.top = "4px";
        badge.style.left = "4px";
        badge.style.zIndex = "30";
        badge.style.maxWidth = "calc(100% - 8px)";
        badge.style.padding = "4px 6px";
        badge.style.background = "rgba(0,0,0,0.78)";
        badge.style.color = "#fff";
        badge.style.font = "11px/1.2 monospace";
        badge.style.borderRadius = "4px";
        badge.style.pointerEvents = "none";
        badge.style.whiteSpace = "pre-wrap";
        card.appendChild(badge);
      }

      badge.textContent = [
        "behavior=" + String(textBehavior || ""),
        "applied=" + applied,
        "scale=" + scale,
        "avail=" + available,
        "natural=" + natural
      ].join(" ");
    } catch (_) { }
  }

  function optimizedShopifySwatchUrl(url, targetWidth) {
    const raw = String(url || "").trim();
    const widthNum = Math.max(1, Math.round(Number(targetWidth) || 0));
    if (!raw) return raw;
    if (!widthNum) return raw;
    if (!/cdn\.shopify\.com/i.test(raw)) return raw;
    try {
      const absolute = raw.startsWith("//") ? ("https:" + raw) : raw;
      const u = new URL(absolute);
      u.searchParams.set("width", String(widthNum));
      const out = u.toString().replace(/^https:/, "");
      return raw.startsWith("//") ? out : out;
    } catch (_) {
      if (/([?&])width=\d+/i.test(raw)) return raw.replace(/([?&])width=\d+/i, "$1width=" + String(widthNum));
      return raw + (raw.includes("?") ? "&" : "?") + "width=" + String(widthNum);
    }
  }

  function currentSwatchRequestWidth(card, slot, imgWrap) {
    const sources = [
      imgWrap && imgWrap.getBoundingClientRect ? imgWrap.getBoundingClientRect().width : 0,
      slot && slot.getBoundingClientRect ? slot.getBoundingClientRect().width : 0,
      card && card.getBoundingClientRect ? card.getBoundingClientRect().width : 0,
      imgWrap && imgWrap.clientWidth ? imgWrap.clientWidth : 0,
      slot && slot.clientWidth ? slot.clientWidth : 0,
      card && card.clientWidth ? card.clientWidth : 0
    ];
    const width = sources.find((v) => Number(v) > 0) || 150;
    // cap swatch image requests to 400px to avoid huge CDN widths
    const capped = Math.min(Number(width) || 0, 400);
    return Math.max(1, Math.round(capped || 150));
  }

  function cappedShopifyImageUrl(url, maxWidth = 2400, fallbackWidth = 400) {
    const raw = String(url || "").trim();
    if (!raw) return raw;
    try {
      const absolute = raw.startsWith("//") ? ("https:" + raw) : raw;
      const u = new URL(absolute);
      if (!/cdn\.shopify\.com/i.test(u.hostname || "")) return raw;
      const existingWidth = Number(u.searchParams.get("width") || 0);
      const targetWidth = existingWidth > 0
        ? Math.min(Math.max(1, Math.round(existingWidth)), maxWidth)
        : Math.min(Math.max(1, Math.round(fallbackWidth)), maxWidth);
      u.searchParams.set("width", String(targetWidth));
      const out = u.toString().replace(/^https:/, "");
      return raw.startsWith("//") ? out : out;
    } catch (_) {
      if (/([?&])width=\d+/i.test(raw)) {
        return raw.replace(/([?&])width=(\d+)/i, (_, prefix, width) => {
          const targetWidth = Math.min(Math.max(1, Number(width) || fallbackWidth), maxWidth);
          return prefix + "width=" + String(targetWidth);
        });
      }
      return optimizedShopifySwatchUrl(raw, Math.min(Math.max(1, fallbackWidth), maxWidth));
    }
  }

  function plainTextFromMaybeHtml(value) {
    try {
      const tpl = document.createElement("template");
      tpl.innerHTML = String(value || "");
      return collapseWhitespace(tpl.content.textContent || "");
    } catch (_) {
      return collapseWhitespace(String(value || "").replace(/<[^>]*>/g, " "));
    }
  }

  function isTrueLike(raw) {
    if (raw === true) return true;
    const s = String(raw == null ? "" : raw).trim().toLowerCase();
    return s === "true" || s === "1" || s === "yes" || s === "on";
  }

  function clampNumber(raw, min, max, fallback) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return fallback;
    return Math.max(min, Math.min(max, n));
  }

  function clampImageZoomPct(raw, fallback = 100) {
    return Math.round(clampNumber(raw, 1, 600, fallback));
  }

  function normalizePresetButtonStyle(raw, fallback = "dropdown_box") {
    const base = String(fallback || "dropdown_box").trim().toLowerCase();
    const s = String(raw || "").trim().toLowerCase();
    if (!s) return base;
    const compact = s.replace(/[\s/_-]+/g, "");
    if (compact === "swatch" || compact === "swatchbutton") return "swatch";
    if (compact === "buttonprimary" || compact === "primarybutton" || compact === "primary") return "button_primary";
    if (compact === "buttonsecondary" || compact === "secondarybutton" || compact === "secondary") return "button_secondary";
    if (compact === "button" || compact === "pill") return "button_primary";
    if (compact === "productimagebutton" || compact === "productimage") return "product_image_button";
    if (compact === "imagebutton" || compact === "image" || compact === "imagecard" || compact === "defaultbutton") return "image_button";
    return "dropdown_box";
  }

  function normalizePresetButtonWidthPercent(raw, fallback = 0) {
    return clampNumber(raw, 0, 100, fallback);
  }

  function normalizeBackgroundImageStyle(raw, fallback = "center") {
    const s = String(raw || "").trim().toLowerCase();
    if (s === "stretch_to_fit" || s === "stretch") return "stretch_to_fit";
    if (s === "full_width" || s === "width") return "full_width";
    if (s === "full_height" || s === "height") return "full_height";
    return "center";
  }

  function normalizeBorderScope(raw, fallback = "image") {
    const s = String(raw || "").trim().toLowerCase();
    return s === "image_text" ? "image_text" : (fallback === "image_text" ? "image_text" : "image");
  }

  function normalizeSwatchAppearance(raw, fallbackScope = "image") {
    const obj = raw && typeof raw === "object" ? raw : {};
    const color = collapseWhitespace(obj.border_color ?? obj.borderColor ?? "#000000") || "#000000";
    const bgColor = collapseWhitespace(obj.background_color ?? obj.backgroundColor ?? "") || "transparent";
    return {
      gradient_color: collapseWhitespace(obj.gradient_color ?? obj.gradientColor ?? ""),
      gradient_angle: clampNumber(obj.gradient_angle ?? obj.gradientAngle, 0, 360, 180),
      border_color: color,
      border_size: clampNumber(obj.border_size ?? obj.borderSize, 0, 20, 2),
      background_color: bgColor || "transparent",
      background_image: safeSrc(obj.background_image ?? obj.backgroundImage ?? ""),
      background_image_style: normalizeBackgroundImageStyle(obj.background_image_style ?? obj.backgroundImageStyle, "center"),
      product_image_padding: clampNumber(obj.product_image_padding ?? obj.productImagePadding, 0, 6, 0),
      border_scope: normalizeBorderScope(obj.border_scope ?? obj.borderScope, fallbackScope),
      shadow_size: clampNumber(obj.shadow_size ?? obj.shadowSize, 0, 60, 0),
      border_radius_px: clampNumber(obj.border_radius_px ?? obj.borderRadiusPx ?? obj.corner_radius_px ?? obj.cornerRadiusPx, 0, 240, 12),
      image_radius_px: clampNumber(obj.image_radius_px ?? obj.imageRadiusPx ?? obj.corner_radius_px ?? obj.cornerRadiusPx, 0, 240, 12),
      text_behavior: String(obj.text_behavior ?? obj.textBehavior ?? "wrap_text").trim().toLowerCase() || "wrap_text",
      text_color: collapseWhitespace(obj.text_color ?? obj.textColor ?? "") || "",
      text_size_mobile: clampNumber(obj.text_size_mobile ?? obj.textSizeMobile, 0, 48, 0),
      text_size_desktop: clampNumber(obj.text_size_desktop ?? obj.textSizeDesktop, 0, 48, 0),
      text_style: String(obj.text_style ?? obj.textStyle ?? "").trim().toLowerCase()
    };
  }

  function applyPresetButtonTextFit(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(".mgps-preset-btn__label").forEach((labelEl) => {
      try {
        unwrapFittedTextInner(labelEl);
        setStyleImportant(labelEl, "display", "block");
        setStyleImportant(labelEl, "width", "");
        setStyleImportant(labelEl, "max-width", "");
        setStyleImportant(labelEl, "margin", "");
        setStyleImportant(labelEl, "white-space", "");
        setStyleImportant(labelEl, "overflow", "");
        setStyleImportant(labelEl, "text-overflow", "");
        setStyleImportant(labelEl, "transform", "none");
        setStyleImportant(labelEl, "transform-origin", "");
        setStyleImportant(labelEl, "font-size", "");
        setStyleImportant(labelEl, "line-height", "");
        setStyleImportant(labelEl, "letter-spacing", "");
        try {
          delete labelEl.dataset.mgpsPresetFitScale;
          delete labelEl.dataset.mgpsBaseFontSize;
          delete labelEl.dataset.mgpsBaseLineHeight;
        } catch (_) { }
        updatePresetFitDebug(labelEl, null);
      } catch (_) { }
    });
  }

  function isDebugAppearanceEnabled() {
    return mgpsDebugFlags.appearance;
  }

  function isDebugPresetFitEnabled() {
    return mgpsDebugFlags.presetFit;
  }

  function updatePresetFitDebug(labelEl, values) {
    if (!labelEl || !labelEl.parentElement) return;
    try {
      let badge = labelEl.parentElement.querySelector(':scope > .mgps-debug-preset-fit');
      if (!isDebugPresetFitEnabled()) {
        if (badge) badge.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement("div");
        badge.className = "mgps-debug-preset-fit";
        badge.style.cssText = [
          "margin-top:4px",
          "font:600 10px/1.2 monospace",
          "color:#0f172a",
          "background:rgba(255,255,0,.18)",
          "border:1px solid rgba(15,23,42,.18)",
          "border-radius:6px",
          "padding:4px 6px",
          "white-space:normal",
          "word-break:break-word"
        ].join(";");
        labelEl.parentElement.appendChild(badge);
      }
      const natural = Math.round(Number(values && values.naturalWidth || 0) || 0);
      const available = Math.round(Number(values && values.availableWidth || 0) || 0);
      const scale = Number(values && values.scale || 1).toFixed(3);
      const mobile = values && values.isMobile ? "mobile" : "desktop";
      const applied = values && values.applied ? "yes" : "no";
      badge.textContent = "preset-fit " + mobile + " natural=" + natural + " available=" + available + " scale=" + scale + " applied=" + applied;
    } catch (_) { }
  }

  function mountAppearanceDebugBadge(payload) {
    if (!isDebugAppearanceEnabled() || !document || !document.body) return;
    try {
      let host = document.getElementById("mgps-debug-appearance-host");
      if (!host) {
        host = document.createElement("div");
        host.id = "mgps-debug-appearance-host";
        host.style.position = "fixed";
        host.style.right = "12px";
        host.style.bottom = "12px";
        host.style.zIndex = "2147483647";
        host.style.display = "flex";
        host.style.flexDirection = "column";
        host.style.gap = "8px";
        host.style.maxWidth = "min(460px, calc(100vw - 24px))";
        host.style.pointerEvents = "none";
        document.body.appendChild(host);
      }
      const badgeId = "mgps-debug-appearance-badge-" + String(payload && payload.setName || "").replace(/[^a-z0-9_-]+/gi, "_");
      let badge = document.getElementById(badgeId);
      if (!badge) {
        badge = document.createElement("div");
        badge.id = badgeId;
        badge.style.padding = "10px 12px";
        badge.style.borderRadius = "10px";
        badge.style.background = "rgba(17,17,17,0.92)";
        badge.style.color = "#fff";
        badge.style.font = "12px/1.4 monospace";
        badge.style.whiteSpace = "pre-wrap";
        badge.style.boxShadow = "0 10px 30px rgba(0,0,0,0.35)";
        host.appendChild(badge);
      }
      const rootAppearance = payload && payload.rootAppearance || {};
      const rootSelectedAppearance = payload && payload.rootSelectedAppearance || {};
      badge.textContent = [
        "MGPS " + MGPS_DEBUG_BUILD,
        "set=" + String(payload && payload.setName || ""),
        "match=" + String(payload && payload.matchedSettingsKey || ""),
        "rootExplicit=" + String(!!(payload && payload.explicitRootAppearance)),
        "firstRowForceRoot=" + String(!!(payload && payload.firstRowForceRootAppearance)),
        "border=" + String(rootAppearance.border_color || ""),
        "bg=" + String(rootAppearance.background_color || ""),
        "shadow=" + String(rootAppearance.shadow_size ?? ""),
        "scope=" + String(rootAppearance.border_scope || ""),
        "selBorder=" + String(rootSelectedAppearance.border_color || "")
      ].join("\n");
    } catch (_) { }
  }

  function mergeSwatchAppearance(baseAppearance, overrideAppearance, fallbackScope = "image") {
    const base = baseAppearance && typeof baseAppearance === "object" ? baseAppearance : {};
    const over = overrideAppearance && typeof overrideAppearance === "object" ? overrideAppearance : {};
    const merged = Object.assign({}, base);
    [
      "border_color",
      "border_size",
      "shadow_size",
      "background_color",
      "background_image",
      "background_image_style",
      "product_image_padding",
      "border_scope",
      "border_radius_px",
      "image_radius_px",
      "gradient_color",
      "gradient_angle",
      "text_color",
      "text_behavior",
      "text_size_mobile",
      "text_size_desktop",
      "text_style"
    ].forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(over, key) && over[key] !== null && over[key] !== "") merged[key] = over[key];
    });
    return normalizeSwatchAppearance(merged, fallbackScope);
  }

function parseRootSwatchAppearance(root) {
  function safeParse(json) {
    try { return JSON.parse(json || "{}"); }
    catch (_) { return {}; }
  }

  function getAttr(name) {
    return (root.getAttribute(name) || "").trim();
  }

  function pick(obj, key, attrName, fallback) {
    // Priority: JSON → attribute → fallback
    if (obj && obj[key] !== undefined && obj[key] !== null && obj[key] !== "") {
      return obj[key];
    }
    const attr = getAttr(attrName);
    if (attr !== "") return attr;
    return fallback;
  }

  const jsonAppearance = safeParse(getAttr("data-mgps-appearance"));
  const jsonSelected = safeParse(getAttr("data-mgps-selected-appearance"));

  const appearance = {
    border_color: pick(jsonAppearance, "border_color", "data-mgps-border-color", "#000000"),
    border_size: Number(pick(jsonAppearance, "border_size", "data-mgps-border-size", 2)),
    shadow_size: Number(pick(jsonAppearance, "shadow_size", "data-mgps-shadow-size", 0)),
    background_color: pick(jsonAppearance, "background_color", "data-mgps-background-color", "transparent"),
    border_scope: pick(jsonAppearance, "border_scope", "data-mgps-border-scope", "image"),
    text_color: pick(jsonAppearance, "text_color", "data-mgps-text-color", ""),
    text_behavior: pick(jsonAppearance, "text_behavior", "data-mgps-text-behavior", "wrap_text"),
    text_size_mobile: Number(pick(jsonAppearance, "text_size_mobile", "data-mgps-text-size-mobile", 0)),
    text_size_desktop: Number(pick(jsonAppearance, "text_size_desktop", "data-mgps-text-size-desktop", 0)),
    border_radius_px: Number(pick(jsonAppearance, "border_radius_px", "data-mgps-border-radius", 12)),
    image_radius_px: Number(pick(jsonAppearance, "image_radius_px", "data-mgps-image-radius", 12)),
    product_image_padding: Number(pick(jsonAppearance, "product_image_padding", "data-mgps-product-image-padding", 0)),
    gradient_color: pick(jsonAppearance, "gradient_color", "", ""),
    gradient_angle: Number(pick(jsonAppearance, "gradient_angle", "", 180)),
    text_style: pick(jsonAppearance, "text_style", "data-mgps-text-style", "")
  };

  const selected = {
    border_color: pick(jsonSelected, "border_color", "data-mgps-selected-border-color", appearance.border_color),
    border_size: Number(pick(jsonSelected, "border_size", "data-mgps-selected-border-size", appearance.border_size)),
    shadow_size: Number(pick(jsonSelected, "shadow_size", "data-mgps-selected-shadow-size", appearance.shadow_size)),
    background_color: pick(jsonSelected, "background_color", "data-mgps-selected-background-color", appearance.background_color),
    border_scope: pick(jsonSelected, "border_scope", "data-mgps-selected-border-scope", appearance.border_scope),
    text_color: pick(jsonSelected, "text_color", "data-mgps-selected-text-color", appearance.text_color),
    text_behavior: pick(jsonSelected, "text_behavior", "", appearance.text_behavior),
    text_size_mobile: Number(pick(jsonSelected, "text_size_mobile", "data-mgps-selected-text-size-mobile", appearance.text_size_mobile)),
    text_size_desktop: Number(pick(jsonSelected, "text_size_desktop", "data-mgps-selected-text-size-desktop", appearance.text_size_desktop)),
    border_radius_px: Number(pick(jsonSelected, "border_radius_px", "data-mgps-selected-border-radius", appearance.border_radius_px)),
    image_radius_px: Number(pick(jsonSelected, "image_radius_px", "data-mgps-selected-image-radius", appearance.image_radius_px)),
    product_image_padding: Number(pick(jsonSelected, "product_image_padding", "data-mgps-selected-product-image-padding", appearance.product_image_padding)),
    gradient_color: pick(jsonSelected, "gradient_color", "", appearance.gradient_color),
    gradient_angle: Number(pick(jsonSelected, "gradient_angle", "", appearance.gradient_angle)),
    text_style: pick(jsonSelected, "text_style", "data-mgps-selected-text-style", appearance.text_style)
  };

  const cornerRadiusPx = Number(getAttr("data-mgps-corner-radius")) || appearance.border_radius_px || 12;

  return {
    appearance,
    selectedAppearance: selected,
    cornerRadiusPx
  };
}

  function resolvedRowAppearance(rowSpec, isSelected) {
    const forceRoot = !!(rowSpec && rowSpec.__forceRootAppearance);
    const forceRootBorder = !!(rowSpec && rowSpec.__forceRootBorderAppearance);
    const rootTextBehavior = String(rowSpec && rowSpec.__rootTextBehaviorOverride || "").trim().toLowerCase();
    const rootNormal = normalizeSwatchAppearance((rowSpec && rowSpec.__rootAppearance) || null, "image");
    const rootSelected = normalizeSwatchAppearance((rowSpec && rowSpec.__rootSelectedAppearance) || null, rootNormal.border_scope || "image");
    rootSelected.border_scope = rootSelected.border_scope || rootNormal.border_scope || "image";
    if (rootTextBehavior) {
      rootNormal.text_behavior = rootTextBehavior;
      rootSelected.text_behavior = rootTextBehavior;
    }

    if (forceRoot) return isSelected ? rootSelected : rootNormal;

    const rowNormalSource = (rowSpec && (rowSpec.__appearance ?? rowSpec.appearance)) || null;
    const rowSelectedSource = (rowSpec && (rowSpec.__selectedAppearance ?? rowSpec.selected_appearance)) || null;
    const mergedNormal = mergeSwatchAppearance(rootNormal, rowNormalSource, rootNormal.border_scope || "image");
    const mergedSelected = mergeSwatchAppearance(rootSelected, rowSelectedSource, mergedNormal.border_scope || "image");
    if (rootTextBehavior) {
      mergedNormal.text_behavior = rootTextBehavior;
      mergedSelected.text_behavior = rootTextBehavior;
    }
    if (forceRootBorder) {
      [
        "border_color",
        "border_size",
        "border_scope",
        "shadow_size",
        "border_radius_px",
        "image_radius_px"
      ].forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(rootNormal, key) && rootNormal[key] !== null && rootNormal[key] !== "") {
          mergedNormal[key] = rootNormal[key];
        }
        if (Object.prototype.hasOwnProperty.call(rootSelected, key) && rootSelected[key] !== null && rootSelected[key] !== "") {
          mergedSelected[key] = rootSelected[key];
        }
      });
    }
    mergedSelected.border_scope = mergedSelected.border_scope || mergedNormal.border_scope || "image";
    return isSelected ? mergedSelected : mergedNormal;
  }

  function resolvedRowCornerRadiusPx(rowSpec, fallback = 12) {
    const rootValue = Number(rowSpec && rowSpec.__rootCornerRadiusPx);
    if (Number.isFinite(rootValue) && rootValue >= 0) return rootValue;
    const rowValue = Number(rowSpec && (rowSpec.__cornerRadiusPx ?? rowSpec.corner_radius_px));
    return Number.isFinite(rowValue) && rowValue >= 0 ? rowValue : fallback;
  }

  function resolvedAppearanceBorderRadiusPx(appearance, rowSpec, fallback = 12) {
    const direct = Number(appearance && (appearance.border_radius_px ?? appearance.borderRadiusPx));
    if (Number.isFinite(direct) && direct >= 0) return direct;
    return resolvedRowCornerRadiusPx(rowSpec, fallback);
  }

  function resolvedAppearanceImageRadiusPx(appearance, rowSpec, fallback = 12) {
    const direct = Number(appearance && (appearance.image_radius_px ?? appearance.imageRadiusPx));
    if (Number.isFinite(direct) && direct >= 0) return direct;
    return resolvedAppearanceBorderRadiusPx(appearance, rowSpec, fallback);
  }


  function topLightShadowValue(shadowSize) {
    const s = clampNumber(shadowSize, 0, 60, 0);
    if (!s) return "none";

    const y = Math.max(2, Math.round(s * 0.55));
    const blurVal = Math.max(4, Math.round(s * 1.35));

    return `0 ${y}px ${blurVal}px rgba(128,128,128,0.45)`;
  }

  function applyAppearanceBackground(el, appearance) {
    if (!el || !appearance) return;

    const bgColor = appearance.background_color || "transparent";
    const gradientEnd = appearance.gradient_color || "";
    const angle = appearance.gradient_angle || 180;
    const bgImage = safeSrc(appearance.background_image || "");

    /* 🔥 PRIORITY ORDER:
       1. Image
       2. Gradient
       3. Solid color
    */

    if (bgImage) {
      setStyleImportant(el, "background-image", `url("${bgImage.replace(/"/g, '%22')}")`);
      setStyleImportant(el, "background-color", bgColor);
      setStyleImportant(el, "background-repeat", "no-repeat");
      setStyleImportant(el, "background-position", "center center");

      switch (appearance.background_image_style) {
        case "stretch_to_fit":
          setStyleImportant(el, "background-size", "100% 100%");
          break;
        case "full_width":
          setStyleImportant(el, "background-size", "100% auto");
          break;
        case "full_height":
          setStyleImportant(el, "background-size", "auto 100%");
          break;
        default:
          setStyleImportant(el, "background-size", "cover");
          break;
      }

      return; // ⛔ STOP HERE so gradient doesn't overwrite image
    }

    if (gradientEnd) {
      setStyleImportant(
        el,
        "background-image",
        `linear-gradient(${angle}deg, ${bgColor}, ${gradientEnd})`
      );
      setStyleImportant(el, "background-color", "transparent");
      return;
    }

    /* fallback */
    setStyleImportant(el, "background-color", bgColor);
    setStyleImportant(el, "background-image", "none");
  }

  function swatchCardRefs(card) {
    if (!card || !card.querySelector) return {};
    const cached = card.__mgpsRefs || {};
    const refs = {
      block: cached.block && cached.block.isConnected ? cached.block : card.querySelector(".mgps-thumb-block"),
      slot: cached.slot && cached.slot.isConnected ? cached.slot : card.querySelector(".mgps-thumb-slot"),
      imgWrap: cached.imgWrap && cached.imgWrap.isConnected ? cached.imgWrap : card.querySelector(".mgps-img-wrap"),
      imgInner: cached.imgInner && cached.imgInner.isConnected ? cached.imgInner : card.querySelector(".mgps-img-inner"),
      bottom: cached.bottom && cached.bottom.isConnected ? cached.bottom : card.querySelector(".mgps-card-bottom"),
      title: cached.title && cached.title.isConnected ? cached.title : card.querySelector(".mgps-title"),
      price: cached.price && cached.price.isConnected ? cached.price : card.querySelector(".mgps-price"),
      img: cached.img && cached.img.isConnected ? cached.img : card.querySelector(".mgps-img-wrap img")
    };
    card.__mgpsRefs = refs;
    return refs;
  }

  function applySwatchAppearance(card, block, slot, imgWrap, bottom, img, rowSpec, isSelected) {
    const appearance = resolvedRowAppearance(rowSpec, isSelected);
    const borderScope = normalizeBorderScope(appearance.border_scope, "image");
    const borderRadius = resolvedAppearanceBorderRadiusPx(appearance, rowSpec, 12);
    const imageRadius = resolvedAppearanceImageRadiusPx(appearance, rowSpec, 12);
    const borderSize = clampNumber(appearance.border_size, 0, 24, 2);
    const borderColor = collapseWhitespace(appearance.border_color || "#000000") || "#000000";
    const pad = clampNumber(appearance.product_image_padding, 0, 24, 0);
    const imgInner = imgWrap && imgWrap.querySelector ? imgWrap.querySelector(".mgps-img-inner") : null;

    try {
      [card, block, slot, imgWrap, imgInner, bottom].forEach((el) => {
        if (!el) return;
        setStyleImportant(el, "background", "transparent");
        setStyleImportant(el, "background-color", "transparent");
        setStyleImportant(el, "background-image", "none");
        setStyleImportant(el, "box-shadow", "none");
        setStyleImportant(el, "border", "0");
      });

      setStyleImportant(block, "display", "block");
      setStyleImportant(block, "width", "100%");
      setStyleImportant(block, "height", "100%");
      setStyleImportant(block, "padding", "0");
      setStyleImportant(block, "margin", "0");
      setStyleImportant(block, "box-sizing", "border-box");
      const shadowSize = clampNumber(appearance.shadow_size, 0, 60, 0);

      const shadowValue = topLightShadowValue(shadowSize);
      setStyleImportant(block, "overflow", borderScope === "image_text" ? "hidden" : "visible");
      setStyleImportant(block, "border-radius", borderScope === "image_text" ? (borderRadius + "px") : "0");
      if (borderScope === "image_text") {
        setStyleImportant(block, "border", borderSize + "px solid " + borderColor);
        setStyleImportant(block, "box-shadow", shadowValue);
        setStyleImportant(block, "filter", "none");
        applyAppearanceBackground(block, appearance);
      } else {
        setStyleImportant(block, "box-shadow", "none");
        setStyleImportant(block, "filter", "none");
      }

      setStyleImportant(slot, "display", "flex");
      setStyleImportant(slot, "position", "relative");
      setStyleImportant(slot, "width", "100%");
      setStyleImportant(slot, "min-width", "0");
      setStyleImportant(slot, "align-items", "stretch");
      setStyleImportant(slot, "justify-content", "center");
      setStyleImportant(slot, "box-sizing", "border-box");
      setStyleImportant(slot, "overflow", "hidden");
      setStyleImportant(slot, "border-radius", imageRadius + "px");
      if (borderScope === "image") {
        setStyleImportant(slot, "border", borderSize + "px solid " + borderColor);
        setStyleImportant(slot, "box-shadow", shadowValue);
        setStyleImportant(slot, "filter", "none");
        applyAppearanceBackground(slot, appearance);
      } else {
        setStyleImportant(slot, "box-shadow", "none");
        setStyleImportant(slot, "filter", "none");
      }

      setStyleImportant(imgWrap, "padding", pad + "px");
      setStyleImportant(imgWrap, "position", "relative");
      setStyleImportant(imgWrap, "z-index", "1");
      try { imgWrap.style.setProperty("--mgps-image-pad", pad + "px"); } catch (_) { }
      setStyleImportant(imgWrap, "box-sizing", "border-box");
      setStyleImportant(imgWrap, "border-radius", imageRadius + "px");
      setStyleImportant(imgWrap, "overflow", "visible");
      setStyleImportant(imgWrap, "background", "transparent");
      if (imgInner) {
        setStyleImportant(imgInner, "position", "relative");
        setStyleImportant(imgInner, "z-index", "1");
        setStyleImportant(imgInner, "width", "100%");
        setStyleImportant(imgInner, "height", "100%");
        setStyleImportant(imgInner, "min-width", "0");
        setStyleImportant(imgInner, "min-height", "0");
        setStyleImportant(imgInner, "overflow", "hidden");
        setStyleImportant(imgInner, "border-radius", imageRadius + "px");
        setStyleImportant(imgInner, "box-sizing", "border-box");
      }
      setStyleImportant(bottom, "display", "flex");
      setStyleImportant(bottom, "position", "relative");
      setStyleImportant(bottom, "z-index", "1");
      setStyleImportant(bottom, "flex-direction", "column");
      setStyleImportant(bottom, "align-items", "center");
      setStyleImportant(bottom, "justify-content", "center");
      setStyleImportant(bottom, "text-align", "center");
      setStyleImportant(bottom, "background", "transparent");
      setStyleImportant(bottom, "margin-top", "4px");
      setStyleImportant(bottom, "padding", "8px 8px 10px");

      const textColor = collapseWhitespace(appearance.text_color || "");
      const textStyle = String(appearance.text_style || "normal").trim().toLowerCase() || "normal";
      const titleEl = bottom && bottom.querySelector ? bottom.querySelector(".mgps-title") : null;
      const priceEl = bottom && bottom.querySelector ? bottom.querySelector(".mgps-price") : null;
      [titleEl, priceEl].forEach((el) => {
        if (!el) return;

        /* RESET HARD (override theme CSS) */
        setStyleImportant(el, "display", "block");
        setStyleImportant(el, "font-style", "normal");
        setStyleImportant(el, "text-decoration", "none");
        setStyleImportant(el, "text-shadow", "none");
        setStyleImportant(el, "font-weight", "700");
        setStyleImportant(el, "color", textColor || "");

        /* APPLY STYLE */
        if (textStyle.includes("italic")) {
          setStyleImportant(el, "font-style", "italic");
        }

        if (textStyle.includes("underline")) {
          setStyleImportant(el, "text-decoration", "underline");
        }
      });
      const textBehavior = String(appearance.text_behavior || "wrap_text").trim().toLowerCase();
      if (titleEl) {
        if (textBehavior === "truncate_text" || textBehavior === "squeeze_text") {
          setStyleImportant(titleEl, "display", "block");
          setStyleImportant(titleEl, "white-space", "nowrap");
          setStyleImportant(titleEl, "overflow", textBehavior === "truncate_text" ? "hidden" : "visible");
          setStyleImportant(titleEl, "text-overflow", textBehavior === "truncate_text" ? "ellipsis" : "clip");
          setStyleImportant(titleEl, "-webkit-line-clamp", "unset");
          setStyleImportant(titleEl, "line-clamp", "unset");
          setStyleImportant(titleEl, "word-break", "normal");
          setStyleImportant(titleEl, "overflow-wrap", "normal");
          setStyleImportant(titleEl, "align-self", "center");
          setStyleImportant(titleEl, "text-align", "center");
          if (textBehavior === "squeeze_text") {
            setStyleImportant(titleEl, "width", "100%");
            setStyleImportant(titleEl, "max-width", "100%");
            setStyleImportant(titleEl, "margin", "0");
          }
        } else {
          setStyleImportant(titleEl, "display", "block");
          setStyleImportant(titleEl, "white-space", "normal");
          setStyleImportant(titleEl, "overflow", "visible");
          setStyleImportant(titleEl, "text-overflow", "clip");
          setStyleImportant(titleEl, "-webkit-line-clamp", "unset");
          setStyleImportant(titleEl, "line-clamp", "unset");
          setStyleImportant(titleEl, "word-break", "normal");
          setStyleImportant(titleEl, "overflow-wrap", "break-word");
          setStyleImportant(titleEl, "align-self", "center");
          setStyleImportant(titleEl, "text-align", "center");
        }
      }
      if (priceEl) {
        setStyleImportant(priceEl, "white-space", "nowrap");
        setStyleImportant(priceEl, "overflow", "hidden");
        setStyleImportant(priceEl, "text-overflow", textBehavior === "truncate_text" ? "ellipsis" : "clip");
      }
      updateTextFitDebugCard(card, textBehavior);

      if (img) {
        const zoomScale = clampImageZoomPct(
          resolvedSwatchZoomPct(card && card.__mgpsMeta ? card.__mgpsMeta : null, 100),
          100
        ) / 100;
        const imageSizePct = clampNumber(
          swatchImageSizePct(card && card.__mgpsMeta ? card.__mgpsMeta : null, 100),
          1,
          100,
          100
        );
        const imageSizeScale = imageSizePct / 100;
        const effectiveScale = Math.max(0.01, zoomScale * imageSizeScale);
        setStyleImportant(img, "position", "relative");
        setStyleImportant(img, "z-index", "2");
        setStyleImportant(img, "border-radius", imageRadius + "px");
        try { img.style.setProperty("--mgps-product-image-size", imageSizePct + "%"); } catch (_) { }
        if (card.dataset.scaleFill === "true") {
          setStyleImportant(img, "top", "0");
          setStyleImportant(img, "right", "0");
          setStyleImportant(img, "bottom", "0");
          setStyleImportant(img, "left", "0");
          setStyleImportant(img, "width", "100%");
          setStyleImportant(img, "height", "100%");
          setStyleImportant(img, "min-width", "100%");
          setStyleImportant(img, "min-height", "100%");
        } else {
          setStyleImportant(img, "width", "100%");
          setStyleImportant(img, "max-width", "100%");
          setStyleImportant(img, "height", "auto");
          setStyleImportant(img, "min-width", "0");
          setStyleImportant(img, "min-height", "0");
          setStyleImportant(img, "transform", "scale(" + zoomScale + ")");
          setStyleImportant(img, "transform-origin", "center bottom");
        }
      }
    } catch (_) { }
  }

  function parsePixelValue(raw, fallback = 0, max = 2400) {
    if (typeof raw === "number" && Number.isFinite(raw)) return Math.max(0, Math.min(max, Math.round(raw)));
    const s = String(raw == null ? "" : raw).trim();
    if (!s) return fallback;
    const match = s.match(/-?\d+(?:\.\d+)?/);
    if (!match) return fallback;
    const n = Number(match[0]);
    if (!Number.isFinite(n)) return fallback;
    return Math.max(0, Math.min(max, Math.round(n)));
  }

  function parseImgRatio(raw) {
    const s = String(raw || "1:1").trim();
    const m = s.match(/^(\d+(?:\.\d+)?)\s*[:/]\s*(\d+(?:\.\d+)?)$/);
    if (!m) return { w: 1, h: 1 };
    const w = Number(m[1]);
    const h = Number(m[2]);
    if (!(w > 0) || !(h > 0)) return { w: 1, h: 1 };
    return { w, h };
  }


  function currentRowHeight(rowEl) {
    if (!rowEl) return 0;
    const mobile = Math.max(0, Number(rowEl.dataset.rowHeightMobile || 0) || 0);
    const desktop = Math.max(0, Number(rowEl.dataset.rowHeightDesktop || rowEl.dataset.rowHeight || 0) || 0);
    return window.innerWidth <= 768 ? (mobile || desktop || 0) : (desktop || 0);
  }

  function currentPaddingBetweenRows(rowEl) {
    if (!rowEl) return 0;
    const mobile = Math.max(0, Number(rowEl.dataset.paddingBetweenRowsMobile || 0) || 0);
    const desktop = Math.max(0, Number(rowEl.dataset.paddingBetweenRowsDesktop || rowEl.dataset.paddingBetweenRows || 0) || 0);
    return window.innerWidth <= 768 ? (mobile || desktop || 0) : (desktop || 0);
  }

  function currentRowHeightFromSpec(rowSpec) {
    const mobile = Math.max(0, Number((rowSpec && rowSpec.row_height_mobile) || 0) || 0);
    const desktop = Math.max(0, Number((rowSpec && (rowSpec.row_height_desktop ?? rowSpec.row_height)) || 0) || 0);
    return window.innerWidth <= 768 ? (mobile || desktop || 0) : (desktop || 0);
  }

  function currentRowDisplayType(rowEl) {
    if (!rowEl) return "scale_to_fit";
    const desktop = String(rowEl.dataset.rowDisplayTypeDesktop || rowEl.dataset.rowDisplayType || "scale_to_fit").trim().toLowerCase() || "scale_to_fit";
    const mobile = String(rowEl.dataset.rowDisplayTypeMobile || desktop).trim().toLowerCase() || desktop;
    return window.innerWidth <= 768 ? mobile : desktop;
  }

  function applyRowTextSizing(rowEl) {
    if (!rowEl) return;
    const rowHeight = currentRowHeight(rowEl);
    const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb"));
    let minCardWidth = 0;
    cards.forEach((card) => {
      const w = Math.round(card.getBoundingClientRect().width || card.clientWidth || 0);
      if (w > 0 && (!minCardWidth || w < minCardWidth)) minCardWidth = w;
    });
    const sizeBasis = minCardWidth || rowHeight || 0;
    const rowSpec = rowEl.__rowSpec || {};
    const appearance = resolvedRowAppearance(rowSpec, false) || {};
    const customTitleSize = window.innerWidth <= 768
      ? Math.max(0, Number(appearance.text_size_mobile || 0) || 0)
      : Math.max(0, Number(appearance.text_size_desktop || 0) || 0);

    let titleSize = 11;
    let priceSize = 10;
    let lineHeight = 1.06;
    let paddingY = 3;
    let priceMarginTop = 1;

    if (customTitleSize > 0) {
      titleSize = customTitleSize;
      priceSize = Math.max(6, customTitleSize - 1);
      lineHeight = 1.1;
      paddingY = 3;
      priceMarginTop = 2;
    } else if (sizeBasis > 0) {
      titleSize = Math.max(7, Math.min(18, Math.round(sizeBasis * 0.12)));
      priceSize = Math.max(6, Math.min(14, Math.round(sizeBasis * 0.095)));
      if (sizeBasis <= 72) {
        lineHeight = 1.0;
        paddingY = 1;
        priceMarginTop = 0;
      } else if (sizeBasis <= 110) {
        lineHeight = 1.02;
        paddingY = 2;
        priceMarginTop = 1;
      } else {
        lineHeight = 1.06;
        paddingY = 3;
        priceMarginTop = 1;
      }
    }

    try {
      rowEl.style.setProperty("--mgps-title-size", titleSize + "px");
      rowEl.style.setProperty("--mgps-price-size", priceSize + "px");
      rowEl.style.setProperty("--mgps-text-line-height", String(lineHeight));
      rowEl.style.setProperty("--mgps-card-bottom-padding-y", paddingY + "px");
      rowEl.style.setProperty("--mgps-price-margin-top", priceMarginTop + "px");
      if (minCardWidth > 0) rowEl.style.setProperty("--mgps-card-width", minCardWidth + "px");
    } catch (_) { }

    cards.forEach((card) => {
      const refs = swatchCardRefs(card);
      const titleEl = refs.title;
      const priceEl = refs.price;
      const isSelected = String(card.dataset.currentProduct || "") === "true";
      const appearanceForCard = resolvedRowAppearance(rowSpec, isSelected) || {};
      const squeezeText = String(appearanceForCard.text_behavior || "wrap_text").trim().toLowerCase() === "squeeze_text";
      if (titleEl) {
        setStyleImportant(titleEl, "font-size", titleSize + "px");
        setStyleImportant(titleEl, "line-height", String(lineHeight));
        setStyleImportant(titleEl, "font-weight", "700");
        try {
          titleEl.dataset.mgpsBaseFontSize = titleSize + "px";
          titleEl.dataset.mgpsBaseLineHeight = String(lineHeight);
        } catch (_) { }
        applySqueezedTextFit(titleEl, squeezeText);
      }
      if (priceEl) {
        setStyleImportant(priceEl, "font-size", priceSize + "px");
        setStyleImportant(priceEl, "line-height", String(lineHeight));
        setStyleImportant(priceEl, "font-weight", "700");
        setStyleImportant(priceEl, "margin-top", priceMarginTop + "px");
        try {
          priceEl.dataset.mgpsBaseFontSize = priceSize + "px";
          priceEl.dataset.mgpsBaseLineHeight = String(lineHeight);
        } catch (_) { }
        applySqueezedTextFit(priceEl, squeezeText);
      }
    });
  }

  function safeSrc(raw) {
    const s = String(raw || "").trim();
    if (!s) return "";
    if (/^\/\//.test(s)) return window.location.protocol + s;
    if (/^data:image\//i.test(s)) return s;
    try {
      const u = new URL(s, window.location.href);
      if (u.protocol === "http:" || u.protocol === "https:") {
        if (/cdn\.shopify\.com/i.test(u.hostname || "")) return cappedShopifyImageUrl(u.href, 2400, 400);
        return u.href;
      }
      return "";
    } catch (_) {
      return "";
    }
  }

  // Ensure any image `src` set on the page that points at Shopify CDN is capped reasonably without forcing it down to 400px
  ;(function enforceCappedShopifyImageSrc(){
    try {
      const desc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
      if (!desc || !desc.configurable) return;
      Object.defineProperty(HTMLImageElement.prototype, 'src', {
        get: function() { return desc.get.call(this); },
        set: function(val) {
          try {
            const s = String(val || '').trim();
            if (s && !/^data:/i.test(s) && /cdn\.shopify\.com/i.test(s)) {
              try {
                const newUrl = cappedShopifyImageUrl(s, 2400, 400);
                return desc.set.call(this, newUrl);
              } catch (_) {}
            }
          } catch (_) {}
          return desc.set.call(this, val);
        },
        configurable: true,
        enumerable: desc.enumerable
      });
    } catch (_) {}
  })();

  function safeLink(raw) {
    const s = String(raw || "").trim();
    if (!s) return "";

    if (/^shopify:\/\//i.test(s)) {
      const path = "/" + s.replace(/^shopify:\/\//i, "").replace(/^\/+/, "");
      try { return new URL(path, window.location.origin).href; } catch (_) { return ""; }
    }

    if (/^\//.test(s) && !/^\/\//.test(s)) {
      try { return new URL(s, window.location.origin).href; } catch (_) { return ""; }
    }

    try {
      const u = new URL(s, window.location.href);
      const allowed = ["http:", "https:", "mailto:", "tel:", "sms:"];
      return allowed.includes(u.protocol) ? u.href : "";
    } catch (_) {
      return "";
    }
  }

  function normalizeComparablePath(raw) {
    try {
      const u = new URL(String(raw || ""), window.location.href);
      let p = String(u.pathname || "").trim() || "/";
      p = p.replace(/\/+/g, "/");
      if (p.length > 1) p = p.replace(/\/+$/, "");
      return p.toLowerCase();
    } catch (_) {
      return "";
    }
  }

  function currentStorefrontProductPath() {
    return normalizeComparablePath(window.location.href);
  }

  function currentStorefrontVariantId() {
    try {
      const params = new URLSearchParams(window.location.search || "");
      const fromUrl = String(params.get("variant") || "").trim();
      if (fromUrl) return fromUrl;
    } catch (_) { }
    try {
      const variantsEl = document.querySelector("product-variants[form-id]");
      const fromVariantsEl = variantsEl && variantsEl.selectedVariant
        ? String(variantsEl.selectedVariant.id || "").trim()
        : "";
      if (fromVariantsEl) return fromVariantsEl;
    } catch (_) { }
    try {
      const variantsEl = document.querySelector("product-variants[form-id]");
      const masterSelector = variantsEl && variantsEl.masterSelector;
      const fromMasterSelector = masterSelector ? String(masterSelector.value || "").trim() : "";
      if (fromMasterSelector) return fromMasterSelector;
    } catch (_) { }
    try {
      const input = document.querySelector('form[is="product-form"] [name="id"], form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="variant"], [data-product-form] [name="id"], [data-product-form] [name="variant"]');
      const value = input ? String(input.value || "").trim() : "";
      if (value) return value;
    } catch (_) { }
    return "";
  }

  function productJsonUrlFromMeta(meta) {
    const href = safeLink(meta?.product_url) || safeLink(meta?.cta?.href) || "";
    if (!href) return "";
    try {
      const url = new URL(href, window.location.href);
      url.search = "";
      url.hash = "";
      const path = String(url.pathname || "").replace(/\/+$/, "");
      if (!path) return "";
      return path + ".js";
    } catch (_) {
      return "";
    }
  }

  async function fetchProductJson(meta) {
    const url = productJsonUrlFromMeta(meta);
    if (!url) return null;
    R.__productJsonCache = R.__productJsonCache || Object.create(null);
    if (R.__productJsonCache[url]) return R.__productJsonCache[url];
    R.__productJsonCache[url] = fetch(url, { credentials: "same-origin" })
      .then((res) => res.ok ? res.json() : null)
      .catch(() => null);
    return R.__productJsonCache[url];
  }

  function formatMoneyCents(cents) {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return "";
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        const fmt = window.Shopify.money_format || "${{amount}}";
        return String(window.Shopify.formatMoney(amount, fmt) || "").trim();
      }
    } catch (_) { }
    try {
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";
      const lang = document.documentElement.lang || navigator.language || "en-US";
      return new Intl.NumberFormat(lang, { style: "currency", currency }).format(amount / 100);
    } catch (_) {
      return "$" + (amount / 100).toFixed(2);
    }
  }

  async function hydrateSwatchPrice(priceEl, meta) {
    if (!priceEl || !meta) return;
    if (!isTrueLike(meta?.show_price)) {
      try {
        priceEl.hidden = true;
      } catch (_) { }
      return;
    }
    const product = await fetchProductJson(meta);
    if (!product || typeof product !== "object") return;
    const cents = Number(product.price);
    if (!Number.isFinite(cents)) return;
    const text = formatMoneyCents(cents);
    if (!text) return;
    try {
      priceEl.textContent = text;
      priceEl.hidden = false;
    } catch (_) { }
  }

  function swatchTargetsCurrentProductOnRender(meta) {
    const targetHref = safeLink(meta?.product_url) || safeLink(meta?.cta?.href) || "";
    if (!targetHref) return false;

    const targetPath = normalizeComparablePath(targetHref);
    const currentPath = currentStorefrontProductPath();
    if (targetPath && currentPath && targetPath === currentPath) return true;

    const currentHandle = collapseWhitespace(
      currentStorefrontProductHandle()
      || currentStorefrontProductData()?.handle
      || ""
    ).toLowerCase();
    if (!currentHandle) return false;

    try {
      const url = new URL(targetHref, window.location.href);
      const match = String(url.pathname || "").match(/^\/products\/([^/?#]+)/i);
      const targetHandle = match ? collapseWhitespace(decodeURIComponent(match[1] || "")).toLowerCase() : "";
      return !!targetHandle && targetHandle === currentHandle;
    } catch (_) {
      return false;
    }
  }

  function isCurrentProductTarget(meta) {
    const targetHref = safeLink(meta?.product_url) || safeLink(meta?.cta?.href) || "";
    const targetPath = normalizeComparablePath(targetHref);
    const currentPath = currentStorefrontProductPath();
    if (!targetPath || !currentPath || targetPath !== currentPath) return false;

    const currentVariantId = currentStorefrontVariantId();
    const targetVariantId = String(
      meta?.product_variant_id
      ?? meta?.variant_id
      ?? ""
    ).trim();

    if (currentVariantId && targetVariantId) return currentVariantId === targetVariantId;
    if (!currentVariantId && targetVariantId) return false;
    if (currentVariantId && !targetVariantId) return false;
    return true;
  }

  function targetsCurrentProductVariant(meta) {
    const targetHref = safeLink(meta?.product_url) || safeLink(meta?.cta?.href) || "";
    const targetPath = normalizeComparablePath(targetHref);
    const currentPath = currentStorefrontProductPath();
    const targetVariantId = String(meta?.product_variant_id ?? meta?.variant_id ?? "").trim();
    if (!targetPath || !currentPath || targetPath !== currentPath) return false;
    return !!targetVariantId;
  }

  function findProductVariantsElementForMeta(meta, contextEl) {
    const handle = currentStorefrontProductHandle();
    const escapedHandle = (() => {
      try {
        return handle && typeof CSS !== "undefined" && CSS.escape ? CSS.escape(handle) : handle;
      } catch (_) {
        return handle;
      }
    })();
    const contextSection = contextEl && contextEl.closest ? contextEl.closest(".shopify-section") : null;
    const selectors = [];
    if (escapedHandle) selectors.push('product-variants[handle="' + escapedHandle + '"]');
    selectors.push("product-variants[form-id]");

    for (const selector of selectors) {
      try {
        if (contextSection && contextSection.querySelector) {
          const local = contextSection.querySelector(selector);
          if (local) return local;
        }
      } catch (_) { }
      try {
        const global = document.querySelector(selector);
        if (global) return global;
      } catch (_) { }
    }
    return null;
  }

  function stickyHeaderOffsetForScroll() {
    try {
      const storeHeader = document.querySelector("store-header");
      if (storeHeader) {
        const rect = storeHeader.getBoundingClientRect();
        if (rect && rect.height > 0) return Math.max(0, Math.round(rect.height));
      }
    } catch (_) { }
    return 0;
  }

  function scrollToProductPageTop() {
    try {
      const mainSection = currentMainProductSection(document);
      if (!mainSection) return false;
      const rect = mainSection.getBoundingClientRect();
      const targetTop = (window.pageYOffset || window.scrollY || 0) + rect.top - stickyHeaderOffsetForScroll();
      window.scrollTo({
        top: Math.max(0, Math.round(targetTop)),
        left: window.scrollX || window.pageXOffset || 0,
        behavior: "auto"
      });
      return true;
    } catch (_) {
      return false;
    }
  }

  function scrollToScreenTop() {
    try {
      window.scrollTo({
        top: 0,
        left: window.scrollX || window.pageXOffset || 0,
        behavior: "auto"
      });
      return true;
    } catch (_) {
      return false;
    }
  }

  function swatchSelectionScrollMode(contextEl) {
    try {
      return "screen_top";
    } catch (_) {
      return "screen_top";
    }
  }

  function currentViewportScrollPosition() {
    return {
      x: Math.max(0, window.scrollX || window.pageXOffset || 0),
      y: Math.max(0, window.scrollY || window.pageYOffset || 0)
    };
  }

  function rememberModalOpenScrollPosition(modal) {
    try {
      if (modal) modal.__openScrollPosition = currentViewportScrollPosition();
    } catch (_) { }
  }

  function modalOpenScrollPosition() {
    try {
      const position = R.__modal && R.__modal.__openScrollPosition;
      if (!position || typeof position !== "object") return null;
      return {
        x: Math.max(0, Number(position.x || 0) || 0),
        y: Math.max(0, Number(position.y || 0) || 0)
      };
    } catch (_) {
      return null;
    }
  }

  function pendingViewportScrollPositionStorageKey() {
    return "__mgps_pending_viewport_scroll_position";
  }

  function queuePendingViewportScrollPosition(position) {
    try {
      const source = position && typeof position === "object" ? position : {};
      window.sessionStorage.setItem(
        pendingViewportScrollPositionStorageKey(),
        JSON.stringify({
          x: source.x ?? window.scrollX ?? window.pageXOffset ?? 0,
          y: source.y ?? window.scrollY ?? window.pageYOffset ?? 0,
          createdAt: Date.now()
        })
      );
      return true;
    } catch (_) {
      return false;
    }
  }

  function consumePendingViewportScrollPosition() {
    try {
      const key = pendingViewportScrollPositionStorageKey();
      const raw = String(window.sessionStorage.getItem(key) || "").trim();
      if (raw) window.sessionStorage.removeItem(key);
      const parsed = raw ? safeJsonParse(raw) : null;
      if (!parsed || typeof parsed !== "object") return null;
      if (Date.now() - Number(parsed.createdAt || 0) > 30000) return null;
      return {
        x: Math.max(0, Number(parsed.x || 0) || 0),
        y: Math.max(0, Number(parsed.y || 0) || 0)
      };
    } catch (_) {
      return null;
    }
  }

  function restoreViewportScrollPosition(position) {
    if (!position || typeof position !== "object") return false;
    const target = {
      x: Math.max(0, Number(position.x || 0) || 0),
      y: Math.max(0, Number(position.y || 0) || 0)
    };
    const run = () => {
      try {
        window.scrollTo({
          top: target.y,
          left: target.x,
          behavior: "auto"
        });
        return true;
      } catch (_) {
        try { window.scrollTo(target.x, target.y); } catch (_) { }
        return true;
      }
    };
    try { run(); } catch (_) { }
    try { requestAnimationFrame(run); } catch (_) { }
    try { setTimeout(run, 0); } catch (_) { }
    try { setTimeout(run, 80); } catch (_) { }
    try { setTimeout(run, 220); } catch (_) { }
    try { setTimeout(run, 600); } catch (_) { }
    try { setTimeout(run, 1200); } catch (_) { }
    try { setTimeout(run, 3000); } catch (_) { }
    return true;
  }

  function applyPendingViewportScrollPosition() {
    const pendingPosition = consumePendingViewportScrollPosition();
    if (!pendingPosition) return false;
    return restoreViewportScrollPosition(pendingPosition);
  }

  function runSwatchSelectionScrollMode(mode) {
    const normalizedMode = String(mode || "").trim().toLowerCase();
    if (normalizedMode === "product_top") {
      return scrollToProductPageTop();
    }
    if (normalizedMode === "screen_top") {
      return scrollToScreenTop();
    }
    return false;
  }

  function preserveViewportScroll(callback) {
    if (typeof callback !== "function") return false;
    const scrollX = window.scrollX || window.pageXOffset || 0;
    const scrollY = window.scrollY || window.pageYOffset || 0;
    const restore = () => {
      try {
        window.scrollTo({ top: scrollY, left: scrollX, behavior: "auto" });
      } catch (_) {
        try { window.scrollTo(scrollX, scrollY); } catch (_) { }
      }
    };

    try {
      callback();
    } catch (_) {
      restore();
      return false;
    }

    restore();
    try { requestAnimationFrame(restore); } catch (_) { }
    try { setTimeout(restore, 0); } catch (_) { }
    try { setTimeout(restore, 80); } catch (_) { }
    try { setTimeout(restore, 220); } catch (_) { }
    return true;
  }

  function selectCurrentProductVariantFromSwatch(meta, contextEl, opts = {}) {
    try {
      const targetVariantId = Number(meta?.product_variant_id ?? meta?.variant_id ?? 0);
      if (!Number.isFinite(targetVariantId) || targetVariantId <= 0) return false;
      if (!targetsCurrentProductVariant(meta)) return false;
      freezeStableSlots(currentMainProductSection(contextEl) || document);
      const scrollMode = String(opts.scrollMode || "").trim().toLowerCase();

      const variantsEl = findProductVariantsElementForMeta(meta, contextEl);
      if (variantsEl && typeof variantsEl.selectVariant === "function") {
        if (scrollMode) {
          variantsEl.selectVariant(targetVariantId);
          try { requestAnimationFrame(() => runSwatchSelectionScrollMode(scrollMode)); } catch (_) { }
          return true;
        }
        return preserveViewportScroll(() => {
          variantsEl.selectVariant(targetVariantId);
        });
      }

      const formId = variantsEl && variantsEl.getAttribute ? String(variantsEl.getAttribute("form-id") || "").trim() : "";
      const form = formId ? document.getElementById(formId) : document.querySelector('form[is="product-form"]');
      const idInput = form && form.querySelector ? form.querySelector('[name="id"]') : null;
      if (idInput) {
        if (scrollMode) {
          idInput.value = String(targetVariantId);
          idInput.dispatchEvent(new Event("change", { bubbles: true }));
          try { requestAnimationFrame(() => runSwatchSelectionScrollMode(scrollMode)); } catch (_) { }
          return true;
        }
        return preserveViewportScroll(() => {
          idInput.value = String(targetVariantId);
          idInput.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }
    } catch (_) { }
    return false;
  }

  function swatchHrefForMeta(meta) {
    return safeLink(meta?.cta?.href) || safeLink(meta?.product_url) || safeLink(meta?.url) || "";
  }

  function swatchPresetSetKey(meta) {
    return collapseWhitespace(meta?.open_set_key || meta?.openSetKey || "");
  }

  function swatchPresetModalTitle(meta) {
    return plainTextFromMaybeHtml(
      meta?.open_set_modal_title
      || meta?.openSetModalTitle
      || meta?.open_set_label
      || meta?.openSetLabel
      || meta?.title
      || meta?.alt
      || swatchPresetSetKey(meta)
      || "Open item"
    ) || "Open item";
  }

  function swatchPresetHideHeader(meta) {
    return isTrueLike(meta?.open_set_hide_header ?? meta?.openSetHideHeader ?? false);
  }

  function preloadSwatchPresetSet(meta, rowSpec) {
    const presetSet = swatchPresetSetKey(meta);
    if (!presetSet) return;
    try {
      const preloadRows = resolveSet(presetSet, new Set());
      const preloadItems = normalizeItems(
        Array.isArray(preloadRows)
          ? preloadRows.flatMap((row) => rowItems(row))
          : [],
        { matchSettingsPresetKey: rowSpec && rowSpec.__rootMatchSettingsPresetKey }
      );
      queuePopupImagePreload(preloadItems);
    } catch (_) { }
  }

  function bindSwatchPresetInteraction(block, meta, rowSpec) {
    if (!block) return;
    block.__mgpsPresetMeta = meta || null;
    block.__mgpsPresetRowSpec = rowSpec || null;

    const presetSet = swatchPresetSetKey(meta);
    if (!presetSet) return;

    block.setAttribute("role", "button");
    block.setAttribute("tabindex", "0");
    block.setAttribute("aria-label", swatchPresetModalTitle(meta));
    block.style.cursor = "pointer";

    try { preloadSwatchPresetSet(meta, rowSpec); } catch (_) { }

    if (block.__mgpsPresetInteractionBound) return;
    block.__mgpsPresetInteractionBound = true;

    const openPreset = (event) => {
      const liveMeta = block.__mgpsPresetMeta || meta || {};
      const liveRowSpec = block.__mgpsPresetRowSpec || rowSpec || {};
      const liveSet = swatchPresetSetKey(liveMeta);
      if (!liveSet) return;
      try { event.preventDefault(); } catch (_) { }
      try { event.stopPropagation(); } catch (_) { }
      openPresetSet(liveSet, swatchPresetModalTitle(liveMeta), {
        hideHeader: swatchPresetHideHeader(liveMeta),
        appearance: liveRowSpec && (liveRowSpec.__rootAppearance || liveRowSpec.__appearance),
        selectedAppearance: liveRowSpec && (liveRowSpec.__rootSelectedAppearance || liveRowSpec.__selectedAppearance),
        cornerRadiusPx: liveRowSpec && (liveRowSpec.__rootCornerRadiusPx ?? liveRowSpec.__cornerRadiusPx),
        sourceBlockType: liveRowSpec && liveRowSpec.block_type
      });
    };

    block.addEventListener("click", openPreset);
    block.addEventListener("keydown", (event) => {
      const key = String(event && event.key || "");
      if (key === "Enter" || key === " ") openPreset(event);
    });
  }

  function swatchTargetsDifferentProductPage(href) {
    const targetPath = normalizeComparablePath(href);
    const currentPath = currentStorefrontProductPath();
    return !!targetPath && !!currentPath && targetPath !== currentPath;
  }

  function currentMainProductSection(contextEl) {
    try {
      const local = contextEl && contextEl.closest ? contextEl.closest(".shopify-section--main-product") : null;
      if (local) return local;
    } catch (_) { }
    try {
      return document.querySelector(".shopify-section--main-product");
    } catch (_) {
      return null;
    }
  }

  function stableSlotKey(el, index) {
    const key = collapseWhitespace(el && el.getAttribute ? el.getAttribute("data-mg-stable-slot") : "");
    return key || ("stable-slot-" + String(index || 0));
  }

  function measuredStableSlotHeight(el) {
    if (!el) return 0;
    try {
      const rectHeight = el.getBoundingClientRect ? Math.ceil(el.getBoundingClientRect().height || 0) : 0;
      const offsetHeight = Math.ceil(el.offsetHeight || 0);
      const computedMinHeight = window.getComputedStyle ? (parseFloat(window.getComputedStyle(el).minHeight || "0") || 0) : 0;
      const storedHeight = parseFloat(el.dataset.mgStableHeight || "0") || 0;
      return Math.max(0, rectHeight, offsetHeight, Math.ceil(computedMinHeight), Math.ceil(storedHeight));
    } catch (_) {
      return 0;
    }
  }

  function mergeStableSlotHeights(heights) {
    const input = heights && typeof heights === "object" ? heights : {};
    const cache = R.__stableSlotHeights || (R.__stableSlotHeights = Object.create(null));
    Object.keys(input).forEach((key) => {
      const nextHeight = Math.max(0, Math.ceil(Number(input[key]) || 0));
      if (nextHeight > (cache[key] || 0)) cache[key] = nextHeight;
    });
    return cache;
  }

  function collectStableSlotHeights(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const out = Object.create(null);
    if (!root || !root.querySelectorAll) return out;
    root.querySelectorAll("[data-mg-stable-slot]").forEach((el, index) => {
      const height = measuredStableSlotHeight(el);
      if (!(height > 0)) return;
      const key = stableSlotKey(el, index);
      out[key] = Math.max(out[key] || 0, height);
    });
    return out;
  }

  function applyStableSlotHeights(scope, heights) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const source = heights && typeof heights === "object" ? heights : {};
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll("[data-mg-stable-slot]").forEach((el, index) => {
      const key = stableSlotKey(el, index);
      const targetHeight = Math.max(
        0,
        Math.ceil(Number(source[key]) || 0),
        measuredStableSlotHeight(el)
      );
      if (!(targetHeight > 0)) return;
      setStyleImportant(el, "min-height", targetHeight + "px");
      try { el.dataset.mgStableHeight = String(targetHeight); } catch (_) { }
    });
  }

  function freezeStableSlots(scope) {
    const mergedHeights = mergeStableSlotHeights(collectStableSlotHeights(scope));
    applyStableSlotHeights(scope, mergedHeights);
    return mergedHeights;
  }

  function scheduleStableSlotRefresh(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    if (!root) return;
    try {
      if (root.__mgStableRefreshTimer) clearTimeout(root.__mgStableRefreshTimer);
    } catch (_) { }
    const refresh = () => {
      try {
        const mergedHeights = mergeStableSlotHeights(collectStableSlotHeights(root));
        applyStableSlotHeights(root, mergedHeights);
      } catch (_) { }
    };
    try {
      requestAnimationFrame(() => {
        refresh();
        try {
          root.__mgStableRefreshTimer = setTimeout(refresh, 700);
        } catch (_) { }
      });
    } catch (_) {
      refresh();
      try {
        root.__mgStableRefreshTimer = setTimeout(refresh, 700);
      } catch (_) { }
    }
  }

  function swatchSelectionKey(meta) {
    if (!meta || typeof meta !== "object") return "";
    const variantId = collapseWhitespace(meta?.product_variant_id ?? meta?.variant_id ?? "");
    if (variantId) return "variant:" + variantId;
    const href = swatchHrefForMeta(meta);
    if (href) {
      try {
        const url = new URL(href, window.location.href);
        const path = String(url.pathname || "").replace(/\/+$/, "") || "/";
        return "href:" + path + "|" + String(url.search || "");
      } catch (_) {
        return "href:" + href;
      }
    }
    const productId = collapseWhitespace(meta?.product_id ?? meta?.productId ?? "");
    if (productId) return "product:" + productId;
    return "";
  }

  function rootSetNameForElement(el) {
    try {
      const root = el && el.closest ? el.closest("[data-mg-product-swatches-root]") : null;
      if (!root) return "";
      return collapseWhitespace(root.getAttribute("data-mg-set") || root.getAttribute("data-vimeo-set") || "");
    } catch (_) {
      return "";
    }
  }

  function getPendingSelectedSwatch() {
    const pending = R.__pendingSelectedSwatch;
    if (!pending || typeof pending !== "object") return null;
    const createdAt = Number(pending.createdAt || 0);
    if (createdAt > 0 && (Date.now() - createdAt) > 15000) {
      try { delete R.__pendingSelectedSwatch; } catch (_) { }
      return null;
    }
    return pending;
  }

  function rememberPendingSelectedSwatch(card) {
    if (!card) return false;
    const rowEl = card.closest ? card.closest(".mgps-thumb-row") : null;
    const key = swatchSelectionKey(card.__mgpsMeta || {});
    if (!rowEl || !key) return false;
    R.__pendingSelectedSwatch = {
      setName: rootSetNameForElement(card),
      rowIndex: String(rowEl.dataset.rowIndex || ""),
      key,
      createdAt: Date.now()
    };
    return true;
  }

  function clearPendingSelectedSwatch() {
    try { delete R.__pendingSelectedSwatch; } catch (_) { }
  }

  function cardMatchesPendingSelectedSwatch(card, pending) {
    if (!card || !pending) return false;
    try {
      const cardKey = swatchSelectionKey(card.__mgpsMeta || {});
      if (!cardKey || cardKey !== String(pending.key || "")) return false;
      const pendingSetName = String(pending.setName || "");
      if (pendingSetName) {
        const cardSetName = rootSetNameForElement(card);
        if (cardSetName && cardSetName !== pendingSetName) return false;
      }
      const pendingRowIndex = String(pending.rowIndex || "");
      if (pendingRowIndex) {
        const rowEl = card.closest ? card.closest(".mgps-thumb-row") : null;
        const cardRowIndex = rowEl ? String(rowEl.dataset.rowIndex || "") : "";
        if (cardRowIndex && cardRowIndex !== pendingRowIndex) return false;
      }
      return true;
    } catch (_) {
      return false;
    }
  }

  function applyPendingSelectedSwatches(context) {
    const pending = getPendingSelectedSwatch();
    if (!pending) return false;
    const scope = context && context.querySelectorAll ? context : document;
    try {
      const cards = Array.from(scope.querySelectorAll(".mgps-thumb[data-kind='product']"));
      const match = cards.find((card) => cardMatchesPendingSelectedSwatch(card, pending));
      if (!match) return false;
      syncSelectedSwatchCard(match);
      clearPendingSelectedSwatch();
      return true;
    } catch (_) {
      return false;
    }
  }

  function bindSwatchBlockInteraction(block, meta, rowSpec) {
    if (!block || !meta || block.tagName !== "A") return;
    const initialHref = swatchHrefForMeta(meta);
    if (!initialHref) return;
    block.href = initialHref;
    block.target = "_self";
    block.setAttribute("aria-label", plainTextFromMaybeHtml(meta?.title || meta?.alt || "Open item") || "Open item");
    block.__mgpsInteractionMeta = meta || null;
    block.__mgpsInteractionHref = initialHref;
    if (block.__mgpsInteractionBound) return;
    block.__mgpsInteractionBound = true;

    block.addEventListener("click", (event) => {
      const card = block.closest ? block.closest(".mgps-thumb") : null;
      const interactionContext = card || block;
      const scrollMode = swatchSelectionScrollMode(block);
      const liveMeta = block.__mgpsInteractionMeta || meta || {};
      const href = safeLink(block.__mgpsInteractionHref) || swatchHrefForMeta(liveMeta) || initialHref;
      if (!href) return;
      try { rememberPendingSelectedSwatch(card); } catch (_) { }
      try { syncSelectedSwatchCard(card); } catch (_) { }
      if (selectCurrentProductVariantFromSwatch(liveMeta, interactionContext, { scrollMode })) {
        try { event.preventDefault(); } catch (_) { }
        try { event.stopPropagation(); } catch (_) { }
        try {
          if (R.__modal && typeof R.__modal.close === "function") {
            R.__modal.close();
          }
        } catch (_) { }
        if (scrollMode) {
          try { requestAnimationFrame(() => runSwatchSelectionScrollMode(scrollMode)); } catch (_) { }
        }
        return;
      }
      const shouldPreserveNavigationScroll = !!(block.closest && block.closest(".mgps-modal__body"))
        && swatchTargetsDifferentProductPage(href);
      if (shouldPreserveNavigationScroll) {
        const preservedNavigationScrollPosition = modalOpenScrollPosition() || currentViewportScrollPosition();
        if (preservedNavigationScrollPosition) {
          queuePendingViewportScrollPosition(preservedNavigationScrollPosition);
        }
      }
    });
  }

  function ensureSwatchCardBlockState(card, meta, isSelected) {
    if (!card) return null;
    const refs = swatchCardRefs(card);
    const currentBlock = refs.block;
    if (!currentBlock) return null;

    const href = swatchHrefForMeta(meta);
    const presetSet = swatchPresetSetKey(meta);
    const shouldUseLink = !!href && !presetSet && !isSelected;
    const wantedTag = shouldUseLink ? "A" : "DIV";
    let block = currentBlock;

    if (String(currentBlock.tagName || "").toUpperCase() !== wantedTag) {
      const replacement = document.createElement(shouldUseLink ? "a" : "div");
      replacement.className = currentBlock.className;
      replacement.style.cssText = currentBlock.style.cssText;
      while (currentBlock.firstChild) replacement.appendChild(currentBlock.firstChild);
      try { currentBlock.replaceWith(replacement); } catch (_) { }
      block = replacement;
      refs.block = replacement;
      card.__mgpsRefs = refs;
    }

    try {
      block.className = "mgps-thumb-block";
      block.style.borderRadius = "0";
      block.removeAttribute("aria-current");
      block.removeAttribute("aria-disabled");
      block.removeAttribute("aria-label");
      block.removeAttribute("role");
      block.removeAttribute("tabindex");
      block.style.cursor = "";
      if (block.tagName === "A") {
        bindSwatchBlockInteraction(block, meta, card.__mgpsRowSpec || {});
        if (isSelected) {
          block.setAttribute("aria-current", "page");
          block.setAttribute("aria-disabled", "true");
        }
      } else {
        block.removeAttribute("href");
        block.removeAttribute("target");
        if (presetSet && !isSelected) {
          bindSwatchPresetInteraction(block, meta, card.__mgpsRowSpec || {});
        }
        if (isSelected) {
          block.setAttribute("aria-current", "page");
          block.setAttribute("aria-disabled", "true");
        }
      }
    } catch (_) { }

    return block;
  }

  function setSwatchCardSelectedState(card, isSelected) {
    if (!card) return;
    try {
      card.dataset.currentProduct = isSelected ? "true" : "false";
    } catch (_) { }

    const rowEl = card.closest(".mgps-thumb-row");
    const rowSpec = rowEl && rowEl.__rowSpec ? rowEl.__rowSpec : {};
    const meta = card.__mgpsMeta || {};
    const block = ensureSwatchCardBlockState(card, meta, isSelected);
    const refs = swatchCardRefs(card);
    const slot = refs.slot;
    const imgWrap = refs.imgWrap;
    const bottom = refs.bottom;
    const img = refs.img;
    applySwatchAppearance(card, block, slot, imgWrap, bottom, img, rowSpec, isSelected);
  }

  function syncSelectedSwatchCard(card) {
    if (!card) return false;
    const rowEl = card.closest(".mgps-thumb-row");
    if (!rowEl) return false;
    let changed = false;

    rowEl.querySelectorAll(":scope > .mgps-thumb[data-kind='product']").forEach((candidate) => {
      const shouldSelect = candidate === card;
      if (String(candidate.dataset.currentProduct || "") === (shouldSelect ? "true" : "false")) return;
      setSwatchCardSelectedState(candidate, shouldSelect);
      changed = true;
    });

    if (changed) {
      try { applyRowTextSizing(rowEl); } catch (_) { }
      try { applyFitRow(rowEl); } catch (_) { }
      try { applyRowSwatchVerticalLayout(rowEl); } catch (_) { }
      try { applyRowCornerRadius(rowEl); } catch (_) { }
    }
    return changed;
  }

  function syncRowCurrentProductSelection(rowEl) {
    if (!rowEl || !rowEl.querySelectorAll) return false;
    const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb[data-kind='product']"));
    if (!cards.length) return false;

    const exactMatches = cards.filter((card) => {
      try {
        return isCurrentProductTarget(card.__mgpsMeta || {});
      } catch (_) {
        return false;
      }
    });
    const explicitMatches = exactMatches.length ? exactMatches : cards.filter((card) => {
      try {
        if (String(card.dataset.currentProduct || "") === "true") return true;
        const meta = card.__mgpsMeta || {};
        return isTrueLike(meta?.current_product || meta?.is_selected || meta?.selected);
      } catch (_) {
        return false;
      }
    });
    if (!explicitMatches.length) return false;

    const selectedCard = explicitMatches[0];
    let changed = false;
    cards.forEach((card) => {
      const shouldSelect = card === selectedCard;
      if (String(card.dataset.currentProduct || "") === (shouldSelect ? "true" : "false")) return;
      setSwatchCardSelectedState(card, shouldSelect);
      changed = true;
    });

    if (changed) {
      try { applyRowTextSizing(rowEl); } catch (_) { }
      try { applyFitRow(rowEl); } catch (_) { }
      try { applyRowSwatchVerticalLayout(rowEl); } catch (_) { }
      try { applyRowCornerRadius(rowEl); } catch (_) { }
    }
    return changed;
  }

  function syncCurrentProductSelections(context) {
    const scope = context && context.querySelectorAll ? context : document;
    let changed = false;
    try {
      scope.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => {
        if (syncRowCurrentProductSelection(rowEl)) changed = true;
      });
    } catch (_) { }
    return changed;
  }

  function ensureInitialSwatchSelections(context) {
    const scope = context && context.querySelectorAll ? context : document;
    try {
      scope.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => {
        try { syncRowCurrentProductSelection(rowEl); } catch (_) { }
      });
    } catch (_) { }
  }

  function productScalePct(meta, fallback = 100) {
    const raw = meta?.swatch_image_zoom
      ?? meta?.swatchImageZoom
      ?? meta?.product_image_scale
      ?? meta?.productImageScale
      ?? meta?.scale
      ?? meta?.__rowSwatchImageZoom
      ?? fallback;
    return clampImageZoomPct(raw, fallback);
  }

  function swatchImageSizePct(meta, fallback = 100) {
    const raw = meta?.__overrideSwatchImageSizePercent
      ?? meta?.swatch_image_size_percent
      ?? meta?.swatchImageSizePercent
      ?? meta?.__rowSwatchImageSizePercent
      ?? fallback;
    return clampNumber(raw, 1, 100, fallback);
  }

  function parseSwatchImageSizeOverrideValue(raw, fallback = 100) {
    const value = Number(raw);
    if (!Number.isFinite(value) || value <= 0) return fallback;
    return clampNumber(value, 1, 100, 100);
  }

  function collectSwatchImageIndexOverrides(source) {
    const list = Array.isArray(source?.swatch_image_index_overrides)
      ? source.swatch_image_index_overrides
      : (Array.isArray(source?.swatchImageIndexOverrides) ? source.swatchImageIndexOverrides : null);
    if (list) {
      return Array.from({ length: 5 }, (_, index) => parseSwatchImageSizeOverrideValue(list[index], 100));
    }

    return [1, 2, 3, 4, 5].map((index) => parseSwatchImageSizeOverrideValue(
      source?.[`swatch_${index}_img_size_percent`]
      ?? source?.[`swatch_${index}_image_size_percent`]
      ?? source?.[`swatch${index}ImgSizePercent`]
      ?? source?.[`swatch${index}ImageSizePercent`],
      100
    ));
  }

  function applySwatchImageSizeIndexOverrides(items, overrides) {
    if (!Array.isArray(overrides) || !overrides.length) return;
    let visualSwatchIndex = 0;
    items.forEach((item) => {
      const itemType = String(item?.type || item?.kind || "").trim().toLowerCase();
      if (itemType === "swatch_popup_trigger" || itemType === "popup_remaining_swatches_trigger") return;

      if (visualSwatchIndex >= overrides.length) {
        visualSwatchIndex += 1;
        return;
      }
      const rawOverride = overrides[visualSwatchIndex];
      const override = rawOverride && typeof rawOverride === "object"
        ? rawOverride
        : { swatch_image_size_percent: rawOverride };
      const imageSizePercent = parseSwatchImageSizeOverrideValue(
        override.swatch_image_size_percent ?? override.swatchImageSizePercent,
        100
      );
      const verticalJustify = normalizeSwatchVerticalJustify(
        override.swatch_vertical_justify ?? override.swatchVerticalJustify,
        "bottom"
      );
      const scalePercent = clampImageZoomPct(
        override.scale
        ?? override.product_image_scale
        ?? override.productImageScale
        ?? imageSizePercent,
        imageSizePercent
      );
      visualSwatchIndex += 1;
      item.__overrideSwatchImageSizePercent = imageSizePercent;
      item.__overrideSwatchVerticalJustify = verticalJustify;
      item.swatch_image_size_percent = imageSizePercent;
      item.swatchImageSizePercent = imageSizePercent;
      item.swatch_vertical_justify = verticalJustify;
      item.swatchVerticalJustify = verticalJustify;
      item.scale = scalePercent;
      item.product_image_scale = scalePercent;
      item.productImageScale = scalePercent;
      item.__rowSwatchImageSizePercent = imageSizePercent;
      item.__rowSwatchVerticalJustify = verticalJustify;
    });
  }

  function collectMatchedPresetItemImageSizeOverrides(matchedRow) {
    const items = Array.isArray(rowItems(matchedRow)) ? rowItems(matchedRow) : [];
    const overrides = [];

    items.forEach((item) => {
      const normalizedItem = normalizeItem(item);
      if (!normalizedItem) return;
      const itemType = String(normalizedItem.type || normalizedItem.kind || "").trim().toLowerCase();
      if (itemType === "swatch_popup_trigger" || itemType === "popup_remaining_swatches_trigger" || itemType === "current_product_variants_source") return;

      overrides.push({
        swatch_image_size_percent: swatchImageSizePct(normalizedItem, 100),
        swatch_vertical_justify: normalizeSwatchVerticalJustify(
          normalizedItem.swatch_vertical_justify ?? normalizedItem.swatchVerticalJustify,
          "bottom"
        ),
        scale: clampImageZoomPct(
          normalizedItem.scale
          ?? normalizedItem.product_image_scale
          ?? normalizedItem.productImageScale
          ?? swatchImageSizePct(normalizedItem, 100),
          swatchImageSizePct(normalizedItem, 100)
        ),
        product_image_scale: clampImageZoomPct(
          normalizedItem.product_image_scale
          ?? normalizedItem.productImageScale
          ?? normalizedItem.scale
          ?? swatchImageSizePct(normalizedItem, 100),
          swatchImageSizePct(normalizedItem, 100)
        )
      });
    });

    return overrides;
  }

  function normalizeSwatchVerticalJustify(raw, fallback = "bottom") {
    const value = String(raw || "").trim().toLowerCase();
    if (value === "top" || value === "middle" || value === "bottom" || value === "fit_to_height") return value;
    return fallback;
  }

  function resolvedSwatchVerticalJustify(meta, rowSpec, fallback = "bottom") {
    return normalizeSwatchVerticalJustify(
      meta?.__overrideSwatchVerticalJustify
      ?? meta?.swatch_vertical_justify
      ?? meta?.swatchVerticalJustify
      ?? meta?.__rowSwatchVerticalJustify
      ?? rowSpec?.swatch_vertical_justify
      ?? rowSpec?.swatchVerticalJustify,
      fallback
    );
  }

  function stripMatchedPresetRowSettings(row) {
    if (!row || typeof row !== "object") return {};
    const copy = Object.assign({}, row);
    [
      "heading_justify",
      "img_ratio",
      "row_height",
      "row_height_mobile",
      "row_height_desktop",
      "fit_row",
      "row_display_type",
      "row_display_type_mobile",
      "row_display_type_desktop",
      "more_popup_text",
      "margin_top",
      "margin_bottom",
      "row_justify",
      "swatches_per_row_mobile",
      "swatches_per_row_desktop",
      "swatches_per_row",
      "swatchesPerRowMobile",
      "swatchesPerRowDesktop",
      "swatchesPerRow",
      "padding_between_rows_mobile",
      "padding_between_rows_desktop",
      "padding_between_rows",
      "paddingBetweenRowsMobile",
      "paddingBetweenRowsDesktop",
      "paddingBetweenRows",
      "swatch_image_size_percent",
      "swatchImageSizePercent",
      "swatch_image_zoom",
      "swatchImageZoom",
      "product_image_scale",
      "productImageScale",
      "scale",
      "swatch_vertical_justify",
      "swatchVerticalJustify",
      "randomize_zoom_area",
      "randomizeZoomArea",
      "random_zoom_max",
      "randomZoomMax",
      "collapsed",
      "show_more_text",
      "show_less_text",
      "row_toggle_border_style",
      "hide_cta_buttons",
      "end_behavior_override",
      "custom_width_desktop_percent",
      "custom_width_mobile_percent",
      "custom_max_width_px",
      "popup_padding_between_rows",
      "preset_button_padding_x_px",
      "preset_button_padding_y_px",
      "preset_button_style",
      "preset_button_image_height_mobile",
      "preset_button_image_height_desktop",
      "preset_button_width_percent",
      "preset_button_max_width_px",
      "preset_button_heading_justify",
      "preset_button_border_color",
      "preset_button_border_size",
      "preset_button_shadow_size",
      "preset_button_border_radius_px",
      "preset_button_background_color",
      "preset_button_text_color",
      "preset_button_gradient_color",
      "preset_button_gradient_angle",
      "preset_button_background_image",
      "preset_button_background_image_style",
      "preset_button_text_size_mobile",
      "preset_button_text_size_desktop",
      "preset_button_text_behavior",
      "preset_button_text_style",
      "preset_button_image_radius_px",
      "preset_button_product_image_padding",
      "preset_button_border_scope",
      "button_width_percent",
      "button_max_width_px",
      "button_image_height_mobile",
      "button_image_height_desktop",
      "button_image_height",
      "button_image_width",
      "button_max_width",
      "modal_button_style",
      "modal_button_image_height_mobile",
      "modal_button_image_height_desktop",
      "modal_button_width_percent",
      "modal_button_max_width_px"
    ].forEach((key) => {
      delete copy[key];
    });
    if (row.preset_button) {
      [
        "preset_button_style",
        "preset_button_image_height_mobile",
        "preset_button_image_height_desktop",
        "preset_button_width_percent",
        "preset_button_max_width_px",
        "preset_button_heading_justify",
        "preset_button_border_color",
        "preset_button_border_size",
        "preset_button_shadow_size",
        "preset_button_border_radius_px",
        "preset_button_background_color",
        "preset_button_text_color",
        "preset_button_gradient_color",
        "preset_button_gradient_angle",
        "preset_button_background_image",
        "preset_button_background_image_style",
        "preset_button_text_size_mobile",
        "preset_button_text_size_desktop",
        "preset_button_text_behavior",
        "preset_button_text_style",
        "preset_button_image_radius_px",
        "preset_button_product_image_padding",
        "preset_button_border_scope",
        "button_width_percent",
        "button_max_width_px",
        "button_image_height_mobile",
        "button_image_height_desktop",
        "button_image_height",
        "popup_padding_between_rows",
        "preset_button_padding_x_px",
        "preset_button_padding_y_px"
      ].forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(row, key)) copy[key] = row[key];
      });
    }
    return copy;
  }

  function stripMatchedPresetItemSettings(item) {
    if (!item || typeof item !== "object") return {};
    const copy = Object.assign({}, item);
    [
      "show_price",
      "show_reviews",
      "show_shop_button",
      "buttons_over_image",
      "swatch_image_zoom",
      "swatchImageZoom",
      "randomize_zoom_area",
      "randomizeZoomArea",
      "scale",
      "product_image_scale",
      "productImageScale",
      "vjust",
      "html_desc",
      "desc_html",
      "margin_top",
      "margin_bottom",
      "open_set_key",
      "learn_more_text",
      "popup_swatches_per_row_mobile",
      "popup_swatches_per_row_desktop"
    ].forEach((key) => {
      delete copy[key];
    });
    return copy;
  }

  function stripMatchedPresetPopupRemainingTriggerSettings(item) {
    if (!item || typeof item !== "object") return {};
    const copy = Object.assign({}, item);
    [
      "button_appearance_source",
      "button_width_percent",
      "button_max_width_px",
      "button_image_height_mobile",
      "button_image_height_desktop",
      "button_justify",
      "preset_button_heading_justify",
      "preset_button_image_height_mobile",
      "preset_button_image_height_desktop",
      "preset_button_border_color",
      "preset_button_border_size",
      "preset_button_shadow_size",
      "preset_button_border_radius_px",
      "preset_button_background_color",
      "preset_button_text_color",
      "preset_button_gradient_color",
      "preset_button_gradient_angle",
      "preset_button_background_image",
      "preset_button_background_image_style",
      "preset_button_text_size_mobile",
      "preset_button_text_size_desktop",
      "preset_button_text_behavior",
      "preset_button_text_style",
      "preset_button_image_radius_px",
      "preset_button_product_image_padding",
      "preset_button_border_scope"
    ].forEach((key) => {
      delete copy[key];
    });
    return copy;
  }

  function stripMatchedPresetItemSettingsForExport(item) {
    const rawItem = item && typeof item === "object" ? item : {};
    const copy = stripMatchedPresetItemSettings(rawItem);
    [
      "swatch_vertical_justify",
      "swatchVerticalJustify",
      "swatch_image_zoom",
      "swatchImageZoom",
      "scale",
      "product_image_scale",
      "productImageScale"
    ].forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(rawItem, key)) {
        copy[key] = rawItem[key];
      }
    });
    return copy;
  }

  function preserveLocalMatchedPresetItemSettings(base, merged) {
    const local = base && typeof base === "object" ? base : {};
    const out = merged && typeof merged === "object" ? merged : {};
    [
      "show_price",
      "show_reviews",
      "show_shop_button",
      "buttons_over_image",
      "swatch_image_zoom",
      "swatchImageZoom",
      "randomize_zoom_area",
      "randomizeZoomArea",
      "scale",
      "product_image_scale",
      "productImageScale",
      "vjust",
      "html_desc",
      "desc_html",
      "margin_top",
      "margin_bottom",
      "open_set_key",
      "learn_more_text",
      "popup_swatches_per_row_mobile",
      "popup_swatches_per_row_desktop"
    ].forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(local, key)) {
        out[key] = local[key];
      } else if (key !== "show_price") {
        delete out[key];
      }
    });
    return out;
  }

  function resolveMatchedRowSwatchVerticalJustify(sourceRow, matchedRow, preferMatched) {
    const sourceValue = normalizeSwatchVerticalJustify(
      sourceRow && (sourceRow.swatch_vertical_justify ?? sourceRow.swatchVerticalJustify),
      ""
    );
    const matchedValue = normalizeSwatchVerticalJustify(
      matchedRow && (matchedRow.swatch_vertical_justify ?? matchedRow.swatchVerticalJustify),
      ""
    );
    if (preferMatched && matchedValue) return matchedValue;
    if (matchedValue && (!sourceValue || sourceValue === "fit_to_height")) return matchedValue;
    return sourceValue || matchedValue || "bottom";
  }

  function swatchVerticalAlignItems(value) {
    switch (normalizeSwatchVerticalJustify(value, "bottom")) {
      case "top":
        return "flex-start";
      case "middle":
        return "center";
      default:
        return "flex-end";
    }
  }

  function rowUsesFitToHeight(rowSpec) {
    return normalizeSwatchVerticalJustify(rowSpec?.swatch_vertical_justify, "bottom") === "fit_to_height";
  }

  function setRowFitToHeightPending(rowEl, isPending) {
    if (!rowEl) return;
    try {
      rowEl.dataset.fitHeightPending = isPending ? "true" : "false";
    } catch (_) { }
  }

  function whenImageMeasurable(img) {
    if (!img) return Promise.resolve();
    if (img.complete && Number(img.naturalWidth) > 0 && Number(img.naturalHeight) > 0) {
      try {
        if (typeof img.decode === "function") {
          return img.decode().catch(() => { });
        }
      } catch (_) { }
      return Promise.resolve();
    }
    return new Promise((resolve) => {
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        try { img.removeEventListener("load", onLoad); } catch (_) { }
        try { img.removeEventListener("error", onError); } catch (_) { }
        resolve();
      };
      const onLoad = () => {
        try {
          if (typeof img.decode === "function") {
            img.decode().catch(() => { }).finally(finish);
            return;
          }
        } catch (_) { }
        finish();
      };
      const onError = () => finish();
      try { img.addEventListener("load", onLoad, { once: true }); } catch (_) { }
      try { img.addEventListener("error", onError, { once: true }); } catch (_) { }
    });
  }

  function primeRowFitToHeight(rowEl) {
    if (!rowEl || !rowEl.querySelectorAll) return Promise.resolve();
    if (!rowUsesFitToHeight(rowEl.__rowSpec || {})) {
      setRowFitToHeightPending(rowEl, false);
      return Promise.resolve();
    }
    if (rowEl.__mgpsFitHeightPrimePromise) return rowEl.__mgpsFitHeightPrimePromise;

    setRowFitToHeightPending(rowEl, true);

    const imgs = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb .mgps-img-wrap img"));
    if (!imgs.length) {
      setRowFitToHeightPending(rowEl, false);
      return Promise.resolve();
    }

    rowEl.__mgpsFitHeightPrimePromise = Promise.race([
      Promise.all(imgs.map((img) => whenImageMeasurable(img))),
      new Promise((resolve) => window.setTimeout(resolve, 2500))
    ]).then(() => new Promise((resolve) => {
      requestAnimationFrame(() => {
        try { applyFitRow(rowEl); } catch (_) { }
        try { applyRowSwatchVerticalLayout(rowEl); } catch (_) { }
        setRowFitToHeightPending(rowEl, false);
        resolve();
      });
    })).finally(() => {
      try { delete rowEl.__mgpsFitHeightPrimePromise; } catch (_) { }
    });

    return rowEl.__mgpsFitHeightPrimePromise;
  }

  function clearRowFitToHeight(rowEl) {
    if (!rowEl || !rowEl.querySelectorAll) return;
    try {
      rowEl.style.removeProperty("--mgps-fit-image-height");
    } catch (_) { }
    rowEl.querySelectorAll(":scope > .mgps-thumb .mgps-img-wrap").forEach((imgWrap) => {
      try {
        imgWrap.classList.remove("is-fit-height");
        imgWrap.style.removeProperty("height");
      } catch (_) { }
    });
  }

  function fitToHeightImageMeasurement(img, rowEl) {
    if (!img) return 0;
    try {
      const imgWrap = img.closest ? img.closest(".mgps-img-wrap") : null;
      const card = img.closest ? img.closest(".mgps-thumb") : null;
      const width = Math.max(
        0,
        Math.round(
          (imgWrap && imgWrap.clientWidth)
          || (imgWrap && imgWrap.getBoundingClientRect ? imgWrap.getBoundingClientRect().width : 0)
          || (card && card.clientWidth)
          || (card && card.getBoundingClientRect ? card.getBoundingClientRect().width : 0)
          || 0
        )
      );
      const ratio = parseImgRatio((rowEl && rowEl.dataset && rowEl.dataset.imgRatio) || "1:1");
      const rowHeight = currentRowHeight(rowEl);
      const wrapHeight = rowHeight > 0
        ? rowHeight
        : (width > 0 ? (width * (ratio.h / ratio.w)) : 0);
      const naturalWidth = Number(img.naturalWidth || 0);
      const naturalHeight = Number(img.naturalHeight || 0);
      const scale = clampImageZoomPct(
        (card && card.__mgpsMeta && resolvedSwatchZoomPct(card.__mgpsMeta, 100)) || 100,
        100
      ) / 100;
      const sizeScale = clampNumber(
        (card && card.__mgpsMeta && swatchImageSizePct(card.__mgpsMeta, 100)) || 100,
        1,
        100,
        100
      ) / 100;

      if (width > 0 && wrapHeight > 0 && naturalWidth > 0 && naturalHeight > 0) {
        const containHeight = Math.min(wrapHeight, width * (naturalHeight / naturalWidth));
        return Math.max(0, Math.round(containHeight * sizeScale * scale));
      }

      if (img.getBoundingClientRect) {
        const rect = img.getBoundingClientRect();
        return Math.max(0, Math.round(rect.height || 0));
      }
    } catch (_) { }
    return 0;
  }

  function fitToHeightCardMeasurement(card, rowEl) {
    if (!card) return 0;
    try {
      const img = card.querySelector ? card.querySelector(".mgps-img-wrap img") : null;
      if (img) {
        const measured = fitToHeightImageMeasurement(img, rowEl);
        if (measured > 0) return measured;
      }

      const imgWrap = card.querySelector ? card.querySelector(".mgps-img-wrap") : null;
      const placeholder = card.querySelector ? card.querySelector(".mgps-img-placeholder") : null;
      const width = Math.max(
        0,
        Math.round(
          (imgWrap && imgWrap.clientWidth)
          || (imgWrap && imgWrap.getBoundingClientRect ? imgWrap.getBoundingClientRect().width : 0)
          || (card.clientWidth)
          || (card.getBoundingClientRect ? card.getBoundingClientRect().width : 0)
          || 0
        )
      );
      const ratio = parseImgRatio((rowEl && rowEl.dataset && rowEl.dataset.imgRatio) || "1:1");
      const rowHeight = currentRowHeight(rowEl);
      const ratioHeight = rowHeight > 0
        ? rowHeight
        : (width > 0 ? (width * (ratio.h / ratio.w)) : 0);
      const placeholderHeight = Math.max(
        0,
        Math.round(
          (placeholder && placeholder.getBoundingClientRect ? placeholder.getBoundingClientRect().height : 0)
          || (placeholder && placeholder.scrollHeight)
          || 0
        )
      );
      const wrapHeight = Math.max(
        0,
        Math.round(
          (imgWrap && imgWrap.getBoundingClientRect ? imgWrap.getBoundingClientRect().height : 0)
          || (imgWrap && imgWrap.clientHeight)
          || 0
        )
      );

      return Math.max(ratioHeight, placeholderHeight, wrapHeight);
    } catch (_) { }
    return 0;
  }

  function applyRowSwatchVerticalLayout(rowEl) {
    if (!rowEl || !rowEl.querySelectorAll) return;
    const rowSpec = rowEl.__rowSpec || {};
    const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb"));
    let usesFitToHeight = false;

    cards.forEach((card) => {
      const mode = resolvedSwatchVerticalJustify(card && card.__mgpsMeta ? card.__mgpsMeta : null, rowSpec, "bottom");
      const alignItems = swatchVerticalAlignItems(mode);
      const imgInner = card.querySelector ? card.querySelector(".mgps-img-inner") : null;
      const img = card.querySelector ? card.querySelector(".mgps-img-wrap img") : null;
      if (imgInner) {
        setStyleImportant(imgInner, "display", "flex");
        setStyleImportant(imgInner, "justify-content", "center");
        setStyleImportant(imgInner, "align-items", alignItems);
      }
      if (img) {
        const originY = mode === "top" ? "top" : mode === "middle" ? "center" : "bottom";
        setStyleImportant(img, "transform-origin", "center " + originY);
        try { img.style.objectPosition = "center " + originY; } catch (_) { }
      }
      if (mode === "fit_to_height") usesFitToHeight = true;
    });

    if (!usesFitToHeight) {
      clearRowFitToHeight(rowEl);
      return;
    }

    const measuredHeights = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb"))
      .map((card) => fitToHeightCardMeasurement(card, rowEl))
      .filter((height) => height > 0);

    if (!measuredHeights.length) {
      clearRowFitToHeight(rowEl);
      return;
    }

    const tallest = Math.max.apply(null, measuredHeights);
    if (!(tallest > 0)) {
      clearRowFitToHeight(rowEl);
      return;
    }

    try {
      rowEl.style.setProperty("--mgps-fit-image-height", tallest + "px");
    } catch (_) { }

    rowEl.querySelectorAll(":scope > .mgps-thumb .mgps-img-wrap").forEach((imgWrap) => {
      try {
        imgWrap.classList.add("is-fit-height");
        imgWrap.style.setProperty("height", tallest + "px");
      } catch (_) { }
    });
  }

  function productRandomZoomMaxPct(meta, fallback = 0) {
    const raw = meta?.random_zoom_max
      ?? meta?.randomZoomMax
      ?? meta?.__rowRandomZoomMax
      ?? meta?.random_swatch_image_zoom
      ?? meta?.randomSwatchImageZoom
      ?? fallback;
    return Math.round(clampNumber(raw, 0, 600, fallback));
  }

  function shouldRandomizeSwatchZoomArea(meta) {
    return isTrueLike(
      meta?.randomize_zoom_area
      ?? meta?.randomizeZoomArea
      ?? meta?.__rowRandomizeZoomArea
      ?? meta?.randomize_zoomed_swatch_area
      ?? meta?.randomizeZoomedSwatchArea
      ?? false
    );
  }

  function swatchZoomSeed(meta, salt = "") {
    const seedSource = String(
      meta?.product_id
      ?? meta?.productId
      ?? meta?.product_url
      ?? meta?.productUrl
      ?? meta?.title
      ?? ""
    ) + "|" + String(salt || "");
    let hash = 0;
    for (let i = 0; i < seedSource.length; i++) {
      hash = ((hash << 5) - hash + seedSource.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
  }

  function swatchZoomPresentation(meta, zoomPct) {
    if (!(Number(zoomPct) > 100) || !shouldRandomizeSwatchZoomArea(meta)) {
      return { objectPosition: "center center", flipX: 1, flipY: 1, shiftX: "0%", shiftY: "0%" };
    }
    const seedX = swatchZoomSeed(meta, "x");
    const seedY = swatchZoomSeed(meta, "y");
    const seedFlipX = swatchZoomSeed(meta, "flip-x");
    const seedFlipY = swatchZoomSeed(meta, "flip-y");
    const x = 8 + (seedX % 85);
    const y = 8 + (seedY % 85);
    const flipX = (seedFlipX % 2) ? -1 : 1;
    const flipY = (seedFlipY % 2) ? -1 : 1;
    const zoomFactor = Math.max(1, Number(zoomPct) / 100);
    const maxShift = Math.max(6, Math.min(28, Math.round((zoomFactor - 1) * 18)));
    const shiftX = ((x - 50) / 50) * maxShift;
    const shiftY = ((y - 50) / 50) * maxShift;
    return {
      objectPosition: x + "% " + y + "%",
      flipX,
      flipY,
      shiftX: shiftX.toFixed(2) + "%",
      shiftY: shiftY.toFixed(2) + "%"
    };
  }

  function resolvedSwatchZoomPct(meta, fallback = 100) {
    const minZoom = productScalePct(meta, fallback);
    const maxZoomRaw = productRandomZoomMaxPct(meta, 0);
    const maxZoom = maxZoomRaw > 0 ? Math.max(minZoom, maxZoomRaw) : minZoom;
    if (maxZoom <= minZoom) return minZoom;
    const seed = swatchZoomSeed(meta, "zoom");
    const steps = 6;
    const span = maxZoom - minZoom;
    const bucket = seed % steps;
    const zoom = minZoom + ((span * bucket) / steps);
    return Math.round(zoom);
  }

  function swatchImageRequestWidth(meta, card, slot, imgWrap) {
    if (shouldRandomizeSwatchZoomArea(meta)) return 2400;
    const displayWidth = currentSwatchRequestWidth(card, slot, imgWrap);
    const zoomPct = resolvedSwatchZoomPct(meta, 100);
    const requestedWidth = Math.max(displayWidth, Math.round(displayWidth * Math.max(1, zoomPct / 100)));
    return Math.min(2400, Math.max(400, requestedWidth));
  }

  function rawImageSrc(raw) {
    const s = String(raw || "").trim();
    if (!s) return "";
    if (/^\/\//.test(s)) return window.location.protocol + s;
    if (/^data:image\//i.test(s)) return s;
    try {
      const u = new URL(s, window.location.href);
      if (u.protocol === "http:" || u.protocol === "https:") return u.href;
      return "";
    } catch (_) {
      return "";
    }
  }

  function guessItemKind(it) {
    const tRaw = String(it?.type || it?.kind || it?.provider || "").trim().toLowerCase();
    if (tRaw === "product") return "product";
    if (tRaw === "image") return "image";
    if (tRaw === "swatch_popup_trigger") return "swatch_popup_trigger";
    if (tRaw === "popup_remaining_swatches_trigger") return "popup_remaining_swatches_trigger";
    if (tRaw === "current_product_variants_source") return "current_product_variants_source";
    if (tRaw === "video" || tRaw === "vimeo" || tRaw === "youtube" || tRaw === "file") return "image";
    if (collapseWhitespace(it?.product_url || it?.productUrl)) return "product";
    if (collapseWhitespace(it?.thumbnail || it?.image || it?.img || it?.url)) return "image";
    return null;
  }

  function normalizeItem(it, opts = {}) {
    if (!it || typeof it !== "object") return null;
    const source = (() => {
      const base = Object.assign({}, it);
      const baseKind = guessItemKind(base);
      const explicitMatchKey = resolveExistingSetKey(
        base.match_settings_preset_key ||
        base.matchPresetSettingsKey ||
        ""
      );
      const inheritedMatchKey = resolveExistingSetKey(opts.matchSettingsPresetKey || "");
      const matchKey = explicitMatchKey || (baseKind === "popup_remaining_swatches_trigger" ? inheritedMatchKey : "");
      if (!matchKey) return base;
      if (baseKind === "popup_remaining_swatches_trigger") {
        const matchedPopupSettings = matchedPresetPopupRemainingTriggerSettings(matchKey);
        if (!matchedPopupSettings || typeof matchedPopupSettings !== "object") return base;
        const merged = Object.assign({}, matchedPopupSettings, stripMatchedPresetPopupRemainingTriggerSettings(base));
        if (Object.prototype.hasOwnProperty.call(base, "match_settings_preset_key")) merged.match_settings_preset_key = base.match_settings_preset_key;
        if (Object.prototype.hasOwnProperty.call(base, "matchPresetSettingsKey")) merged.matchPresetSettingsKey = base.matchPresetSettingsKey;
        return merged;
      }
      const matched = firstResolvedItemFromSet(matchKey);
      if (!matched || typeof matched !== "object") return base;
      const merged = Object.assign({}, matched, stripMatchedPresetItemSettings(base));
      preserveLocalMatchedPresetItemSettings(base, merged);
      if (base.cta && typeof base.cta === "object") merged.cta = Object.assign({}, matched.cta || {}, base.cta);
      ["thumbnail", "image", "img"].forEach((key) => {
        if (!Object.prototype.hasOwnProperty.call(base, key)) delete merged[key];
      });
      if (!Object.prototype.hasOwnProperty.call(base, "product_image_id")) delete merged.product_image_id;
      return merged;
    })();
    const kind = guessItemKind(source);
    if (!kind) return null;
    const copy = Object.assign({}, source);
    copy.type = kind;
    if (kind === "swatch_popup_trigger" || kind === "popup_remaining_swatches_trigger") {
      copy.popup_swatches_per_row_mobile = Number(copy.popup_swatches_per_row_mobile || 0) || 0;
      copy.popup_swatches_per_row_desktop = Number(copy.popup_swatches_per_row_desktop || 0) || 0;
      copy.include_visible_swatches_in_popup = isTrueLike(copy.include_visible_swatches_in_popup);
      return copy;
    }
    if (kind === "current_product_variants_source") {
      copy.use_product_page_product = isTrueLike(copy.use_product_page_product ?? copy.use_current_product_page_product ?? true);
      copy.source_product_handle = collapseWhitespace(copy.source_product_handle || copy.sourceProductHandle || "");
      copy.fallback_source_product_handle = collapseWhitespace(copy.fallback_source_product_handle || copy.fallbackSourceProductHandle || "");
      copy.fallback_use_product_page_product = isTrueLike(copy.fallback_use_product_page_product ?? copy.fallbackUseProductPageProduct ?? false);
      copy.variant_option_name = collapseWhitespace(copy.variant_option_name || copy.variantOptionName || "");
      copy.current_option_value = collapseWhitespace(copy.current_option_value || copy.currentOptionValue || "");
      copy.product_handle_contains = collapseWhitespace(copy.product_handle_contains || copy.productHandleContains || "");
      copy.find_product_handle_contains = collapseWhitespace(copy.find_product_handle_contains || copy.findProductHandleContains || "");
      copy.variant_title_mode = String(copy.variant_title_mode || copy.variantTitleMode || "option_value").trim().toLowerCase() || "option_value";
      copy.variant_title_prefix = String(copy.variant_title_prefix || copy.variantTitlePrefix || "");
      copy.show_price = isTrueLike(copy.show_price);
      return copy;
    }
    if (!copy.thumbnail && copy.product_image_url) copy.thumbnail = copy.product_image_url;
    if (!copy.thumbnail && copy.image) copy.thumbnail = copy.image;
    if (!copy.thumbnail && copy.img) copy.thumbnail = copy.img;
    return copy;
  }

  function currentStorefrontProductHandle() {
    try {
      const path = currentStorefrontProductPath();
      const match = String(path || "").match(/^\/products\/([^/?#]+)/i);
      return match ? String(match[1] || "").trim() : "";
    } catch (_) {
      return "";
    }
  }

  function storefrontProductJsonFromScope(scope) {
    try {
      const root = scope && scope.querySelector ? scope : document;
      const script = root.querySelector('script[id^="ProductJson-"][type="application/json"]');
      if (!script) return null;
      return safeJsonParse(script.textContent || "") || null;
    } catch (_) {
      return null;
    }
  }

  function currentStorefrontProductJsonFromDom() {
    return storefrontProductJsonFromScope(document);
  }

  function currentStorefrontProductJsonUrl() {
    try {
      const path = currentStorefrontProductPath();
      if (!/^\/products\/[^/?#]+/i.test(String(path || ""))) return "";
      return path + ".js";
    } catch (_) {
      return "";
    }
  }

  function productJsonUrlForHandle(handle) {
    const normalizedHandle = String(handle || "").trim();
    if (!normalizedHandle) return "";
    return "/products/" + encodeURIComponent(normalizedHandle) + ".js";
  }

  function productCacheKeyForHref(href, fallbackVariantId) {
    const rawHref = safeLink(href);
    if (!rawHref) return "";
    try {
      const url = new URL(rawHref, window.location.href);
      const path = String(url.pathname || "").replace(/\/+$/, "");
      if (!/^\/products\/[^/?#]+/i.test(path)) return "";
      const variantId = collapseWhitespace(url.searchParams.get("variant") || fallbackVariantId || "");
      return path + ".js::" + variantId;
    } catch (_) {
      return "";
    }
  }

  function currentStorefrontProductCacheKey() {
    const jsonUrl = currentStorefrontProductJsonUrl();
    const variantId = currentStorefrontVariantId();
    return jsonUrl ? (jsonUrl + "::" + variantId) : "";
  }

  function currentStorefrontProductData() {
    try {
      const cacheKey = currentStorefrontProductCacheKey();
      if (cacheKey && R.__currentStorefrontProductCacheKey === cacheKey && R.__currentStorefrontProductData && typeof R.__currentStorefrontProductData === "object") {
        return R.__currentStorefrontProductData;
      }
    } catch (_) { }
    try {
      const fromDom = currentStorefrontProductJsonFromDom();
      if (fromDom && typeof fromDom === "object") return fromDom;
    } catch (_) { }
    return null;
  }

  async function loadCurrentStorefrontProductData(force = false) {
    const cacheKey = currentStorefrontProductCacheKey();
    const jsonUrl = currentStorefrontProductJsonUrl();
    if (!jsonUrl) return null;

    if (!force && cacheKey && R.__currentStorefrontProductCacheKey === cacheKey && R.__currentStorefrontProductData && typeof R.__currentStorefrontProductData === "object") {
      return R.__currentStorefrontProductData;
    }

    R.__currentStorefrontProductFetchCache = R.__currentStorefrontProductFetchCache || Object.create(null);
    if (!force && R.__currentStorefrontProductFetchCache[cacheKey]) {
      return R.__currentStorefrontProductFetchCache[cacheKey];
    }

    const request = fetch(jsonUrl, { credentials: "same-origin" })
      .then((res) => res.ok ? res.json() : null)
      .then((data) => {
        if (data && typeof data === "object") {
          R.__currentStorefrontProductData = data;
          R.__currentStorefrontProductCacheKey = cacheKey;
          R.__currentStorefrontProductHandle = currentStorefrontProductHandle();
          return data;
        }
        return null;
      })
      .catch(() => null)
      .finally(() => {
        try { delete R.__currentStorefrontProductFetchCache[cacheKey]; } catch (_) { }
      });

    R.__currentStorefrontProductFetchCache[cacheKey] = request;
    return request;
  }

  function relatedProductHandleFromSource(sourceMeta) {
    const currentHandle = currentStorefrontProductHandle();
    const findValue = collapseWhitespace(sourceMeta?.product_handle_contains || "");
    const replaceValue = collapseWhitespace(sourceMeta?.find_product_handle_contains || "");
    if (!currentHandle) return "";
    if (!findValue) return currentHandle;
    if (!replaceValue) return "";
    try {
      const currentLower = String(currentHandle || "").toLowerCase();
      const findLower = String(findValue || "").toLowerCase();
      const matchIndex = currentLower.indexOf(findLower);
      if (matchIndex < 0) return "";
      return currentHandle.slice(0, matchIndex) + replaceValue + currentHandle.slice(matchIndex + findValue.length);
    } catch (_) {
      if (!currentHandle.includes(findValue)) return "";
      return currentHandle.replace(findValue, replaceValue);
    }
  }

  function sourceHandleContainsMatchesUrl(sourceMeta) {
    const findValue = collapseWhitespace(sourceMeta?.product_handle_contains || "");
    if (!findValue) return true;
    try {
      const currentHandle = String(currentStorefrontProductHandle() || "").trim().toLowerCase();
      return !!currentHandle && currentHandle.includes(findValue.toLowerCase());
    } catch (_) {
      return false;
    }
  }

  function shouldSkipRowImmediatelyForHandle(rowMeta, sourceItemsOverride) {
    const rowBlockType = String(rowMeta?.block_type || rowMeta?.blockType || "").trim().toLowerCase();
    const rowHandleContains = collapseWhitespace(rowMeta?.product_handle_contains || rowMeta?.productHandleContains || "");
    if (rowBlockType === "swatch_variant" && rowHandleContains && !sourceHandleContainsMatchesUrl({ product_handle_contains: rowHandleContains })) {
      return true;
    }

    const sourceItems = Array.isArray(sourceItemsOverride)
      ? sourceItemsOverride
      : (Array.isArray(rowItems(rowMeta)) ? rowItems(rowMeta) : []);
    const runtimeItems = sourceItems
      .map((item) => normalizeItem(item))
      .filter((item) => String(item?.type || "").trim().toLowerCase() === "current_product_variants_source");
    if (!runtimeItems.length) return false;

    const matchingRuntimeItems = runtimeItems.filter((item) => {
      const handleContains = collapseWhitespace(item?.product_handle_contains || "");
      if (!handleContains) return true;
      return sourceHandleContainsMatchesUrl(item);
    });

    return !matchingRuntimeItems.length;
  }

  function ensureSwatchVariantTargetProductLoaded(sourceMeta) {
    const targetHandle = collapseWhitespace(sourceMeta?.source_product_handle || "") || relatedProductHandleFromSource(sourceMeta);
    if (!targetHandle) return "";
    const cached = cachedProductDataForHandle(targetHandle);
    if (cached && typeof cached === "object") return targetHandle;
    Promise.resolve(loadProductDataForHandle(targetHandle)).then(() => {
      try {
        refreshAsyncProductDataRoots(document);
      } catch (_) { }
    }).catch(() => { });
    return "";
  }

  function shouldSkipSwatchVariantRow(rowMeta) {
    const handleContains = collapseWhitespace(rowMeta?.product_handle_contains || rowMeta?.productHandleContains || "");
    const sourceProductHandle = collapseWhitespace(rowMeta?.source_product_handle || rowMeta?.sourceProductHandle || "");
    if (!handleContains && !sourceProductHandle) return false;
    if (handleContains && !sourceHandleContainsMatchesUrl({ product_handle_contains: handleContains })) return true;
    if (handleContains && !collapseWhitespace(rowMeta?.find_product_handle_contains || rowMeta?.findProductHandleContains || "")) return true;
    const targetHandle = ensureSwatchVariantTargetProductLoaded({
      product_handle_contains: handleContains,
      find_product_handle_contains: collapseWhitespace(rowMeta?.find_product_handle_contains || rowMeta?.findProductHandleContains || ""),
      source_product_handle: sourceProductHandle
    });
    if (!targetHandle) return true;
    const productData = cachedProductDataForHandle(targetHandle);
    return !productData || !hasRealProductVariants(productData);
  }

  function cachedProductDataForHandle(handle) {
    const normalizedHandle = String(handle || "").trim();
    if (!normalizedHandle) return null;
    if (normalizedHandle === currentStorefrontProductHandle()) {
      return currentStorefrontProductData();
    }
    R.__productDataByHandle = R.__productDataByHandle || Object.create(null);
    return R.__productDataByHandle[normalizedHandle] || null;
  }

  async function loadProductDataForHandle(handle, force = false) {
    const normalizedHandle = String(handle || "").trim();
    if (!normalizedHandle) return null;
    if (normalizedHandle === currentStorefrontProductHandle()) {
      return loadCurrentStorefrontProductData(force);
    }

    R.__productDataByHandle = R.__productDataByHandle || Object.create(null);
    R.__productDataFetchCacheByHandle = R.__productDataFetchCacheByHandle || Object.create(null);

    if (!force && R.__productDataByHandle[normalizedHandle] && typeof R.__productDataByHandle[normalizedHandle] === "object") {
      return R.__productDataByHandle[normalizedHandle];
    }
    if (!force && R.__productDataFetchCacheByHandle[normalizedHandle]) {
      return R.__productDataFetchCacheByHandle[normalizedHandle];
    }

    const jsonUrl = productJsonUrlForHandle(normalizedHandle);
    if (!jsonUrl) return null;

    const request = fetch(jsonUrl, { credentials: "same-origin" })
      .then((res) => res.ok ? res.json() : null)
      .then((data) => {
        if (data && typeof data === "object") {
          R.__productDataByHandle[normalizedHandle] = data;
          return data;
        }
        return null;
      })
      .catch(() => null)
      .finally(() => {
        try { delete R.__productDataFetchCacheByHandle[normalizedHandle]; } catch (_) { }
      });

    R.__productDataFetchCacheByHandle[normalizedHandle] = request;
    return request;
  }

  function scheduleCurrentStorefrontProductRefresh() {
    if (Number(R.__suppressCurrentStorefrontRefresh || 0) > 0) return false;
    try {
      if (R.__currentStorefrontRefreshTimer) window.clearTimeout(R.__currentStorefrontRefreshTimer);
    } catch (_) { }
    R.__currentStorefrontRefreshTimer = window.setTimeout(async () => {
      try {
        const data = await loadCurrentStorefrontProductData();
        if (!data) return;
        try { syncCurrentProductSelections(document); } catch (_) { }
        try { applyPendingSelectedSwatches(document); } catch (_) { }
        try {
          const skipMainSection = Number(R.__skipMainProductRootRefreshUntil || 0) > Date.now()
            ? currentMainProductSection(document)
            : null;
          const rootsToRefresh = getRoots(document).filter((root) => {
            try {
              return !!root.__mgpsInit
                && rootContainsCurrentProductVariantSource(root);
            } catch (_) {
              return false;
            }
          }).filter((root) => {
            try {
              return !(skipMainSection && skipMainSection.contains && skipMainSection.contains(root));
            } catch (_) {
              return true;
            }
          });
          if (rootsToRefresh.length) refreshSpecificRoots(rootsToRefresh);
          else applyPendingSelectedSwatches(document);
        } catch (_) { }
      } catch (_) { }
    }, 60);
    return true;
  }

  function hasRealProductVariants(productData) {
    const variants = Array.isArray(productData?.variants) ? productData.variants : [];
    if (variants.length > 1) return true;
    if (variants.length !== 1) return false;
    const only = variants[0] || {};
    const title = collapseWhitespace(only.title || "");
    return !!title && title.toLowerCase() !== "default title";
  }

  function productJsonImageSrc(imageLike) {
    if (!imageLike) return "";
    if (typeof imageLike === "string") return safeSrc(imageLike);
    return safeSrc(
      imageLike.src
      || imageLike.url
      || imageLike.preview_image?.src
      || imageLike.previewImage?.src
      || ""
    );
  }

  function optionPositionFromProductData(productData, optionName) {
    const options = Array.isArray(productData?.options) ? productData.options : [];
    const wanted = String(optionName || "").trim().toLowerCase();
    if (!wanted) return options.length ? 0 : -1;
    for (let i = 0; i < options.length; i++) {
      if (String(options[i] || "").trim().toLowerCase() === wanted) return i;
    }
    return -1;
  }

  function variantDisplayTitleFromSource(variant, productData, sourceMeta) {
    const mode = String(sourceMeta?.variant_title_mode || "option_value").trim().toLowerCase();
    const prefix = String(sourceMeta?.variant_title_prefix || "");
    const optionIndex = optionPositionFromProductData(productData, sourceMeta?.variant_option_name);
    const variantOptions = Array.isArray(variant?.options) ? variant.options : [];

    let title = collapseWhitespace(variant?.title || "");
    if (mode === "option_value") {
      if (optionIndex >= 0 && variantOptions.length > optionIndex) title = collapseWhitespace(variantOptions[optionIndex] || "");
      else if (variantOptions.length === 1) title = collapseWhitespace(variantOptions[0] || "");
    } else if (mode === "product_plus_option") {
      let suffix = collapseWhitespace(variant?.title || "");
      if (optionIndex >= 0 && variantOptions.length > optionIndex) suffix = collapseWhitespace(variantOptions[optionIndex] || "");
      else if (variantOptions.length === 1) suffix = collapseWhitespace(variantOptions[0] || "");
      title = collapseWhitespace(String(productData?.title || "") + " - " + suffix);
    }
    return prefix ? (prefix + title) : title;
  }

  function storefrontUrlForHandle(handle, variantId) {
    const normalizedHandle = String(handle || "").trim();
    const normalizedVariantId = String(variantId || "").trim();
    try {
      const url = new URL(window.location.href);
      if (normalizedHandle) {
        url.pathname = "/products/" + encodeURIComponent(normalizedHandle);
      }
      if (normalizedVariantId) {
        url.searchParams.set("variant", normalizedVariantId);
      } else {
        url.searchParams.delete("variant");
      }
      return url.pathname + url.search + url.hash;
    } catch (_) {
      if (!normalizedHandle) return window.location.href;
      return "/products/" + encodeURIComponent(normalizedHandle)
        + (normalizedVariantId ? ("?variant=" + encodeURIComponent(normalizedVariantId)) : "");
    }
  }

  function expandCurrentProductVariantSource(sourceMeta) {
    const currentHandle = currentStorefrontProductHandle();
    const handleContains = collapseWhitespace(sourceMeta?.product_handle_contains || "");
    const sourceProductHandle = collapseWhitespace(sourceMeta?.source_product_handle || "");
    const fallbackSourceProductHandle = collapseWhitespace(sourceMeta?.fallback_source_product_handle || "");
    const fallbackHandle = isTrueLike(sourceMeta?.fallback_use_product_page_product) ? currentHandle : fallbackSourceProductHandle;
    const relatedHandle = relatedProductHandleFromSource(sourceMeta);
    let targetHandle = "";

    if (handleContains) {
      if (!sourceHandleContainsMatchesUrl(sourceMeta)) return { resolved: true, items: [] };
      targetHandle = relatedHandle;
    } else if (isTrueLike(sourceMeta?.use_product_page_product)) {
      targetHandle = currentHandle;
    } else {
      targetHandle = sourceProductHandle;
    }

    if (!targetHandle) {
      if (fallbackHandle) targetHandle = fallbackHandle;
      else return { resolved: true, items: [] };
    }
    let resolvedHandle = targetHandle;
    let productData = targetHandle === currentHandle
      ? currentStorefrontProductData()
      : cachedProductDataForHandle(targetHandle);

    if ((!productData || typeof productData !== "object") && fallbackHandle && fallbackHandle !== targetHandle) {
      resolvedHandle = fallbackHandle;
      productData = fallbackHandle === currentHandle
        ? currentStorefrontProductData()
        : cachedProductDataForHandle(fallbackHandle);
    }

    if (!productData || typeof productData !== "object") {
      if (targetHandle) {
        Promise.resolve(loadProductDataForHandle(targetHandle)).then((data) => {
          if (!data || typeof data !== "object") return;
          try {
            refreshAsyncProductDataRoots(document);
          } catch (_) { }
        }).catch(() => { });
      }
      if (fallbackHandle && fallbackHandle !== targetHandle) {
        Promise.resolve(loadProductDataForHandle(fallbackHandle)).then((data) => {
          if (!data || typeof data !== "object") return;
          try {
            refreshAsyncProductDataRoots(document);
          } catch (_) { }
        }).catch(() => { });
      }
      return { resolved: false, items: [] };
    }
    if (!hasRealProductVariants(productData)) {
      if (fallbackHandle && fallbackHandle !== resolvedHandle) {
        const fallbackProductData = fallbackHandle === currentHandle
          ? currentStorefrontProductData()
          : cachedProductDataForHandle(fallbackHandle);
        if (fallbackProductData && typeof fallbackProductData === "object" && hasRealProductVariants(fallbackProductData)) {
          resolvedHandle = fallbackHandle;
          productData = fallbackProductData;
        } else {
          if (fallbackHandle && fallbackHandle !== currentHandle) {
            Promise.resolve(loadProductDataForHandle(fallbackHandle)).then((data) => {
              if (!data || typeof data !== "object") return;
              try {
                refreshAsyncProductDataRoots(document);
              } catch (_) { }
            }).catch(() => { });
          }
          return { resolved: true, items: [] };
        }
      } else {
        return { resolved: true, items: [] };
      }
    }

    const baseImage = productJsonImageSrc(productData.featured_image || productData.featuredImage || "");
    const variants = Array.isArray(productData.variants) ? productData.variants : [];
    const optionIndex = optionPositionFromProductData(productData, sourceMeta?.variant_option_name);
    const currentVariantId = currentStorefrontVariantId();
    const currentProductData = currentStorefrontProductData();
    const currentProductOptionIndex = currentProductData
      ? optionPositionFromProductData(currentProductData, sourceMeta?.variant_option_name)
      : -1;
    let currentOptionValue = "";

    if (currentProductOptionIndex >= 0 && currentVariantId && currentProductData) {
      const currentVariants = Array.isArray(currentProductData?.variants) ? currentProductData.variants : [];
      const currentVariant = currentVariants.find((variant) => String(variant?.id || "").trim() === currentVariantId);
      const currentVariantOptions = Array.isArray(currentVariant?.options) ? currentVariant.options : [];
      if (currentVariantOptions.length > currentProductOptionIndex) {
        currentOptionValue = collapseWhitespace(currentVariantOptions[currentProductOptionIndex] || "");
      }
    }

    if (!currentOptionValue) {
      currentOptionValue = collapseWhitespace(sourceMeta?.current_option_value || "");
    }

    const items = variants.map((variant) => {
      const title = variantDisplayTitleFromSource(variant, productData, sourceMeta);
      const imageSrc = productJsonImageSrc(variant?.featured_image || variant?.featuredImage || "") || baseImage;
      const href = storefrontUrlForHandle(resolvedHandle, String(variant.id || ""));
      const variantOptions = Array.isArray(variant?.options) ? variant.options : [];
      const variantOptionValue = optionIndex >= 0 && variantOptions.length > optionIndex
        ? collapseWhitespace(variantOptions[optionIndex] || "")
        : "";
      const isCurrent = currentOptionValue && variantOptionValue
        ? variantOptionValue === currentOptionValue
        : (!!currentVariantId && resolvedHandle === currentHandle && String(variant?.id || "").trim() === currentVariantId);
      return {
        type: "product",
        swatch_mode: true,
        title,
        alt: title || collapseWhitespace(productData.title || ""),
        thumbnail: imageSrc,
        thumb_mode: "default",
        product_image_id: "",
        product_image_url: imageSrc,
        product_url: href,
        product_id: productData.id ?? null,
        product_variant_id: variant?.id ?? null,
        current_product: isCurrent,
        is_selected: isCurrent,
        show_price: isTrueLike(sourceMeta?.show_price),
        show_reviews: false,
        show_shop_button: false,
        buttons_over_image: false,
        price: formatMoneyCents(variant?.price),
        price_num: Number.isFinite(Number(variant?.price)) ? (Number(variant.price) / 100) : null,
        available: !!variant?.available,
        vjust: "center",
        html_desc: "",
        desc_html: "",
        margin_top: 0,
        margin_bottom: 0,
        open_set_key: "",
        learn_more_text: "",
        cta: {
          href,
          text: "Shop"
        }
      };
    });
    return { resolved: true, items };
  }

  function expandRuntimeRowItems(list) {
    const arr = Array.isArray(list) ? list : [];
    const out = [];
    let pending = false;

    for (const item of arr) {
      const normalized = normalizeItem(item);
      if (!normalized) continue;
      if (String(normalized.type || "").trim().toLowerCase() !== "current_product_variants_source") {
        out.push(item);
        continue;
      }

      const handleContains = collapseWhitespace(normalized.product_handle_contains || "");
      if (handleContains && !sourceHandleContainsMatchesUrl(normalized)) {
        continue;
      }

      const result = expandCurrentProductVariantSource(normalized);
      if (result && result.resolved === false) {
        pending = true;
        continue;
      }
      if (result && result.resolved && Array.isArray(result.items) && result.items.length) {
        out.push(...result.items);
      }
    }

    if (pending) {
      out.length = 0;
      out.__pendingRuntime = true;
      return out;
    }

    return out;
  }

  function normalizeItems(list, opts = {}) {
    const arr = Array.isArray(list) ? list : [];
    const out = [];
    for (const it of arr) {
      const normalized = normalizeItem(it, opts);
      if (normalized) out.push(normalized);
    }
    return out;
  }

  function rowItems(row) {
    return row?.swatches || row?.videos || row?.items || row?.cards || [];
  }

  function rowsContainCurrentProductVariantSource(rows) {
    const arr = Array.isArray(rows) ? rows : [];
    return arr.some((row) => {
      const items = Array.isArray(rowItems(row)) ? rowItems(row) : [];
      return items.some((item) => String(item?.type || item?.kind || "").trim().toLowerCase() === "current_product_variants_source");
    });
  }

  function rawRowsForSetLookup(key) {
    const setKey = resolveExistingSetKey(key);
    if (!setKey) return [];
    if (Object.prototype.hasOwnProperty.call(R.__rawSpecs, setKey)) {
      return coerceToRows(R.__rawSpecs[setKey] && R.__rawSpecs[setKey].rows);
    }
    const store = getSetStore();
    const value = store[setKey];
    const payload = getSetPayload(value);
    return coerceToRows(payload ? payload.rows : value);
  }

  function getPreferredStoreValue(setKey, preferMediaGallerySets) {
    const key = resolveExistingSetKey(setKey);
    if (!key) return undefined;
    if (preferMediaGallerySets) {
      try {
        const mediaStore = window.MEDIA_GALLERY_SETS;
        if (mediaStore && typeof mediaStore === "object" && Object.prototype.hasOwnProperty.call(mediaStore, key)) {
          return mediaStore[key];
        }
      } catch (_) { }
    }
    const store = getSetStore();
    return store ? store[key] : undefined;
  }

  function rowContainsCurrentProductVariantSourceRaw(row) {
    const items = Array.isArray(rowItems(row)) ? rowItems(row) : [];
    return items.some((item) => String(item?.type || item?.kind || "").trim().toLowerCase() === "current_product_variants_source");
  }

  function setContainsCurrentProductVariantSourceRaw(key, stack) {
    const setKey = resolveExistingSetKey(key);
    if (!setKey) return false;
    const seen = stack instanceof Set ? stack : new Set();
    if (seen.has(setKey)) return false;
    seen.add(setKey);

    const rows = rawRowsForSetLookup(setKey);
    const found = rows.some((row) => {
      if (!row || typeof row !== "object") return false;
      if (rowContainsCurrentProductVariantSourceRaw(row)) return true;
      const importKey = resolveExistingSetKey(row.__import_set || "");
      return importKey ? setContainsCurrentProductVariantSourceRaw(importKey, seen) : false;
    });

    seen.delete(setKey);
    return found;
  }

  function rowHasAsyncProductDataDependencyRaw(row) {
    if (!row || typeof row !== "object") return false;
    if (rowContainsCurrentProductVariantSourceRaw(row)) return true;

    const blockType = String(row.block_type || row.blockType || "").trim().toLowerCase();
    if (blockType !== "swatch_variant") return false;

    const sourceProductHandle = collapseWhitespace(row.source_product_handle || row.sourceProductHandle || "");
    const handleContains = collapseWhitespace(row.product_handle_contains || row.productHandleContains || "");
    return !!(sourceProductHandle || handleContains);
  }

  function setHasAsyncProductDataDependencyRaw(key, stack) {
    const setKey = resolveExistingSetKey(key);
    if (!setKey) return false;
    const seen = stack instanceof Set ? stack : new Set();
    if (seen.has(setKey)) return false;
    seen.add(setKey);

    const rows = rawRowsForSetLookup(setKey);
    const found = rows.some((row) => {
      if (!row || typeof row !== "object") return false;
      if (rowHasAsyncProductDataDependencyRaw(row)) return true;
      const importKey = resolveExistingSetKey(row.__import_set || "");
      return importKey ? setHasAsyncProductDataDependencyRaw(importKey, seen) : false;
    });

    seen.delete(setKey);
    return found;
  }

  function createAsyncProductDependencyBucket() {
    return {
      needsCurrentProduct: false,
      handles: new Set()
    };
  }

  function addAsyncProductHandle(bucket, handle) {
    const normalizedHandle = collapseWhitespace(handle || "");
    if (!bucket || !normalizedHandle) return;
    bucket.handles.add(normalizedHandle);
  }

  function addCurrentProductDependency(bucket) {
    if (!bucket) return;
    bucket.needsCurrentProduct = true;
    const currentHandle = currentStorefrontProductHandle();
    if (currentHandle) bucket.handles.add(currentHandle);
  }

  function collectVariantSourceDependencies(sourceMeta, bucket) {
    if (!sourceMeta || !bucket) return;

    const handleContains = collapseWhitespace(sourceMeta.product_handle_contains || sourceMeta.productHandleContains || "");
    const explicitSourceHandle = collapseWhitespace(sourceMeta.source_product_handle || sourceMeta.sourceProductHandle || "");
    const fallbackSourceHandle = collapseWhitespace(sourceMeta.fallback_source_product_handle || sourceMeta.fallbackSourceProductHandle || "");

    if (isTrueLike(sourceMeta.use_product_page_product)) {
      addCurrentProductDependency(bucket);
    } else if (handleContains) {
      if (sourceHandleContainsMatchesUrl(sourceMeta)) {
        addAsyncProductHandle(bucket, relatedProductHandleFromSource(sourceMeta));
      }
    } else {
      addAsyncProductHandle(bucket, explicitSourceHandle);
    }

    if (isTrueLike(sourceMeta.fallback_use_product_page_product)) {
      addCurrentProductDependency(bucket);
    } else {
      addAsyncProductHandle(bucket, fallbackSourceHandle);
    }
  }

  function collectSwatchVariantRowDependencies(row, bucket) {
    if (!row || !bucket) return;

    const sourceProductHandle = collapseWhitespace(row.source_product_handle || row.sourceProductHandle || "");
    if (sourceProductHandle) {
      addAsyncProductHandle(bucket, sourceProductHandle);
      return;
    }

    const handleContains = collapseWhitespace(row.product_handle_contains || row.productHandleContains || "");
    if (!handleContains) return;
    if (!sourceHandleContainsMatchesUrl({ product_handle_contains: handleContains })) return;

    addAsyncProductHandle(bucket, relatedProductHandleFromSource({
      product_handle_contains: handleContains,
      find_product_handle_contains: collapseWhitespace(row.find_product_handle_contains || row.findProductHandleContains || "")
    }));
  }

  function collectAsyncProductDependenciesFromSetRows(rows, bucket, stack) {
    const arr = Array.isArray(rows) ? rows : [];
    const out = bucket || createAsyncProductDependencyBucket();
    const seen = stack instanceof Set ? stack : new Set();

    arr.forEach((row) => {
      if (!row || typeof row !== "object") return;

      if (rowHasAsyncProductDataDependencyRaw(row)) {
        const blockType = String(row.block_type || row.blockType || "").trim().toLowerCase();
        if (blockType === "swatch_variant") collectSwatchVariantRowDependencies(row, out);

        const items = Array.isArray(rowItems(row)) ? rowItems(row) : [];
        items.forEach((item) => {
          if (String(item?.type || item?.kind || "").trim().toLowerCase() !== "current_product_variants_source") return;
          collectVariantSourceDependencies(item, out);
        });
      }

      const importKey = resolveExistingSetKey(row.__import_set || "");
      if (!importKey || seen.has(importKey)) return;
      seen.add(importKey);
      collectAsyncProductDependenciesFromSetRows(rawRowsForSetLookup(importKey), out, seen);
      seen.delete(importKey);
    });

    return out;
  }

  function isRowLike(value) {
    return !!(value && typeof value === "object" && (Array.isArray(value.swatches) || Array.isArray(value.videos) || Array.isArray(value.items) || Array.isArray(value.cards)));
  }

  function cloneDeep(value) {
    try { return JSON.parse(JSON.stringify(value)); } catch (_) { return value; }
  }

  function getSetPayload(value) {
    if (value && typeof value === "object" && !Array.isArray(value) && Array.isArray(value.rows)) {
      return value;
    }
    return null;
  }

  function getSetMeta(value) {
    const payload = getSetPayload(value);
    if (!payload || !payload.meta || typeof payload.meta !== "object") return {};
    return Object.assign({}, payload.meta);
  }

  function normalizeSetLookupKey(raw) {
    let key = String(raw == null ? "" : raw)
      .replace(/[\u200B-\u200D\uFEFF]/g, "")
      .replace(/\u00A0/g, " ")
      .replace(/[‐‑‒–—―]/g, "-")
      .replace(/[“”„‟«»]/g, '"')
      .replace(/[‘’‚‛‹›]/g, "'")
      .trim();
    if (!key) return "";

    const parsed = safeJsonParse(key);
    if (typeof parsed === "string") {
      key = String(parsed || "").trim();
    } else if (Array.isArray(parsed) && parsed.length === 1 && typeof parsed[0] === "string") {
      key = String(parsed[0] || "").trim();
    }

    if ((key.startsWith('"') && key.endsWith('"')) || (key.startsWith("'") && key.endsWith("'")) || (key.startsWith("`") && key.endsWith("`"))) {
      key = key.slice(1, -1).trim();
    }

    return key;
  }

  function resolveExistingSetKey(raw) {
    const requested = normalizeSetLookupKey(raw);
    if (!requested) return "";

    if (Object.prototype.hasOwnProperty.call(R.__rawSpecs, requested)) return requested;

    const store = getSetStore();
    if (Object.prototype.hasOwnProperty.call(store, requested)) return requested;

    const requestedLower = requested.toLowerCase();
    const candidates = [
      ...Object.keys(R.__rawSpecs || {}),
      ...Object.keys(store || {})
    ];

    for (const candidate of candidates) {
      if (String(candidate || "").trim().toLowerCase() === requestedLower) {
        return candidate;
      }
    }

    return requested;
  }

  function firstResolvedRowFromSet(key) {
    const setKey = resolveExistingSetKey(key);
    if (!setKey) return null;
    try {
      const rows = resolveSet(setKey, new Set());
      return Array.isArray(rows) && rows.length ? rows[0] : null;
    } catch (_) {
      return null;
    }
  }

  function firstResolvedItemFromSet(key) {
    const row = firstResolvedRowFromSet(key);
    if (!row) return null;
      const items = normalizeItems(rowItems(row));
    return items.find((it) => {
      const t = String(it?.type || "").trim().toLowerCase();
      return t === "product" || t === "image";
    }) || null;
  }

  function matchedPresetPopupRemainingTriggerSettings(key) {
    const row = firstResolvedRowFromSet(key);
    if (!row || typeof row !== "object") return null;

    const buttonJustify = String(row.preset_button_heading_justify || row.heading_justify || "center").trim().toLowerCase() || "center";
    const rowCornerRadius = (() => {
      const value = Number(row.corner_radius_px);
      return Number.isFinite(value) && value >= 0 ? value : 12;
    })();

    return {
      button_style: normalizePresetButtonStyle(row.preset_button_style || "dropdown_box", "dropdown_box"),
      button_appearance_source: "custom",
      button_width_percent: normalizePresetButtonWidthPercent(row.preset_button_width_percent ?? row.button_width_percent, 0),
      button_max_width_px: parsePixelValue(row.preset_button_max_width_px ?? row.button_max_width_px, 0),
      button_justify: buttonJustify,
      preset_button_heading_justify: buttonJustify,
      preset_button_image_height_mobile: parsePixelValue(row.preset_button_image_height_mobile ?? row.button_image_height_mobile ?? row.preset_button_image_height ?? row.button_image_height, 0),
      preset_button_image_height_desktop: parsePixelValue(row.preset_button_image_height_desktop ?? row.button_image_height_desktop ?? row.preset_button_image_height_mobile ?? row.button_image_height_mobile ?? row.preset_button_image_height ?? row.button_image_height, 0),
      preset_button_border_color: collapseWhitespace(row.preset_button_border_color || ""),
      preset_button_border_size: clampNumber(row.preset_button_border_size, 0, 20, 1),
      preset_button_shadow_size: clampNumber(row.preset_button_shadow_size, 0, 60, 0),
      preset_button_border_radius_px: clampNumber(row.preset_button_border_radius_px, 0, 240, 4),
      preset_button_background_color: collapseWhitespace(row.preset_button_background_color || ""),
      preset_button_text_color: collapseWhitespace(row.preset_button_text_color || ""),
      preset_button_gradient_color: collapseWhitespace(row.preset_button_gradient_color || ""),
      preset_button_gradient_angle: clampNumber(row.preset_button_gradient_angle, 0, 360, 180),
      preset_button_background_image: safeSrc(row.preset_button_background_image || ""),
      preset_button_background_image_style: normalizeBackgroundImageStyle(row.preset_button_background_image_style, "center"),
      preset_button_text_size_mobile: clampNumber(row.preset_button_text_size_mobile, 0, 48, 0),
      preset_button_text_size_desktop: clampNumber(row.preset_button_text_size_desktop, 0, 48, 0),
      preset_button_text_behavior: String(row.preset_button_text_behavior || "wrap_text").trim().toLowerCase() || "wrap_text",
      preset_button_text_style: String(row.preset_button_text_style || "normal").trim().toLowerCase() || "normal",
      preset_button_image_radius_px: clampNumber(row.preset_button_image_radius_px, 0, 240, rowCornerRadius),
      preset_button_product_image_padding: clampNumber(row.preset_button_product_image_padding, 0, 120, 0),
      preset_button_border_scope: normalizeBorderScope(row.preset_button_border_scope, "image_text")
    };
  }

  function resolveSetMeta(key, stack) {
    const setKey = resolveExistingSetKey(key);
    if (!setKey) return {};

    const seen = stack instanceof Set ? stack : new Set();
    if (seen.has(setKey)) return {};
    seen.add(setKey);

    const sourceValue = Object.prototype.hasOwnProperty.call(R.__rawSpecs, setKey)
      ? R.__rawSpecs[setKey]
      : getSetStore()[setKey];

    let meta = cloneDeep(getSetMeta(sourceValue)) || {};
    const matchedSettingsKey = resolveExistingSetKey(meta.match_settings_preset_key || meta.matchPresetSettingsKey || "");
    if (matchedSettingsKey) {
      const matchedMeta = resolveSetMeta(matchedSettingsKey, seen);
      if (!isNonEmptyObject(meta.appearance) && isNonEmptyObject(matchedMeta.appearance)) meta.appearance = cloneDeep(matchedMeta.appearance);
      if (!isNonEmptyObject(meta.selected_appearance) && isNonEmptyObject(matchedMeta.selected_appearance)) meta.selected_appearance = cloneDeep(matchedMeta.selected_appearance);
      const matchedCorner = Number(matchedMeta.corner_radius_px);
      if (!Number.isFinite(Number(meta.corner_radius_px)) && Number.isFinite(matchedCorner) && matchedCorner >= 0) meta.corner_radius_px = matchedCorner;
    }
    const rawRows = coerceToRows(sourceValue);

    for (const rawRow of rawRows) {
      if (!rawRow || typeof rawRow !== "object") continue;
      const importKey = resolveExistingSetKey(rawRow.__import_set || "");
      if (importKey) {
        const importedMeta = resolveSetMeta(importKey, seen);
        if (!isNonEmptyObject(meta.appearance) && isNonEmptyObject(importedMeta.appearance)) meta.appearance = cloneDeep(importedMeta.appearance);
        if (!isNonEmptyObject(meta.selected_appearance) && isNonEmptyObject(importedMeta.selected_appearance)) meta.selected_appearance = cloneDeep(importedMeta.selected_appearance);
        const importedCorner = Number(importedMeta.corner_radius_px);
        if (!Number.isFinite(Number(meta.corner_radius_px)) && Number.isFinite(importedCorner) && importedCorner >= 0) meta.corner_radius_px = importedCorner;
      }

      if (!isNonEmptyObject(meta.appearance) && appearanceHasVisualOverrides(rawRow.appearance)) meta.appearance = cloneDeep(rawRow.appearance);
      if (!isNonEmptyObject(meta.selected_appearance) && appearanceHasVisualOverrides(rawRow.selected_appearance)) meta.selected_appearance = cloneDeep(rawRow.selected_appearance);
      const rowCorner = Number(rawRow.corner_radius_px);
      if (!Number.isFinite(Number(meta.corner_radius_px)) && Number.isFinite(rowCorner) && rowCorner >= 0) meta.corner_radius_px = rowCorner;
    }

    seen.delete(setKey);
    return meta;
  }

  function coerceToRows(value) {
    if (!value) return [];

    const payload = getSetPayload(value);
    if (payload) value = payload.rows;

    if (Array.isArray(value)) {
      if (value.length && isRowLike(value[0])) {
        return value
          .map((row) => {
            if (!row || typeof row !== "object") return null;
            const copy = Object.assign({}, row);
            copy.videos = normalizeItems(rowItems(row));
            delete copy.items;
            delete copy.cards;
            return copy;
          })
          .filter(Boolean);
      }

      const items = normalizeItems(value);
      if (!items.length) return [];
      return [{
        heading: "",
        subheading: "",
        img_ratio: "1:1",
        row_height: 0,
        fit_row: false,
        margin_top: 0,
        margin_bottom: 0,
        swatch_row: true,
        row_justify: "center",
        heading_justify: "center",
        videos: items
      }];
    }

    if (typeof value === "object") {
      if (isRowLike(value)) {
        const copy = Object.assign({}, value);
        copy.videos = normalizeItems(rowItems(value));
        delete copy.items;
        delete copy.cards;
        return [copy];
      }
      const item = normalizeItem(value);
      if (!item) return [];
      return [{
        heading: "",
        subheading: "",
        img_ratio: "1:1",
        row_height: 0,
        fit_row: false,
        margin_top: 0,
        margin_bottom: 0,
        swatch_row: true,
        row_justify: "center",
        heading_justify: "center",
        videos: [item]
      }];
    }

    return [];
  }

  function normalizeRow(rowSpec, opts = {}) {
    const sourceRow = Object.assign({}, rowSpec || {});
    const disableMatchedPresetRowMerge = !!(opts && opts.disableMatchedPresetRowMerge);
    const matchedRowKey = disableMatchedPresetRowMerge
      ? ""
      : resolveExistingSetKey(
        sourceRow.match_settings_preset_key ||
        sourceRow.matchPresetSettingsKey ||
        opts.matchSettingsPresetKey ||
        ""
      );
    const matchedRow = matchedRowKey ? firstResolvedRowFromSet(matchedRowKey) : null;
    const row = (() => {
      if (!matchedRowKey) return sourceRow;
      if (!matchedRow || typeof matchedRow !== "object") return sourceRow;
      const mergedRow = Object.assign({}, matchedRow, stripMatchedPresetRowSettings(sourceRow));
      if (Object.prototype.hasOwnProperty.call(sourceRow, "heading")) mergedRow.heading = sourceRow.heading;
      if (Object.prototype.hasOwnProperty.call(sourceRow, "subheading")) mergedRow.subheading = sourceRow.subheading;
      mergedRow.videos = rowItems(sourceRow);
      mergedRow.swatches = rowItems(sourceRow);
      if (Object.prototype.hasOwnProperty.call(sourceRow, "match_settings_preset_key")) mergedRow.match_settings_preset_key = sourceRow.match_settings_preset_key;
      if (Object.prototype.hasOwnProperty.call(sourceRow, "matchPresetSettingsKey")) mergedRow.matchPresetSettingsKey = sourceRow.matchPresetSettingsKey;
      return mergedRow;
    })();
    const rowDisplayType = String(
      row.row_display_type ||
      row.rowDisplayType ||
      (row.fit_row ? "scale_to_fit" : "scrollable")
    ).trim().toLowerCase() || "scrollable";
    const normalAppearance = row.appearance || row.swatch_appearance || row.__appearance || null;
    const selectedAppearance = row.selected_appearance || row.selectedAppearance || row.swatch_selected_appearance || row.__selectedAppearance || null;
    const hasExplicitNormalAppearance = appearanceHasVisualOverrides(normalAppearance);
    const hasExplicitSelectedAppearance = appearanceHasVisualOverrides(selectedAppearance);
    const normalizedAppearance = hasExplicitNormalAppearance ? normalizeSwatchAppearance(normalAppearance, "image") : null;
    const normalizedSelectedAppearance = hasExplicitSelectedAppearance
      ? normalizeSwatchAppearance(selectedAppearance, normalizedAppearance && normalizedAppearance.border_scope ? normalizedAppearance.border_scope : "image")
      : null;
    if (normalizedSelectedAppearance && normalizedAppearance && normalizedAppearance.border_scope) {
      normalizedSelectedAppearance.border_scope = normalizedSelectedAppearance.border_scope || normalizedAppearance.border_scope;
    }
    const isSwatchVariantRow = String(row.block_type || row.blockType || "").trim().toLowerCase() === "swatch_variant";
    const sourceItems = Array.isArray(rowItems(row)) ? rowItems(row) : [];
    const skipRowImmediatelyForHandle = shouldSkipRowImmediatelyForHandle(row, sourceItems);
    if (skipRowImmediatelyForHandle) {
      return {
        block_type: String(row.block_type || row.blockType || "").trim().toLowerCase(),
        heading: "",
        subheading: "",
        videos: [],
        swatches: [],
        __skipRender: true
      };
    }
    const skipSwatchVariantRowForHandle = isSwatchVariantRow && shouldSkipSwatchVariantRow(row);
    const skipCurrentProductVariantsSource = sourceItems.some((item) => {
      const normalizedItem = normalizeItem(item, { matchSettingsPresetKey: matchedRowKey });
      if (!normalizedItem) return false;
      if (String(normalizedItem.type || "").trim().toLowerCase() !== "current_product_variants_source") return false;
      if (!collapseWhitespace(normalizedItem.product_handle_contains || "")) return false;
      return !sourceHandleContainsMatchesUrl(normalizedItem);
    });
    const containsCurrentProductVariantsSource = sourceItems.some((item) => String(item?.type || item?.kind || "").trim().toLowerCase() === "current_product_variants_source");
    const expandedRuntimeItems = expandRuntimeRowItems(sourceItems);
    const pendingRuntimeItems = !!(expandedRuntimeItems && expandedRuntimeItems.__pendingRuntime);
    const normalizedItems = normalizeItems(expandedRuntimeItems, { matchSettingsPresetKey: matchedRowKey });
    const suppressInlineSubheading = containsCurrentProductVariantsSource && !row.preset_button;
    const normalizedRowSubheading = suppressInlineSubheading
      ? ""
      : (typeof row.subheading === "string" ? row.subheading : "");
    const hasExplicitRowSwatchImageZoom =
      row.swatch_image_zoom != null
      || row.swatchImageZoom != null
      || row.product_image_scale != null
      || row.productImageScale != null
      || row.scale != null;
    const rowSwatchImageZoom = hasExplicitRowSwatchImageZoom
      ? (row.swatch_image_zoom ?? row.swatchImageZoom ?? row.product_image_scale ?? row.productImageScale ?? row.scale ?? 100)
      : null;
    const rowSwatchImageSizePercent = row.swatch_image_size_percent ?? row.swatchImageSizePercent ?? 100;
    const rowSwatchImageIndexOverrides = collectSwatchImageIndexOverrides(row);
    const getImageSizesFromPresetSettings =
      row.get_image_sizes_from_preset_settings === true
      || row.getImageSizesFromPresetSettings === true;
    const useMatchedPresetItemImageSizeOverrides =
      getImageSizesFromPresetSettings
      &&
      !!matchedRowKey
      && !!matchedRow
      && containsCurrentProductVariantsSource
      && !isSwatchVariantRow;
    const matchedPresetItemImageSizeOverrides = useMatchedPresetItemImageSizeOverrides
      ? collectMatchedPresetItemImageSizeOverrides(matchedRow)
      : [];
    const rowRandomZoomMax = row.random_zoom_max ?? row.randomZoomMax ?? 0;
    const rowSwatchVerticalJustify = resolveMatchedRowSwatchVerticalJustify(sourceRow, matchedRow, !!matchedRowKey);
    const rowRandomizeZoomArea = row.randomize_zoom_area ?? row.randomizeZoomArea ?? false;
    normalizedItems.forEach((item) => {
      if (!Object.prototype.hasOwnProperty.call(item, "__rowSwatchImageSizePercent")) item.__rowSwatchImageSizePercent = rowSwatchImageSizePercent;
      if (rowSwatchImageZoom != null && !Object.prototype.hasOwnProperty.call(item, "__rowSwatchImageZoom")) item.__rowSwatchImageZoom = rowSwatchImageZoom;
      if (!Object.prototype.hasOwnProperty.call(item, "__rowSwatchVerticalJustify")) item.__rowSwatchVerticalJustify = rowSwatchVerticalJustify;
      if (!Object.prototype.hasOwnProperty.call(item, "__rowRandomZoomMax")) item.__rowRandomZoomMax = rowRandomZoomMax;
      if (!Object.prototype.hasOwnProperty.call(item, "__rowRandomizeZoomArea")) item.__rowRandomizeZoomArea = rowRandomizeZoomArea;
    });
    applySwatchImageSizeIndexOverrides(
      normalizedItems,
      matchedPresetItemImageSizeOverrides.length ? matchedPresetItemImageSizeOverrides : rowSwatchImageIndexOverrides
    );
    const presetButtonAppearance = row.preset_button && matchedRowKey && normalizedAppearance
      ? normalizedAppearance
      : null;
    const presetButtonBorderColor = collapseWhitespace(row.preset_button_border_color || "")
      || (presetButtonAppearance ? collapseWhitespace(presetButtonAppearance.border_color || "") : "");
    const presetButtonBackgroundColor = collapseWhitespace(row.preset_button_background_color || "")
      || (presetButtonAppearance ? collapseWhitespace(presetButtonAppearance.background_color || "") : "");
    const presetButtonTextColor = collapseWhitespace(row.preset_button_text_color || "")
      || (presetButtonAppearance ? collapseWhitespace(presetButtonAppearance.text_color || "") : "");
    const presetButtonGradientColor = collapseWhitespace(row.preset_button_gradient_color || "")
      || (presetButtonAppearance ? collapseWhitespace(presetButtonAppearance.gradient_color || "") : "");
    const presetButtonBackgroundImage = safeSrc(row.preset_button_background_image || "")
      || (presetButtonAppearance ? safeSrc(presetButtonAppearance.background_image || "") : "");
    const presetButtonBorderRadiusFallback = presetButtonAppearance ? presetButtonAppearance.border_radius_px : 4;
    const presetButtonImageRadiusFallback = presetButtonAppearance
      ? presetButtonAppearance.image_radius_px
      : clampNumber(row.preset_button_border_radius_px, 0, 240, 4);

    return {
      block_type: String(row.block_type || row.blockType || "").trim().toLowerCase(),
      heading: typeof row.heading === "string" ? row.heading : "",
      subheading: normalizedRowSubheading,
      heading_justify: String(row.heading_justify || "center").trim() || "center",
      __has_heading_justify_override: typeof row.heading_justify === "string" && String(row.heading_justify).trim() !== "",
      img_ratio: String(row.img_ratio || "1:1").trim() || "1:1",
      row_height: Math.max(0, Number((row.row_height_desktop ?? row.row_height ?? 0)) || 0),
      row_height_mobile: Math.max(0, Number(row.row_height_mobile || 0) || 0),
      row_height_desktop: Math.max(0, Number((row.row_height_desktop ?? row.row_height ?? 0)) || 0),
      corner_radius_px: (() => { const v = Number(row.corner_radius_px); return Number.isFinite(v) && v >= 0 ? v : 12; })(),
      fit_row: rowDisplayType === "scale_to_fit",
      row_display_type_mobile: String(row.row_display_type_mobile || rowDisplayType).trim().toLowerCase() || rowDisplayType,
      row_display_type_desktop: String(row.row_display_type_desktop || rowDisplayType).trim().toLowerCase() || rowDisplayType,
      row_display_type: rowDisplayType,
      swatches_per_row_mobile: Math.max(0, Number(row.swatches_per_row_mobile || row.swatchesPerRowMobile || 0) || 0),
      swatches_per_row_desktop: Math.max(0, Number(row.swatches_per_row_desktop || row.swatchesPerRowDesktop || row.swatches_per_row || row.swatchesPerRow || 0) || 0),
      swatches_per_row: Math.max(0, Number(row.swatches_per_row_desktop || row.swatchesPerRowDesktop || row.swatches_per_row || row.swatchesPerRow || 0) || 0),
      padding_between_rows_mobile: Math.max(0, Number(row.padding_between_rows_mobile || row.paddingBetweenRowsMobile || 0) || 0),
      padding_between_rows_desktop: Math.max(0, Number(row.padding_between_rows_desktop || row.paddingBetweenRowsDesktop || row.padding_between_rows || row.paddingBetweenRows || 0) || 0),
      padding_between_rows: Math.max(0, Number(row.padding_between_rows_desktop || row.paddingBetweenRowsDesktop || row.padding_between_rows || row.paddingBetweenRows || 0) || 0),
      more_popup_text: typeof row.more_popup_text === "string" ? row.more_popup_text : "More",
      margin_top: Math.max(0, Number(row.margin_top || 0) || 0),
      margin_bottom: Math.max(0, Number(row.margin_bottom || 0) || 0),
      swatch_image_size_percent: clampNumber(row.swatch_image_size_percent ?? row.swatchImageSizePercent, 1, 100, 100),
      swatch_image_index_overrides: rowSwatchImageIndexOverrides,
      swatch_vertical_justify: rowSwatchVerticalJustify,
      swatch_row: !!row.swatch_row,
      row_justify: String(row.row_justify || "center").trim() || "center",
      custom_html: typeof row.custom_html === "string" ? row.custom_html : "",
      custom_template_id: String(row.custom_template_id || "").trim(),
      custom_width_desktop_percent: clampNumber(row.custom_width_desktop_percent, 10, 100, 100),
      custom_width_mobile_percent: clampNumber(row.custom_width_mobile_percent, 10, 100, 100),
      custom_max_width_px: parsePixelValue(row.custom_max_width_px, 0),
      popup_padding_between_rows: Math.max(0, Number(row.popup_padding_between_rows || row.popupPaddingBetweenRows || 0) || 0),
      button_switch: !!row.button_switch,
      button_switch_rules: Array.isArray(row.button_switch_rules)
        ? row.button_switch_rules.map((rule) => ({
          if_handle_contains: collapseWhitespace(rule?.if_handle_contains || rule?.ifHandleContains || ""),
          button_text: typeof rule?.button_text === "string" ? rule.button_text : "",
          button_subtext: typeof rule?.button_subtext === "string" ? rule.button_subtext : "",
          replace_with: collapseWhitespace(rule?.replace_with || rule?.replaceWith || "")
        }))
        : [],
      preset_button: !!row.preset_button,
      preset_button_text: typeof row.preset_button_text === "string" ? row.preset_button_text : (typeof row.heading === "string" ? row.heading : "Open Preset"),
      preset_modal_title: typeof row.preset_modal_title === "string" ? row.preset_modal_title : "",
      preset_hide_modal_header: !!row.preset_hide_modal_header,
      preset_button_set: resolveExistingSetKey(row.preset_button_set || row.__preset_button_set || row.__import_set || ""),
      preset_button_href: safeLink(row.preset_button_href || row.button_href || ""),
      preset_button_style: normalizePresetButtonStyle(row.preset_button_style || "dropdown_box", "dropdown_box"),
      preset_button_subtext: typeof row.preset_button_subtext === "string" ? row.preset_button_subtext : normalizedRowSubheading,
      preset_button_image: safeSrc(row.preset_button_image || row.preset_button_image_url || row.button_image || row.button_image_url || ""),
      preset_button_image_alt: String(row.preset_button_image_alt || row.button_image_alt || "").trim(),
      preset_button_image_height_mobile: parsePixelValue(row.preset_button_image_height_mobile ?? row.button_image_height_mobile ?? row.preset_button_image_height ?? row.button_image_height, 0),
      preset_button_image_height_desktop: parsePixelValue(row.preset_button_image_height_desktop ?? row.button_image_height_desktop ?? row.preset_button_image_height ?? row.button_image_height, 0),
      preset_button_width_percent: normalizePresetButtonWidthPercent(row.preset_button_width_percent ?? row.button_width_percent, 0),
      preset_button_max_width_px: parsePixelValue(row.preset_button_max_width_px ?? row.button_max_width_px, 0),
      preset_button_padding_x_px: clampNumber(row.preset_button_padding_x_px, 0, 120, 0),
      preset_button_padding_y_px: clampNumber(row.preset_button_padding_y_px, 0, 120, 0),
        preset_button_heading_justify: String(row.preset_button_heading_justify || row.heading_justify || "center").trim().toLowerCase(),
        preset_button_border_color: presetButtonBorderColor,
        preset_button_border_size: clampNumber(row.preset_button_border_size, 0, 20, presetButtonAppearance ? presetButtonAppearance.border_size : 1),
        preset_button_shadow_size: clampNumber(row.preset_button_shadow_size, 0, 60, presetButtonAppearance ? presetButtonAppearance.shadow_size : 0),
        preset_button_border_radius_px: clampNumber(row.preset_button_border_radius_px, 0, 240, presetButtonBorderRadiusFallback),
        preset_button_background_color: presetButtonBackgroundColor,
        preset_button_text_color: presetButtonTextColor,
        preset_button_gradient_color: presetButtonGradientColor,
      preset_button_gradient_angle: clampNumber(row.preset_button_gradient_angle, 0, 360, presetButtonAppearance ? presetButtonAppearance.gradient_angle : 180),
      preset_button_background_image: presetButtonBackgroundImage,
      preset_button_background_image_style: normalizeBackgroundImageStyle(row.preset_button_background_image_style || (presetButtonAppearance && presetButtonAppearance.background_image_style), "center"),
      preset_button_text_size_mobile: clampNumber(row.preset_button_text_size_mobile, 0, 48, presetButtonAppearance ? presetButtonAppearance.text_size_mobile : 0),
      preset_button_text_size_desktop: clampNumber(row.preset_button_text_size_desktop, 0, 48, presetButtonAppearance ? presetButtonAppearance.text_size_desktop : 0),
      preset_button_text_behavior: String(row.preset_button_text_behavior || (presetButtonAppearance && presetButtonAppearance.text_behavior) || "wrap_text").trim().toLowerCase() || "wrap_text",
      preset_button_text_style: String(row.preset_button_text_style || (presetButtonAppearance && presetButtonAppearance.text_style) || "normal").trim().toLowerCase() || "normal",
      preset_button_image_radius_px: clampNumber(row.preset_button_image_radius_px, 0, 240, presetButtonImageRadiusFallback),
      preset_button_product_image_padding: clampNumber(row.preset_button_product_image_padding, 0, 120, presetButtonAppearance ? presetButtonAppearance.product_image_padding : 0),
      preset_button_border_scope: normalizeBorderScope(row.preset_button_border_scope || (presetButtonAppearance && presetButtonAppearance.border_scope), "image_text"),
      collapsed: !!row.collapsed,
      show_more_text: String(row.show_more_text || "Show more"),
      show_less_text: String(row.show_less_text || "Show less"),
      row_toggle_border_style: String(row.row_toggle_border_style || "solid"),
      hide_cta_buttons: !!row.hide_cta_buttons,
      end_behavior_override: String(row.end_behavior_override || ""),
      appearance: normalizedAppearance,
      selected_appearance: normalizedSelectedAppearance,
      __import_set: resolveExistingSetKey(row.__import_set || ""),
      __import_mode: String(row.__import_mode || "flatten").trim() || "flatten",
      __import_passthrough: !!row.__import_passthrough,
      __force_root_appearance: !!row.__force_root_appearance,
      __skipRender: skipSwatchVariantRowForHandle || skipCurrentProductVariantsSource || pendingRuntimeItems,
      videos: normalizedItems,
      swatches: normalizedItems
    };
  }

  function getSetStore() {
    const w = window;
    const candidate =
      (w.MG_SWATCH_SETS && typeof w.MG_SWATCH_SETS === "object")
        ? w.MG_SWATCH_SETS
        : (w.MEDIA_GALLERY_SETS && typeof w.MEDIA_GALLERY_SETS === "object")
          ? w.MEDIA_GALLERY_SETS
          : (w.VIMEO_VIDEO_SETS && typeof w.VIMEO_VIDEO_SETS === "object")
            ? w.VIMEO_VIDEO_SETS
            : null;

    if (candidate) {
      if (Object.getPrototypeOf(candidate) === null) {
        w.MG_SWATCH_SETS = candidate;
        return candidate;
      }
      const safe = Object.create(null);
      for (const key of Object.keys(candidate)) safe[key] = candidate[key];
      w.MG_SWATCH_SETS = safe;
      return safe;
    }

    const safe = Object.create(null);
    w.MG_SWATCH_SETS = safe;
    return safe;
  }

  function getSpecScripts(context) {
    const scope = context || document;
    const seen = new Set();
    const out = [];
    scope.querySelectorAll('script[data-mg-product-swatches-spec][type="application/json"], script[data-vimeo-control-spec][type="application/json"]').forEach((node) => {
      if (!node || seen.has(node)) return;
      seen.add(node);
      out.push(node);
    });
    return out;
  }

  function shouldPreserveExistingSpecRows(target, nextRows) {
    if (!window.Shopify || !window.Shopify.designMode) return false;
    const key = String(target || "").trim();
    if (!key) return false;
    if (Array.isArray(nextRows) && nextRows.length) return false;
    try {
      const existing = Object.prototype.hasOwnProperty.call(R.__rawSpecs, key)
        ? R.__rawSpecs[key]
        : null;
      const existingRows = existing ? coerceToRows(existing.rows) : [];
      return !!existingRows.length;
    } catch (_) {
      return false;
    }
  }

  function registerSpecs(context) {
    for (const script of getSpecScripts(context)) {
      const spec = safeJsonParse(script.textContent || "");
      const target = String(spec?.targetSet || "").trim();
      if (!target) continue;
      const nextRows = coerceToRows(spec.rows);
      if (shouldPreserveExistingSpecRows(target, nextRows)) continue;
      R.__rawSpecs[target] = { targetSet: target, rows: nextRows };
    }
  }

  function registerLocalSpecForRoot(root, setName) {
    if (!root || !setName) return false;
    try {
      const candidates = [];
      const section = root.closest ? root.closest(".shopify-section") : null;
      if (section && section.querySelectorAll) {
        section.querySelectorAll('script[data-mg-product-swatches-spec][type="application/json"]').forEach((node) => {
          candidates.push(node);
        });
      }
      let node = root.previousElementSibling;
      while (node) {
        candidates.push(node);
        node = node.previousElementSibling;
      }
      node = root.nextElementSibling;
      while (node) {
        candidates.push(node);
        node = node.nextElementSibling;
      }
      for (const candidate of candidates) {
        if (!candidate || !candidate.matches || !candidate.matches('script[data-mg-product-swatches-spec][type="application/json"]')) continue;
        const spec = safeJsonParse(candidate.textContent || "");
        const target = String(spec?.targetSet || "").trim();
        if (target !== setName) continue;
        const nextRows = coerceToRows(spec.rows);
        if (shouldPreserveExistingSpecRows(target, nextRows)) return true;
        R.__rawSpecs[target] = { targetSet: target, rows: nextRows };
        return true;
      }
    } catch (_) { }
    return false;
  }

  function mergeImportedRows(baseRow, importedRows) {
    const rows = cloneDeep(importedRows) || [];
    if (!rows.length) return rows;

    const first = rows[0];
    const last = rows[rows.length - 1];
    const hasExplicitPresetButtonText = !!(baseRow && Object.prototype.hasOwnProperty.call(baseRow, "preset_button_text"));
    const hasPresetButtonText = collapseWhitespace(plainTextFromMaybeHtml(baseRow?.preset_button_text || ""));
    const hasOverrideHeading = collapseWhitespace(plainTextFromMaybeHtml(baseRow?.heading || ""));
    const hasOverrideSubheading = collapseWhitespace(plainTextFromMaybeHtml(baseRow?.subheading || ""));
    const headingJustifyOverride = !!(baseRow && baseRow.__has_heading_justify_override)
      ? collapseWhitespace(baseRow?.heading_justify || "")
      : "";
    const clearImportedFirstHeading = !!(baseRow && baseRow.__clear_imported_first_heading);

    if (baseRow?.preset_button && !hasExplicitPresetButtonText && !hasPresetButtonText) {
      const firstImportedHeading = rows.find((row) => collapseWhitespace(plainTextFromMaybeHtml(row?.heading || "")));
      if (firstImportedHeading) {
        const fallbackHeading = String(firstImportedHeading.heading || "");
        baseRow.preset_button_text = fallbackHeading;
      }
    }

    if (clearImportedFirstHeading) {
      first.heading = "";
      first.subheading = "";
      if (headingJustifyOverride) first.heading_justify = String(baseRow.heading_justify || "");
    } else if (hasOverrideHeading || hasOverrideSubheading || headingJustifyOverride) {
      if (hasOverrideHeading) first.heading = String(baseRow.heading || "");
      if (hasOverrideSubheading) first.subheading = String(baseRow.subheading || "");
      if (headingJustifyOverride) first.heading_justify = String(baseRow.heading_justify || "");
    }

    if (baseRow.margin_top) first.margin_top = (Number(first.margin_top || 0) || 0) + baseRow.margin_top;
    if (baseRow.margin_bottom) last.margin_bottom = (Number(last.margin_bottom || 0) || 0) + baseRow.margin_bottom;

    if (baseRow.custom_html || baseRow.custom_template_id) {
      const customRow = normalizeRow({
        heading: "",
        subheading: "",
        heading_justify: baseRow.heading_justify || "center",
        custom_html: baseRow.custom_html || "",
        custom_template_id: baseRow.custom_template_id || "",
        custom_width_desktop_percent: baseRow.custom_width_desktop_percent,
        custom_width_mobile_percent: baseRow.custom_width_mobile_percent,
        custom_max_width_px: baseRow.custom_max_width_px,
        img_ratio: "1:1",
        row_height: 0,
        fit_row: false,
        margin_top: baseRow.margin_top,
        margin_bottom: 0,
        videos: []
      });
      rows.unshift(customRow);
    }

    if (baseRow.appearance || baseRow.selected_appearance) {
      rows.forEach((row) => {
        if (!row || typeof row !== "object") return;
        if (baseRow.appearance) {
          row.appearance = mergeSwatchAppearance(row.appearance, baseRow.appearance, "image");
        }
        if (baseRow.selected_appearance) {
          const selectedScope = (
            (row.appearance && row.appearance.border_scope)
            || (baseRow.appearance && baseRow.appearance.border_scope)
            || "image"
          );
          row.selected_appearance = mergeSwatchAppearance(row.selected_appearance, baseRow.selected_appearance, selectedScope);
        }
        // Imported sets should fully honor wrapper appearance overrides when provided.
        row.__force_root_appearance = true;
      });
    }

    if (baseRow.videos && baseRow.videos.length) {
      last.videos = normalizeItems((last.videos || []).concat(baseRow.videos));
      last.swatches = last.videos;
    }

    return rows;
  }

  function applyPresetButtonHeadingFallback(row, importedRows) {
    if (!row || !row.preset_button) return row;
    const hasExplicitPresetButtonText = Object.prototype.hasOwnProperty.call(row, "preset_button_text");
    const hasPresetButtonText = collapseWhitespace(plainTextFromMaybeHtml(row.preset_button_text || ""));
    if (hasExplicitPresetButtonText || hasPresetButtonText) return row;
    const rows = Array.isArray(importedRows) ? importedRows : [];
    const firstImportedHeading = rows.find((candidate) => collapseWhitespace(plainTextFromMaybeHtml(candidate?.heading || "")));
    if (!firstImportedHeading) return row;

    const fallbackHeading = String(firstImportedHeading.heading || "");
    row.preset_button_text = fallbackHeading;
    if (!collapseWhitespace(String(row.preset_modal_title || ""))) {
      row.preset_modal_title = plainTextFromMaybeHtml(fallbackHeading);
    }
    return row;
  }

  function resolveSet(key, stack, opts = {}) {
    const setKey = resolveExistingSetKey(key);
    if (!setKey) return [];

    const store = getSetStore();
    const inheritedMatchSettingsKey = resolveExistingSetKey(opts && opts.matchSettingsPresetKey || "");
    const ignoreSourceMatchSettings = !!(opts && opts.ignoreSourceMatchSettings);
    const disableMatchedPresetRowMerge = !!(opts && opts.disableMatchedPresetRowMerge);
    const preferMediaGallerySets = !!(opts && opts.preferMediaGallerySets);
    const seen = stack instanceof Set ? stack : new Set();
    if (seen.has(setKey)) return coerceToRows(store[setKey]);
    seen.add(setKey);

    const sourceEntry = Object.prototype.hasOwnProperty.call(R.__rawSpecs, setKey)
      ? R.__rawSpecs[setKey]
      : getPreferredStoreValue(setKey, preferMediaGallerySets);
    const sourceValue = Object.prototype.hasOwnProperty.call(R.__rawSpecs, setKey)
      ? R.__rawSpecs[setKey].rows
      : getPreferredStoreValue(setKey, preferMediaGallerySets);
    const sourceMeta = cloneDeep(getSetMeta(sourceEntry)) || {};
    const currentMatchSettingsKey = resolveExistingSetKey(
      inheritedMatchSettingsKey ||
      (ignoreSourceMatchSettings ? "" : (
        sourceMeta.match_settings_preset_key ||
        sourceMeta.matchPresetSettingsKey ||
        ""
      )) ||
      ""
    );

    const rawRows = coerceToRows(sourceValue);
    const preserveSourceRowsForRuntimeExpansion = rowsContainCurrentProductVariantSource(rawRows);
    const out = [];

    for (const rawRow of rawRows) {
      const row = normalizeRow(rawRow, {
        matchSettingsPresetKey: currentMatchSettingsKey,
        disableMatchedPresetRowMerge: disableMatchedPresetRowMerge
      });
      const importKey = resolveExistingSetKey(row.__import_set || "");
      const importMode = String(row.__import_mode || "flatten").trim().toLowerCase();
      const passthrough = !!row.__import_passthrough;

      if (!importKey) {
        out.push(row);
        continue;
      }

      const importedRows = resolveSet(importKey, seen, {
        matchSettingsPresetKey: currentMatchSettingsKey,
        ignoreSourceMatchSettings: ignoreSourceMatchSettings,
        disableMatchedPresetRowMerge: disableMatchedPresetRowMerge,
        preferMediaGallerySets: preferMediaGallerySets
      });
      if (!importedRows.length) {
        continue;
      }

      if (row.preset_button) {
        const keep = Object.assign({}, row);
        keep.preset_button_set = keep.preset_button_set || importKey;
        applyPresetButtonHeadingFallback(keep, importedRows);
        keep.videos = [];
        out.push(keep);
        continue;
      }

      if (passthrough || importMode === "preserve") {
        const merged = mergeImportedRows(row, importedRows);
        out.push(...merged.map((mergedRow) => normalizeRow(mergedRow, {
          matchSettingsPresetKey: currentMatchSettingsKey,
          disableMatchedPresetRowMerge: disableMatchedPresetRowMerge
        })));
        continue;
      }

      const flatItems = [];
      for (const imported of importedRows) flatItems.push(...normalizeItems(rowItems(imported)));
      flatItems.push(...(row.videos || []));
      const flatRow = Object.assign({}, row, {
        __import_set: "",
        __import_mode: "flatten",
        __import_passthrough: false,
        videos: normalizeItems(flatItems)
      });
      out.push(flatRow);
    }

    seen.delete(setKey);
    const shouldWriteResolvedRowsBackToStore = !preserveSourceRowsForRuntimeExpansion && !currentMatchSettingsKey;
    if (shouldWriteResolvedRowsBackToStore) {
      try {
        if (Object.prototype.hasOwnProperty.call(R.__rawSpecs, setKey)) {
          store[setKey] = cloneDeep(out);
        } else {
          const existingMeta = cloneDeep(getSetMeta(sourceValue)) || {};
          const hadPayload = !!getSetPayload(sourceValue);
          store[setKey] = hadPayload
            ? { meta: existingMeta, rows: cloneDeep(out) }
            : cloneDeep(out);
        }
      } catch (_) {
        store[setKey] = cloneDeep(out);
      }
    }
    return out;
  }

  function buildFromDom(context) {
    registerSpecs(context || document);
    Object.keys(R.__rawSpecs).forEach((key) => {
      try { resolveSet(key, new Set()); } catch (_) { }
    });
    try { R.__dispatchingSetsReady = true; } catch (_) { }
    try { document.dispatchEvent(new Event("media_gallery_sets_ready")); } catch (_) { }
    try {
      window.setTimeout(() => {
        try { R.__dispatchingSetsReady = false; } catch (_) { }
      }, 0);
    } catch (_) {
      try { R.__dispatchingSetsReady = false; } catch (_) { }
    }
  }

  function getRoots(context) {
    const scope = context || document;
    const roots = [];
    if (scope.matches && scope.matches('[data-mg-product-swatches-root]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-mg-product-swatches-root]'));
    return roots;
  }

  function getExportBoxes(context) {
    const scope = context || document;
    const boxes = [];
    if (scope.matches && scope.matches('[data-mgps-export-box]')) boxes.push(scope);
    if (scope.querySelectorAll) boxes.push(...scope.querySelectorAll('[data-mgps-export-box]'));
    return boxes;
  }

  function exportBoxMatchesRoot(exportBox, root) {
    if (!exportBox || !root || !exportBox.getAttribute || !root.getAttribute) return false;
    try {
      const rootId = String(root.id || "").trim();
      const exportRootId = String(exportBox.getAttribute("data-mgps-root-id") || "").trim();
      if (rootId && exportRootId && exportRootId === rootId) return true;
    } catch (_) { }
    try {
      const rootSet = collapseWhitespace(root.getAttribute("data-mg-set") || root.getAttribute("data-vimeo-set") || "");
      const exportSet = collapseWhitespace(exportBox.getAttribute("data-source-set") || "");
      if (rootSet && exportSet && rootSet === exportSet) return true;
    } catch (_) { }
    return false;
  }

  function shouldShowEditorExportForRoot(root) {
    if (!root || !window.Shopify || !window.Shopify.designMode) return false;
    try {
      return !!(root.classList && root.classList.contains("mg-product-swatches"));
    } catch (_) {
      return false;
    }
  }

  function ensureDesignModeExportBoxes(context) {
    if (!window.Shopify || !window.Shopify.designMode) return;
    const scope = context && context.querySelectorAll ? context : document;
    const roots = getRoots(scope);
    roots.forEach((root) => {
      if (!shouldShowEditorExportForRoot(root)) return;
      if (!root || !root.parentNode) return;
      const section = root.closest ? root.closest(".shopify-section") : null;
      const existingBoxes = section ? getExportBoxes(section) : getExportBoxes(root.parentNode);
      const existing = existingBoxes.find((box) => exportBoxMatchesRoot(box, root));
      if (existing) {
        try {
          const setName = collapseWhitespace(root.getAttribute("data-mg-set") || root.getAttribute("data-vimeo-set") || "");
          if (setName) existing.setAttribute("data-source-set", setName);
          if (root.id) existing.setAttribute("data-mgps-root-id", root.id);
        } catch (_) { }
        return;
      }

      const setName = collapseWhitespace(root.getAttribute("data-mg-set") || root.getAttribute("data-vimeo-set") || "");
      if (!setName) return;

      const exportBox = document.createElement("div");
      exportBox.className = "mgps-export";
      exportBox.setAttribute("data-mgps-export-box", "");
      exportBox.setAttribute("data-source-set", setName);
      if (root.id) exportBox.setAttribute("data-mgps-root-id", root.id);
      exportBox.setAttribute("data-mgps-auto-export", "true");

      try {
        root.insertAdjacentElement("afterend", exportBox);
      } catch (_) {
        try { root.parentNode.appendChild(exportBox); } catch (_) { }
      }
    });
  }

  function buildRowHeading(rowSpec) {
    const headingHtml = String(rowSpec?.heading || "");
    const subheadingHtml = String(rowSpec?.subheading || "");
    if (!headingHtml.trim() && !subheadingHtml.trim()) return null;

    const justifyRaw = String(rowSpec?.heading_justify || "center").trim().toLowerCase();
    const justify = ["left", "center", "right"].includes(justifyRaw) ? justifyRaw : "center";
    const alignItems = justify === "left" ? "flex-start" : justify === "right" ? "flex-end" : "center";

    const wrap = document.createElement("div");
    wrap.className = "mgps-row-heading-wrap";
    wrap.dataset.headingJustify = justify;
    setStyleImportant(wrap, "width", "100%");
    setStyleImportant(wrap, "align-items", alignItems);
    setStyleImportant(wrap, "text-align", justify);

    if (headingHtml.trim()) {
      const heading = document.createElement("div");
      heading.className = "mgps-row-heading";
      heading.innerHTML = headingHtml;
      setStyleImportant(heading, "text-align", justify);
      try {
        heading.querySelectorAll("*").forEach((node) => setStyleImportant(node, "text-align", justify));
      } catch (_) { }
      wrap.appendChild(heading);
    }

    if (subheadingHtml.trim()) {
      const subheading = document.createElement("div");
      subheading.className = "mgps-row-subheading";
      subheading.innerHTML = subheadingHtml;
      setStyleImportant(subheading, "text-align", justify);
      try {
        subheading.querySelectorAll("*").forEach((node) => setStyleImportant(node, "text-align", justify));
      } catch (_) { }
      wrap.appendChild(subheading);
    }

    return wrap;
  }

  function shouldHideControlIfMissingDataset(root) {
    const raw = getDataAttr(root, "data-mgps-hide-if-missing-dataset");
    if (!raw) return true;
    const normalized = String(raw).trim().toLowerCase();
    return !(normalized === "false" || normalized === "0" || normalized === "no" || normalized === "off");
  }

  function setControlVisibility(root, visible) {
    if (!root) return;
    const wrapper = root.closest ? root.closest(".mg-swatch-presets") : null;
    const target = wrapper || root;
    try {
      target.hidden = !visible;
    } catch (_) { }
    try {
      target.style.display = visible ? "" : "none";
    } catch (_) { }
    try {
      target.setAttribute("aria-hidden", visible ? "false" : "true");
    } catch (_) { }
  }

  function buildMissingSetMessage(setName) {
    const message = document.createElement("div");
    message.className = "mgps-missing-set";
    message.textContent = setName
      ? 'Dataset not found: ' + setName
      : 'Dataset not found.';
    return message;
  }

  function activateClonedScripts(container) {
    if (!container || !container.querySelectorAll) return;
    const scripts = Array.from(container.querySelectorAll("script"));
    scripts.forEach((oldScript) => {
      const newScript = document.createElement("script");
      for (const attr of Array.from(oldScript.attributes || [])) {
        newScript.setAttribute(attr.name, attr.value);
      }
      newScript.textContent = oldScript.textContent || "";
      oldScript.replaceWith(newScript);
    });
  }

  function renderCustomRow(rowSpec, rowWrap) {
    const customTemplateId = String(rowSpec?.custom_template_id || "").trim();
    const customRaw = String(rowSpec?.custom_html || "");
    if (!customTemplateId && !customRaw.trim()) return false;

    const customEl = document.createElement("div");
    customEl.className = "mgps-custom";
    customEl.setAttribute("data-custom-liquid", "true");

    let injected = false;
    if (customTemplateId) {
      const tpl = document.getElementById(customTemplateId);
      if (tpl) {
        const clone = tpl.cloneNode(true);
        try { clone.removeAttribute("id"); } catch (_) { }
        try { clone.removeAttribute("hidden"); } catch (_) { }
        try { clone.removeAttribute("aria-hidden"); } catch (_) { }
        while (clone.firstChild) customEl.appendChild(clone.firstChild);
        injected = true;
      }
    }

    if (!injected && customRaw.trim()) {
      customEl.innerHTML = customRaw;
    }

    let wrap = customEl.querySelector(":scope > .mg-custom-liquid-wrap");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "mg-custom-liquid-wrap";
      while (customEl.firstChild) wrap.appendChild(customEl.firstChild);
      customEl.appendChild(wrap);
    }

    wrap.style.setProperty("--mgps-custom-width-mobile", String(rowSpec?.custom_width_mobile_percent ?? 100) + "%");
    wrap.style.setProperty("--mgps-custom-width-desktop", String(rowSpec?.custom_width_desktop_percent ?? 100) + "%");
    wrap.style.setProperty("--mgps-custom-max-width", (Number(rowSpec?.custom_max_width_px || 0) > 0) ? (String(Number(rowSpec.custom_max_width_px)) + "px") : "none");

    rowWrap.appendChild(customEl);
    activateClonedScripts(customEl);
    return true;
  }

  function ensureModal() {
    if (R.__modal && R.__modal.node && R.__modal.node.isConnected) return R.__modal;

    const overlay = document.createElement("div");
    overlay.className = "mgps-modal";
    overlay.hidden = true;
    overlay.setAttribute("aria-hidden", "true");
    overlay.style.display = "none";
    overlay.style.pointerEvents = "none";

    const dialog = document.createElement("div");
    dialog.className = "mgps-modal__dialog";
    dialog.style.width = "min(1200px, calc(100vw - 48px))";
    dialog.style.maxWidth = "1200px";
    dialog.style.height = "auto";
    dialog.style.maxHeight = "100vh";
    dialog.style.borderRadius = "20px";
    dialog.setAttribute("role", "dialog");
    dialog.setAttribute("aria-modal", "true");
    dialog.setAttribute("aria-labelledby", "mgps-modal-title");

    const header = document.createElement("div");
    header.className = "mgps-modal__header";

    const title = document.createElement("div");
    title.className = "mgps-modal__title";
    title.id = "mgps-modal-title";
    header.appendChild(title);

    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.className = "mgps-modal__close";
    closeBtn.setAttribute("aria-label", "Close");
    closeBtn.textContent = "✕";
    closeBtn.setAttribute("title", "Close");
    closeBtn.textContent = "\u00D7";
    header.appendChild(closeBtn);

    const body = document.createElement("div");
    body.className = "mgps-modal__body";

    dialog.appendChild(header);
    dialog.appendChild(body);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
    // simple stack so nested modals restore the previous modal when closed
    R.__modalStack = R.__modalStack || [];

    function pushModalState() {
      try {
        if (!overlay || overlay.hidden || overlay.style.display === "none") return;
        const titleFrag = document.createDocumentFragment();
        while (title.firstChild) titleFrag.appendChild(title.firstChild);
        const bodyFrag = document.createDocumentFragment();
        while (body.firstChild) bodyFrag.appendChild(body.firstChild);
        const entry = {
          titleFrag,
          bodyFrag,
          swatchMeta: (R.__modal && R.__modal.__swatchPopupMeta) ? R.__modal.__swatchPopupMeta : null,
          sourceBlockType: (R.__modal && R.__modal.__sourceBlockType) ? R.__modal.__sourceBlockType : "",
          dialogClass: dialog.className,
          headerStyle: header.getAttribute && header.getAttribute('style') || '',
          titleStyle: title.getAttribute && title.getAttribute('style') || '',
          closeBtnStyle: closeBtn.getAttribute && closeBtn.getAttribute('style') || ''
        };
        R.__modalStack.push(entry);
      } catch (_) { }
    }

    function popModalState() {
      try {
        if (!R.__modalStack || !R.__modalStack.length) return false;
        const entry = R.__modalStack.pop();
        try { while (title.firstChild) title.removeChild(title.firstChild); } catch (_) { }
        try { title.appendChild(entry.titleFrag); } catch (_) { }
        try { while (body.firstChild) body.removeChild(body.firstChild); } catch (_) { }
        try { body.appendChild(entry.bodyFrag); } catch (_) { }
        try { dialog.className = entry.dialogClass || dialog.className; } catch (_) { }
        try { if (header && header.setAttribute) header.setAttribute('style', entry.headerStyle || ''); } catch (_) { }
        try { if (title && title.setAttribute) title.setAttribute('style', entry.titleStyle || ''); } catch (_) { }
        try { if (closeBtn && closeBtn.setAttribute) closeBtn.setAttribute('style', entry.closeBtnStyle || ''); } catch (_) { }
        try { if (R.__modal) R.__modal.__swatchPopupMeta = entry.swatchMeta; } catch (_) { }
        try { if (R.__modal) R.__modal.__sourceBlockType = entry.sourceBlockType || ""; } catch (_) { }
        return true;
      } catch (_) { return false; }
    }

    function closeModal() {
      try {
        // if there's a stacked state restore it instead of fully closing
        if (popModalState()) return;
      } catch (_) { }
      try { overlay.hidden = true; } catch (_) { }
      try { overlay.setAttribute("aria-hidden", "true"); } catch (_) { }
      try { overlay.style.display = "none"; } catch (_) { }
      try { overlay.style.pointerEvents = "none"; } catch (_) { }
      try { body.innerHTML = ""; } catch (_) { }
      try { title.textContent = ""; } catch (_) { }
      try { if (R.__modal) R.__modal.__sourceBlockType = ""; } catch (_) { }
      try {
        if (dialog) dialog.classList.remove("is-header-hidden");
        if (header) {
          header.style.display = "";
          header.style.padding = "";
          header.style.minHeight = "";
          header.style.borderBottom = "";
          header.style.height = "";
          header.style.overflow = "";
        }
        if (title) title.style.display = "";
        if (closeBtn) {
          closeBtn.style.position = "";
          closeBtn.style.top = "";
          closeBtn.style.right = "";
          closeBtn.style.left = "";
          closeBtn.style.bottom = "";
          closeBtn.style.display = "";
          closeBtn.style.alignItems = "";
          closeBtn.style.justifyContent = "";
          closeBtn.style.width = "";
          closeBtn.style.height = "";
          closeBtn.style.padding = "";
          closeBtn.style.margin = "";
          closeBtn.style.border = "";
          closeBtn.style.borderRadius = "";
          closeBtn.style.background = "";
          closeBtn.style.boxShadow = "";
          closeBtn.style.color = "";
          closeBtn.style.fontSize = "";
          closeBtn.style.fontWeight = "";
          closeBtn.style.lineHeight = "";
          closeBtn.style.zIndex = "";
        }
      } catch (_) { }
      try { document.documentElement.classList.remove("mgps-modal-open"); } catch (_) { }
      try { document.body.classList.remove("mgps-modal-open"); } catch (_) { }
    }

    closeBtn.addEventListener("click", closeModal);
    overlay.addEventListener("click", (event) => {
      if (event.target === overlay) closeModal();
    });

    if (!R.__escInstalled) {
      R.__escInstalled = true;
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && R.__modal && !R.__modal.node.hidden) {
          R.__modal.close();
        }
      });
      window.addEventListener("resize", () => {
        try {
          if (R.__modal && R.__modal.node && !R.__modal.node.hidden) {
            applyModalSizing(R.__modal);
            applyPresetButtonTextFit(R.__modal.node);
          }
          applyPresetButtonTextFit(document);
        } catch (_) { }
      });
    }

    R.__modal = { node: overlay, dialog, header, closeBtn, title, body, close: closeModal, push: pushModalState, pop: popModalState };
    return R.__modal;
  }

  function applyModalSizing(modal) {
    if (!modal || !modal.dialog || !modal.body) return;
    try {
      const viewportWidth = Math.max(window.innerWidth || 0, document.documentElement?.clientWidth || 0, 0);
      const viewportHeight = Math.max(window.innerHeight || 0, document.documentElement?.clientHeight || 0, 0);
      const isMobile = viewportWidth <= 768;
      const maxDialogHeight = viewportHeight > 0
        ? Math.floor(viewportHeight)
        : 0;
      const headerHeight = modal.header ? Math.ceil(modal.header.getBoundingClientRect().height || 0) : 0;

      modal.node.style.alignItems = isMobile ? "center" : "flex-end";
      modal.node.style.padding = isMobile ? "0" : "0 24px 0";
      modal.node.style.overflowY = isMobile ? "auto" : "hidden";

      modal.dialog.style.width = isMobile
        ? "100vw"
        : "min(1200px, calc(100vw - 48px))";
      modal.dialog.style.maxWidth = isMobile ? "100vw" : "1200px";
      modal.dialog.style.height = "auto";
      modal.dialog.style.minHeight = "0";
      modal.dialog.style.maxHeight = maxDialogHeight > 0
        ? (String(maxDialogHeight) + "px")
        : "100vh";
      modal.dialog.style.borderRadius = "20px";

      modal.body.style.boxSizing = "border-box";
      modal.body.style.minHeight = "0";
      modal.body.style.overflowX = "hidden";
      modal.body.style.overflowY = "auto";
      modal.body.style.paddingBottom = isMobile ? "10%" : "5%";
      modal.body.style.maxHeight = maxDialogHeight > 0
        ? (String(Math.max(0, maxDialogHeight - headerHeight)) + "px")
        : "calc(100vh - 70px)";
    } catch (_) { }
  }

  function openPresetSet(setKey, label, opts = {}) {
    const key = String(setKey || "").trim();
    if (!key) return;

    try { buildFromDom(document); } catch (_) { }

    const rows = resolveSet(key, new Set());
    if (!rows.length) return;
    const modal = ensureModal();
    try { if (modal && modal.node && !modal.node.hidden && modal.node.style.display !== "none" && typeof modal.push === "function") modal.push(); } catch (_) { }
    rememberModalOpenScrollPosition(modal);
    try { if (modal) modal.__sourceBlockType = String(opts && opts.sourceBlockType || "").trim().toLowerCase(); } catch (_) { }
    const normalizedTitle = String(label == null ? key : label);
    const hideHeader = !!(opts && opts.hideHeader);
    const visibleTitle = hideHeader ? "" : plainTextFromMaybeHtml(normalizedTitle);

    modal.title.textContent = visibleTitle;

    try {
      if (modal.dialog) {
        modal.dialog.style.position = "relative";
        modal.dialog.classList.toggle("is-header-hidden", hideHeader);
      }
      if (modal.dialog) {
        modal.dialog.style.position = "relative";
      }
      if (modal.header) {
        if (hideHeader) {
          modal.header.style.display = "block";
          modal.header.style.padding = "0";
          modal.header.style.margin = "0";
          modal.header.style.minHeight = "0";
          modal.header.style.height = "0";
          modal.header.style.borderBottom = "0";
          modal.header.style.overflow = "visible";
        } else {
          modal.header.style.display = "";
          modal.header.style.padding = "";
          modal.header.style.margin = "";
          modal.header.style.minHeight = "";
          modal.header.style.height = "";
          modal.header.style.borderBottom = "";
          modal.header.style.overflow = "";
        }
      }
      if (modal.title) {
        modal.title.style.display = hideHeader ? "none" : "";
      }
      if (modal.closeBtn) {
        if (hideHeader) {
          modal.closeBtn.style.position = "absolute";
          modal.closeBtn.style.top = "12px";
          modal.closeBtn.style.right = "12px";
          modal.closeBtn.style.left = "auto";
          modal.closeBtn.style.bottom = "auto";
          modal.closeBtn.style.display = "inline-flex";
          modal.closeBtn.style.alignItems = "center";
          modal.closeBtn.style.justifyContent = "center";
          modal.closeBtn.style.width = "46px";
          modal.closeBtn.style.height = "46px";
          modal.closeBtn.style.padding = "0";
          modal.closeBtn.style.margin = "0";
          modal.closeBtn.style.border = "1px solid rgba(12, 26, 52, 0.18)";
          modal.closeBtn.style.borderRadius = "999px";
          modal.closeBtn.style.background = "rgba(255, 255, 255, 0.96)";
          modal.closeBtn.style.boxShadow = "0 10px 24px rgba(12, 26, 52, 0.18)";
          modal.closeBtn.style.color = "#102542";
          modal.closeBtn.style.fontSize = "32px";
          modal.closeBtn.style.fontWeight = "400";
          modal.closeBtn.style.lineHeight = "1";
          modal.closeBtn.style.zIndex = "999";
        } else {
          modal.closeBtn.style.position = "";
          modal.closeBtn.style.top = "";
          modal.closeBtn.style.right = "";
          modal.closeBtn.style.left = "";
          modal.closeBtn.style.bottom = "";
          modal.closeBtn.style.display = "";
          modal.closeBtn.style.alignItems = "";
          modal.closeBtn.style.justifyContent = "";
          modal.closeBtn.style.width = "";
          modal.closeBtn.style.height = "";
          modal.closeBtn.style.padding = "";
          modal.closeBtn.style.margin = "";
          modal.closeBtn.style.border = "";
          modal.closeBtn.style.borderRadius = "";
          modal.closeBtn.style.background = "";
          modal.closeBtn.style.boxShadow = "";
          modal.closeBtn.style.color = "";
          modal.closeBtn.style.fontSize = "";
          modal.closeBtn.style.fontWeight = "";
          modal.closeBtn.style.lineHeight = "";
          modal.closeBtn.style.zIndex = "";
        }
      }
    } catch (_) { }

    modal.body.innerHTML = "";

    const rowsForRender = hideHeader
      ? (() => {
        const clonedRows = cloneDeep(rows);
        if (Array.isArray(clonedRows) && clonedRows.length) {
          clonedRows[0] = Object.assign({}, clonedRows[0], { heading: "" });
        }
        return clonedRows;
      })()
      : rows;

    const rendered = renderRows(rowsForRender, { inModal: true, appearance: opts && opts.appearance, selectedAppearance: opts && opts.selectedAppearance, cornerRadiusPx: opts && opts.cornerRadiusPx, forceRootAppearance: false, matchSettingsPresetKey: opts && opts.matchSettingsPresetKey });
    modal.body.appendChild(rendered);
    try {
      requestAnimationFrame(() => {
        try {
          applyModalSizing(modal);
          rendered.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => { applyFitRow(rowEl); applyRowCornerRadius(rowEl); });
        } catch (_) { }
      });
    } catch (_) { }

    try { modal.node.hidden = false; } catch (_) { }
    try { modal.node.setAttribute("aria-hidden", "false"); } catch (_) { }
    try { modal.node.style.display = "flex"; } catch (_) { }
    try { modal.node.style.pointerEvents = "auto"; } catch (_) { }
    try { document.documentElement.classList.add("mgps-modal-open"); } catch (_) { }
    try { document.body.classList.add("mgps-modal-open"); } catch (_) { }
    try { requestAnimationFrame(() => applyModalSizing(modal)); } catch (_) { }
  }

  function makePresetButton(rowSpec, preloadedRows) {
    const buttonStyle = normalizePresetButtonStyle(rowSpec?.preset_button_style || "dropdown_box", "dropdown_box");
    const headingJustifyRaw = String(rowSpec?.preset_button_heading_justify || "center").trim().toLowerCase();
    const headingJustify = ["left", "center", "right"].includes(headingJustifyRaw) ? headingJustifyRaw : "center";
    const presetSetForButton = resolveExistingSetKey(rowSpec?.preset_button_set || rowSpec?.__import_set || "");
    const presetHrefForButton = safeLink(rowSpec?.preset_button_href || rowSpec?.button_href || "");
    const isLinkOnlyPresetButton = !presetSetForButton && !!presetHrefForButton;
    const button = document.createElement("button");
    button.type = "button";
    button.className = "mgps-preset-btn mgps-preset-btn--" + buttonStyle;
    button.setAttribute("data-mgps-preset-style", buttonStyle);
    button.style.position = "relative";
    button.style.zIndex = "1";
    button.style.pointerEvents = "auto";
    button.style.cursor = "pointer";
    if (buttonStyle === "button") {
      if (!isLinkOnlyPresetButton) button.classList.add("button", "button--primary");
      button.style.width = "auto";
      button.style.maxWidth = "100%";
      button.style.marginLeft = "auto";
      button.style.marginRight = "auto";
      button.style.flex = "0 0 auto";
      button.style.alignSelf = "center";
    } else if (buttonStyle === "button_primary") {
      if (!isLinkOnlyPresetButton) button.classList.add("button", "button--primary");
      button.style.width = "auto";
      button.style.maxWidth = "100%";
      button.style.marginLeft = "auto";
      button.style.marginRight = "auto";
      button.style.flex = "0 0 auto";
      button.style.alignSelf = "center";
    } else if (buttonStyle === "button_secondary") {
      if (!isLinkOnlyPresetButton) button.classList.add("button", "button--secondary");
      button.style.width = "auto";
      button.style.maxWidth = "100%";
      button.style.marginLeft = "auto";
      button.style.marginRight = "auto";
      button.style.flex = "0 0 auto";
      button.style.alignSelf = "center";
    }

    const widthPercent = normalizePresetButtonWidthPercent(rowSpec?.preset_button_width_percent, 0);
    const maxWidthPx = parsePixelValue(rowSpec?.preset_button_max_width_px, 0);
    const buttonPaddingXPx = clampNumber(rowSpec?.preset_button_padding_x_px, 0, 120, 0);
    const buttonPaddingYPx = clampNumber(rowSpec?.preset_button_padding_y_px, 0, 120, 0);
    const imageHeightMobilePx = parsePixelValue(rowSpec?.preset_button_image_height_mobile ?? rowSpec?.preset_button_image_height, 0);
    const imageHeightDesktopPx = parsePixelValue(rowSpec?.preset_button_image_height_desktop ?? rowSpec?.preset_button_image_height_mobile ?? rowSpec?.preset_button_image_height, 0);
    if (widthPercent > 0) button.style.setProperty("--mgps-preset-btn-width", widthPercent + "%");
    if (maxWidthPx > 0) button.style.setProperty("--mgps-preset-btn-max-width", maxWidthPx + "px");
    if (imageHeightMobilePx > 0) button.style.setProperty("--mgps-preset-btn-image-height-mobile", imageHeightMobilePx + "px");
    if (imageHeightDesktopPx > 0) button.style.setProperty("--mgps-preset-btn-image-height-desktop", imageHeightDesktopPx + "px");
    if (imageHeightDesktopPx > 0) button.style.setProperty("--mgps-preset-btn-image-height", imageHeightDesktopPx + "px");

    const rawButtonBorderColor = collapseWhitespace(rowSpec?.preset_button_border_color || "");
    const rawButtonBackgroundColor = collapseWhitespace(rowSpec?.preset_button_background_color || "");
    const rawButtonTextColor = collapseWhitespace(rowSpec?.preset_button_text_color || "");
    const buttonBorderColor = rawButtonBorderColor && rawButtonBorderColor !== "rgba(0,0,0,0)" && rawButtonBorderColor !== "rgba(0, 0, 0, 0)"
      ? rawButtonBorderColor
      : "rgba(var(--text-color), 0.15)";
    const buttonBorderSize = clampNumber(rowSpec?.preset_button_border_size, 0, 20, 1);
    const buttonShadowSize = clampNumber(rowSpec?.preset_button_shadow_size, 0, 60, 0);
    const buttonBorderRadiusPx = clampNumber(rowSpec?.preset_button_border_radius_px, 0, 240, 4);
    const buttonBackgroundColor = rawButtonBackgroundColor && rawButtonBackgroundColor !== "rgba(0,0,0,0)" && rawButtonBackgroundColor !== "rgba(0, 0, 0, 0)"
      ? rawButtonBackgroundColor
      : "rgb(var(--secondary-background))";
    const buttonTextColor = rawButtonTextColor && rawButtonTextColor !== "rgba(0,0,0,0)" && rawButtonTextColor !== "rgba(0, 0, 0, 0)"
      ? rawButtonTextColor
      : "rgb(var(--text-color))";
    const buttonGradientColor = collapseWhitespace(rowSpec?.preset_button_gradient_color || "");
    const buttonGradientAngle = clampNumber(rowSpec?.preset_button_gradient_angle, 0, 360, 180);
    const buttonBackgroundImage = safeSrc(rowSpec?.preset_button_background_image || "");
    const buttonBackgroundImageStyle = normalizeBackgroundImageStyle(rowSpec?.preset_button_background_image_style, "center");
    const buttonTextSizeMobile = clampNumber(rowSpec?.preset_button_text_size_mobile, 0, 48, 0);
    const buttonTextSizeDesktop = clampNumber(rowSpec?.preset_button_text_size_desktop, 0, 48, 0);
    const buttonTextBehavior = String(rowSpec?.preset_button_text_behavior || "wrap_text").trim().toLowerCase() || "wrap_text";
    const buttonTextStyle = String(rowSpec?.preset_button_text_style || "normal").trim().toLowerCase() || "normal";
    const buttonImageRadiusPx = clampNumber(
      rowSpec?.preset_button_image_radius_px,
      0,
      240,
      buttonBorderRadiusPx
    );
    const buttonProductImagePadding = clampNumber(rowSpec?.preset_button_product_image_padding, 0, 120, 0);
    const buttonBorderScope = normalizeBorderScope(rowSpec?.preset_button_border_scope, "image_text");

    const buttonShadowValue = topLightShadowValue(buttonShadowSize);

    button.style.borderColor = buttonBorderColor;
    button.style.borderWidth = buttonBorderSize + "px";
    button.style.borderStyle = buttonBorderSize > 0 ? "solid" : "none";
    button.style.borderRadius = buttonBorderRadiusPx + "px";
    button.style.setProperty("--mg-shadow-width", buttonShadowSize + "px");
    button.style.boxShadow = "none";
    button.style.filter = "none";
    button.style.backgroundColor = "transparent";
    button.style.color = buttonTextColor;
    button.style.overflow = "visible";
    if (isLinkOnlyPresetButton) {
      button.style.borderWidth = "0";
      button.style.borderStyle = "none";
      button.style.borderColor = "transparent";
      button.style.background = "transparent";
      button.style.padding = "0";
      button.style.boxShadow = "none";
    }

    const inner = document.createElement("span");
    inner.className = "mgps-preset-btn__inner";
    inner.style.borderColor = buttonBorderColor;
    inner.style.borderWidth = buttonBorderSize + "px";
    inner.style.borderStyle = buttonBorderSize > 0 ? "solid" : "none";
    inner.style.borderRadius = buttonBorderRadiusPx + "px";
    inner.style.backgroundColor = buttonBackgroundColor;
    inner.style.boxShadow = buttonShadowSize > 0 ? buttonShadowValue : "none";
    inner.style.overflow = "hidden";
    inner.style.color = buttonTextColor;
    if (buttonPaddingXPx > 0 || buttonPaddingYPx > 0) {
      inner.style.padding = `${buttonPaddingYPx}px ${buttonPaddingXPx}px`;
    }

    const bgTarget = inner;
    if (buttonBackgroundImage) {
      bgTarget.style.backgroundImage = `url("${buttonBackgroundImage.replace(/"/g, '%22')}")`;
      bgTarget.style.backgroundRepeat = "no-repeat";
      switch (buttonBackgroundImageStyle) {
        case "stretch_to_fit":
          bgTarget.style.backgroundSize = "100% 100%";
          bgTarget.style.backgroundPosition = "center center";
          break;
        case "full_width":
          bgTarget.style.backgroundSize = "100% auto";
          bgTarget.style.backgroundPosition = "center center";
          break;
        case "full_height":
          bgTarget.style.backgroundSize = "auto 100%";
          bgTarget.style.backgroundPosition = "center center";
          break;
        default:
          bgTarget.style.backgroundSize = "cover";
          bgTarget.style.backgroundPosition = "center center";
          break;
      }
    } else if (buttonGradientColor) {
      bgTarget.style.backgroundImage = `linear-gradient(${buttonGradientAngle}deg, ${buttonBackgroundColor}, ${buttonGradientColor})`;
      bgTarget.style.backgroundRepeat = "no-repeat";
      bgTarget.style.backgroundSize = "100% 100%";
      bgTarget.style.backgroundPosition = "center center";
    } else {
      bgTarget.style.backgroundImage = "none";
      bgTarget.style.backgroundRepeat = "";
      bgTarget.style.backgroundSize = "";
      bgTarget.style.backgroundPosition = "";
    }

    const imageSrc = safeSrc(rowSpec?.preset_button_image || "");
    let media = null;
    if (imageSrc) {
      media = document.createElement("span");
      media.className = "mgps-preset-btn__media";
      media.style.borderRadius = buttonImageRadiusPx + "px";
      media.style.padding = buttonProductImagePadding > 0 ? (buttonProductImagePadding + "px") : "0";
      media.style.boxSizing = "border-box";
      media.style.overflow = "hidden";
      const img = document.createElement("img");
      img.className = "mgps-preset-btn__image";
      img.loading = "lazy";
      img.decoding = "async";
      img.src = imageSrc;
      img.alt = String(rowSpec?.preset_button_image_alt || "");
      media.appendChild(img);
      inner.appendChild(media);
      button.classList.add("has-image");
    }

    const body = document.createElement("span");
    body.className = "mgps-preset-btn__body";
    body.style.alignItems = headingJustify === "left" ? "flex-start" : (headingJustify === "right" ? "flex-end" : "center");
    body.style.textAlign = headingJustify;

    const label = document.createElement("span");
    label.className = "mgps-preset-btn__label";
    const hasExplicitPresetButtonText = !!(rowSpec && Object.prototype.hasOwnProperty.call(rowSpec, "preset_button_text"));
    label.innerHTML = hasExplicitPresetButtonText
      ? String(rowSpec?.preset_button_text ?? "")
      : String(rowSpec?.preset_button_text || rowSpec?.heading || "Open Preset");
    body.appendChild(label);

    const rawHintHtml = String(rowSpec?.preset_button_subtext ?? rowSpec?.subheading ?? "");
    const hintText = plainTextFromMaybeHtml(rawHintHtml);
    if (hintText) {
      const hint = document.createElement("span");
      hint.className = "mgps-preset-btn__hint";
      hint.innerHTML = rawHintHtml;
      body.appendChild(hint);
    } else {
      button.classList.add("mgps-preset-btn--single-line");
    }

    [label, body.querySelector(".mgps-preset-btn__hint")].forEach((el) => {
      if (!el) return;
      if (buttonTextStyle.includes("italic")) setStyleImportant(el, "font-style", "italic");
      if (buttonTextStyle.includes("underline")) setStyleImportant(el, "text-decoration", "underline");
      if (buttonTextColor) setStyleImportant(el, "color", buttonTextColor);
      const viewportTextSize = window.innerWidth <= 768
        ? (buttonTextSizeMobile || buttonTextSizeDesktop || 0)
        : (buttonTextSizeDesktop || buttonTextSizeMobile || 0);
      if (viewportTextSize > 0) setStyleImportant(el, "font-size", viewportTextSize + "px");
      if (buttonTextBehavior === "truncate_text" || buttonTextBehavior === "squeeze_text") {
        setStyleImportant(el, "display", "block");
        setStyleImportant(el, "white-space", "nowrap");
        setStyleImportant(el, "overflow", buttonTextBehavior === "truncate_text" ? "hidden" : "visible");
        setStyleImportant(el, "text-overflow", buttonTextBehavior === "truncate_text" ? "ellipsis" : "clip");
        if (buttonTextBehavior === "squeeze_text") {
          setStyleImportant(el, "width", "100%");
          setStyleImportant(el, "max-width", "100%");
        }
      } else {
        setStyleImportant(el, "white-space", "normal");
        setStyleImportant(el, "overflow", "visible");
        setStyleImportant(el, "text-overflow", "clip");
        setStyleImportant(el, "overflow-wrap", "break-word");
      }
    });

    inner.appendChild(body);

    if (media && buttonBorderScope === "image") {
      inner.style.borderWidth = "0";
      inner.style.borderStyle = "none";
      inner.style.boxShadow = "none";
      inner.style.backgroundColor = "transparent";
      inner.style.backgroundImage = "none";
      media.style.borderColor = buttonBorderColor;
      media.style.borderWidth = buttonBorderSize + "px";
      media.style.borderStyle = buttonBorderSize > 0 ? "solid" : "none";
      media.style.backgroundColor = buttonBackgroundColor;
      media.style.boxShadow = buttonShadowSize > 0 ? buttonShadowValue : "none";
    }

    if (buttonStyle === "dropdown_box" || buttonStyle === "product_image_button") {
      const chevron = document.createElement("span");
      chevron.className = "mgps-preset-btn__chevron";
      chevron.setAttribute("aria-hidden", "true");
      chevron.textContent = "\u25BE";
      inner.appendChild(chevron);
    }

    button.appendChild(inner);
    try {
      requestAnimationFrame(() => applyPresetButtonTextFit(button));
    } catch (_) { }

    const presetSet = presetSetForButton;
    const presetHref = presetHrefForButton;
    const modalTitle = Object.prototype.hasOwnProperty.call(rowSpec || {}, "preset_modal_title")
      ? String(rowSpec?.preset_modal_title ?? "")
      : hasExplicitPresetButtonText
        ? String(rowSpec?.preset_button_text ?? "")
        : String(rowSpec?.preset_button_text || rowSpec?.heading || presetSet || "Open Preset");
    const hideModalHeader = !!rowSpec?.preset_hide_modal_header;
    if (!presetSet && !presetHref) {
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
    } else {
      if (presetSet) {
        try {
          const preloadRows = Array.isArray(preloadedRows) ? preloadedRows : resolveSet(presetSet, new Set());
          const preloadItems = normalizeItems(
            Array.isArray(preloadRows)
              ? preloadRows.flatMap((row) => rowItems(row))
              : [],
            { matchSettingsPresetKey: rowSpec && rowSpec.__rootMatchSettingsPresetKey }
          );
          queuePopupImagePreload(preloadItems);
        } catch (_) { }

        const openPreset = (event) => {
          try { event.preventDefault(); } catch (_) { }
          try { event.stopPropagation(); } catch (_) { }
          openPresetSet(presetSet, modalTitle, { hideHeader: hideModalHeader, appearance: rowSpec && (rowSpec.__rootAppearance || rowSpec.__appearance), selectedAppearance: rowSpec && (rowSpec.__rootSelectedAppearance || rowSpec.__selectedAppearance), cornerRadiusPx: rowSpec && (rowSpec.__rootCornerRadiusPx ?? rowSpec.__cornerRadiusPx), sourceBlockType: rowSpec && rowSpec.block_type });
        };
        button.addEventListener("click", openPreset);
      } else {
        const navigate = (event) => {
          try { event.preventDefault(); } catch (_) { }
          try { event.stopPropagation(); } catch (_) { }
          const shouldPreserveNavigationScroll = !!(button.closest && button.closest(".mgps-modal__body")) && swatchTargetsDifferentProductPage(presetHref);
          const preservedNavigationScrollPosition = shouldPreserveNavigationScroll
            ? (modalOpenScrollPosition() || currentViewportScrollPosition())
            : null;
          if (preservedNavigationScrollPosition) {
            queuePendingViewportScrollPosition(preservedNavigationScrollPosition);
          }
          try { window.location.assign(presetHref); } catch (_) {
            try { window.location.href = presetHref; } catch (_) { }
          }
        };
        button.addEventListener("click", navigate);
      }
    }

    return button;
  }

  function getCurrentProductHandleFromLocation() {
    try {
      const path = String(window.location.pathname || "");
      const match = path.match(/\/products\/([^\/?#]+)/i);
      return match ? decodeURIComponent(match[1] || "").trim() : "";
    } catch (_) {
      return "";
    }
  }

  function buildButtonSwitchTargetHandle(currentHandle, rule) {
    const current = String(currentHandle || "").trim();
    const source = collapseWhitespace(rule?.if_handle_contains || "");
    const replacement = collapseWhitespace(rule?.replace_with || "");
    if (!current || !source || !replacement) return "";
    if (!current.includes(source)) return "";
    return current.replace(source, replacement);
  }

  function buildButtonSwitchFallbackTargetHandle(rule) {
    return collapseWhitespace(rule?.replace_with || "");
  }

  function isButtonSwitchRuleBlank(rule) {
    if (!rule || typeof rule !== "object") return true;
    const source = collapseWhitespace(rule.if_handle_contains || "");
    const label = collapseWhitespace(plainTextFromMaybeHtml(rule.button_text || ""));
    const hint = collapseWhitespace(plainTextFromMaybeHtml(rule.button_subtext || ""));
    const replacement = collapseWhitespace(rule.replace_with || "");
    return !source && !label && !hint && !replacement;
  }

  function selectButtonSwitchRule(rowSpec) {
    const rules = Array.isArray(rowSpec?.button_switch_rules) ? rowSpec.button_switch_rules : [];
    const currentHandle = getCurrentProductHandleFromLocation();
    const primaryRules = rules.slice(0, 4);
    const fallbackRule = rules.length > 4 ? rules[4] : null;

    for (const rawRule of primaryRules) {
      const rule = rawRule && typeof rawRule === "object" ? rawRule : {};
      const source = collapseWhitespace(rule.if_handle_contains || "");
      if (!source || !currentHandle.includes(source)) continue;
      const nextHandle = buildButtonSwitchTargetHandle(currentHandle, rule);
      if (!nextHandle || nextHandle === currentHandle) continue;
      return {
        currentHandle,
        nextHandle,
        rule
      };
    }

    if (!isButtonSwitchRuleBlank(fallbackRule)) {
      const nextHandle = buildButtonSwitchFallbackTargetHandle(fallbackRule);
      if (nextHandle && nextHandle !== currentHandle) {
        return {
          currentHandle,
          nextHandle,
          rule: fallbackRule
        };
      }
    }

    return null;
  }

  function makeButtonSwitch(rowSpec) {
    const match = selectButtonSwitchRule(rowSpec);
    if (!match) return null;

    const nextUrl = (() => {
      try {
        if (match.rule === (Array.isArray(rowSpec?.button_switch_rules) ? rowSpec.button_switch_rules[4] : null)) {
          const url = new URL(window.location.href);
          url.pathname = "/products/" + encodeURIComponent(match.nextHandle);
          return url.toString();
        }
        return window.location.href.replace(match.currentHandle, match.nextHandle);
      } catch (_) {
        if (match.rule === (Array.isArray(rowSpec?.button_switch_rules) ? rowSpec.button_switch_rules[4] : null)) {
          return "/products/" + encodeURIComponent(match.nextHandle);
        }
        return "";
      }
    })();
    if (!nextUrl) return null;

    const buttonRow = Object.assign({}, rowSpec, {
      preset_button_text: typeof match.rule.button_text === "string" ? match.rule.button_text : (rowSpec?.preset_button_text || "Switch"),
      preset_button_subtext: typeof match.rule.button_subtext === "string" ? match.rule.button_subtext : (rowSpec?.preset_button_subtext || ""),
      preset_button_set: ""
    });
    const button = makePresetButton(buttonRow);
    if (!button) return null;

    try {
      button.disabled = false;
      button.removeAttribute("disabled");
      button.removeAttribute("aria-disabled");
    } catch (_) { }

    const navigate = (event) => {
      try { event.preventDefault(); } catch (_) { }
      try { event.stopPropagation(); } catch (_) { }
      window.location.href = nextUrl;
    };

    button.addEventListener("click", navigate);
    button.addEventListener("touchend", navigate);
    return button;
  }

  function makeSwatchCard(meta, rowSpec, opts = {}) {
    const kind = String(meta?.type || "product").trim().toLowerCase() === "product" ? "product" : "image";
    const currentProduct = (() => {
      const explicitSelected = isTrueLike(meta?.is_selected || meta?.selected || meta?.current_product);
      if (kind !== "product") {
        return explicitSelected;
      }

      const renderCurrentMatch = swatchTargetsCurrentProductOnRender(meta);
      const liveCurrentMatch = isCurrentProductTarget(meta);
      const isVariationSwatchRow = String(rowSpec?.block_type || "").trim().toLowerCase() === "swatch_variant";
      if (isVariationSwatchRow) return liveCurrentMatch || explicitSelected;
      if (targetsCurrentProductVariant(meta)) return liveCurrentMatch || explicitSelected;

      return renderCurrentMatch || liveCurrentMatch || explicitSelected;
    })();
    const href = safeLink(meta?.cta?.href) || safeLink(meta?.product_url) || safeLink(meta?.url) || "";
    const presetSet = swatchPresetSetKey(meta);
    const ratio = parseImgRatio(rowSpec?.img_ratio || "1:1");
    const rowHeight = currentRowHeightFromSpec(rowSpec);
    const rowSwatchVerticalJustify = resolvedSwatchVerticalJustify(meta, rowSpec, "bottom");
    const initialAppearance = resolvedRowAppearance(rowSpec, currentProduct);
    const initialImageRadius = resolvedAppearanceImageRadiusPx(
      initialAppearance,
      rowSpec,
      (() => {
        const v = Number(meta?.corner_radius_px);
        return Number.isFinite(v) && v >= 0 ? v : 12;
      })()
    );

    const card = document.createElement("div");
    card.className = "mgps-thumb";
    card.style.position = "relative";
    card.style.zIndex = "1";
    card.__mgpsMeta = meta;
    card.style.setProperty("--mgps-corner-radius", String(initialImageRadius) + "px");
    card.dataset.kind = kind;
    card.dataset.swatchMode = (kind === "product") ? "true" : "false";
    card.dataset.currentProduct = currentProduct ? "true" : "false";
    card.dataset.swatchVerticalJustify = rowSwatchVerticalJustify;
    card.__mgpsRowSpec = rowSpec || {};

    const block = document.createElement(href && !currentProduct && !presetSet ? "a" : "div");
    block.className = "mgps-thumb-block";
    block.style.borderRadius = "0";
    if (block.tagName === "A") {
      bindSwatchBlockInteraction(block, meta, rowSpec || {});
      if (currentProduct) {
        block.setAttribute("aria-current", "page");
        block.setAttribute("aria-disabled", "true");
      }
    } else if (presetSet && !currentProduct) {
      bindSwatchPresetInteraction(block, meta, rowSpec);
    } else if (currentProduct) {
      block.setAttribute("aria-current", "page");
      block.setAttribute("aria-disabled", "true");
    }

    const slot = document.createElement("div");
    slot.className = "mgps-thumb-slot";
    slot.style.borderRadius = String(initialImageRadius) + "px";
    slot.style.setProperty("--mgps-corner-radius", String(initialImageRadius) + "px");

    const imgWrap = document.createElement("div");
    imgWrap.className = "mgps-img-wrap";
    imgWrap.style.borderRadius = String(initialImageRadius) + "px";
    imgWrap.style.setProperty("--mgps-corner-radius", String(initialImageRadius) + "px");
    imgWrap.style.setProperty("--mgps-row-aspect", ratio.w + " / " + ratio.h);
    if (rowHeight > 0) {
      imgWrap.classList.add("is-fixed-height");
      imgWrap.style.setProperty("--mgps-row-height", rowHeight + "px");
    }
    const imgInner = document.createElement("div");
    imgInner.className = "mgps-img-inner";
    imgInner.style.borderRadius = String(initialImageRadius) + "px";
    imgInner.style.setProperty("--mgps-corner-radius", String(initialImageRadius) + "px");
    let img = null;

    const imageSrc = (() => {
      const baseSrc = shouldRandomizeSwatchZoomArea(meta)
        ? rawImageSrc(meta?.thumbnail || meta?.image || meta?.img || "")
        : safeSrc(meta?.thumbnail || meta?.image || meta?.img || "");
      if (!baseSrc) return "";
      try {
        return cappedShopifyImageUrl(baseSrc, 2400, swatchImageRequestWidth(meta, card, slot, imgWrap));
      } catch (_) {
        return baseSrc;
      }
    })();
    if (imageSrc) {
      img = document.createElement("img");
      img.loading = (opts && opts.inModal) || rowSwatchVerticalJustify === "fit_to_height" ? "eager" : "lazy";
      img.decoding = "async";
      if ((opts && opts.inModal) || rowSwatchVerticalJustify === "fit_to_height") {
        try { img.fetchPriority = "high"; } catch (_) { }
      }
      img.src = imageSrc;
      img.alt = String(meta?.alt || meta?.title || "").slice(0, 127);
      img.style.setProperty("--mgps-product-image-size", String(swatchImageSizePct(meta, 100)) + "%");
      const _mgpsScalePct = resolvedSwatchZoomPct(meta, 100);
      const zoomPresentation = swatchZoomPresentation(meta, _mgpsScalePct);
      img.style.setProperty("--mgps-product-image-scale", String(_mgpsScalePct / 100));
      img.style.setProperty("--mgps-product-image-flip-x", String(zoomPresentation.flipX));
      img.style.setProperty("--mgps-product-image-flip-y", String(zoomPresentation.flipY));
      img.style.setProperty("--mgps-product-image-shift-x", String(zoomPresentation.shiftX || "0%"));
      img.style.setProperty("--mgps-product-image-shift-y", String(zoomPresentation.shiftY || "0%"));
      img.style.objectPosition = zoomPresentation.objectPosition;
      img.addEventListener("load", () => {
        const rowEl = card.closest(".mgps-thumb-row");
        if (rowEl) scheduleRowRelayout(rowEl);
      });
      imgInner.appendChild(img);
    } else {
      const placeholder = document.createElement("div");
      placeholder.className = "mgps-img-placeholder";
      placeholder.textContent = plainTextFromMaybeHtml(meta?.title || "Product");
      imgInner.appendChild(placeholder);
    }

    imgWrap.appendChild(imgInner);
    slot.appendChild(imgWrap);
    block.appendChild(slot);

    const bottom = document.createElement("div");
    bottom.className = "mgps-card-bottom";

    const title = document.createElement("div");
    title.className = "mgps-title";
    title.textContent = plainTextFromMaybeHtml(meta?.title || "");
    bottom.appendChild(title);

    const showPrice = kind === "product" && isTrueLike(meta?.show_price);
    if (showPrice) {
      const price = document.createElement("div");
      price.className = "mgps-price";
      price.hidden = true;
      bottom.appendChild(price);
      try { hydrateSwatchPrice(price, meta); } catch (_) { }
    }

    block.appendChild(bottom);
    card.__mgpsRefs = { block, slot, imgWrap, imgInner, bottom, title, price: bottom.querySelector(".mgps-price"), img };
    applySwatchAppearance(
      card,
      block,
      slot,
      imgWrap,
      bottom,
      img,
      rowSpec,
      currentProduct
    );
    card.appendChild(block);
    return card;
  }

  function clearFitRow(rowEl) {
    if (!rowEl) return;
    const ratio = parseImgRatio(rowEl.dataset.imgRatio || "1:1");
    const aspect = Math.max(0.01, ratio.w / ratio.h);
    const rowHeight = currentRowHeight(rowEl);

    rowEl.querySelectorAll(":scope > .mgps-thumb").forEach((card) => {
      if (rowHeight > 0) {
        const width = Math.max(1, Math.floor(rowHeight * aspect));
        card.style.width = width + "px";
        card.style.maxWidth = "none";
        card.style.minWidth = "0px";
        card.style.flex = "0 0 " + width + "px";
      } else {
        card.style.removeProperty("width");
        card.style.removeProperty("max-width");
        card.style.removeProperty("min-width");
        card.style.flex = "0 0 auto";
      }
    });
  }

  function setRowFitVisibility(rowEl, isReady) {
    if (!rowEl) return;
    try {
      if (isReady) {
        rowEl.style.visibility = "";
        rowEl.style.pointerEvents = "";
      } else {
        rowEl.style.visibility = "hidden";
        rowEl.style.pointerEvents = "none";
      }
    } catch (_) { }
  }

  function applyFitRow(rowEl) {
    if (!rowEl) return false;
    const rowDisplayType = currentRowDisplayType(rowEl);
    const forcedPerRowDesktop = Math.max(0, Number(rowEl.dataset.swatchesPerRowDesktop || rowEl.dataset.swatchesPerRow || 0) || 0);
    const forcedPerRowMobile = Math.max(0, Number(rowEl.dataset.swatchesPerRowMobile || 0) || 0);
    const isMobileBp = window.innerWidth <= 767;
    const forcedPerRow = isMobileBp ? forcedPerRowMobile : forcedPerRowDesktop;
    const viewport = rowEl.parentElement && rowEl.parentElement.classList.contains("mgps-row-viewport")
      ? rowEl.parentElement
      : rowEl;

    clearFitRow(rowEl);
    try {
      const next = viewport.nextElementSibling;
      if (next && next.classList && next.classList.contains("mgps-more-popup-wrap")) next.remove();
      viewport.style.maxHeight = "";
    } catch (_) { }

    try {
      if (rowDisplayType === "scrollable") {
        viewport.dataset.rowDisplayType = "scrollable";
        rowEl.dataset.rowDisplayType = "scrollable";
        rowEl.style.flexWrap = "nowrap";
        setStyleImportant(rowEl, "row-gap", "0px");
        rowEl.style.justifyContent = "flex-start";
        rowEl.style.width = "max-content";
        rowEl.style.maxWidth = "none";
        rowEl.style.minWidth = "100%";
        setRowFitVisibility(rowEl, true);
        return false;
      }

      if (rowDisplayType === "wrap" || forcedPerRow > 0) {
        viewport.dataset.rowDisplayType = "wrap";
        rowEl.dataset.rowDisplayType = "wrap";
        rowEl.style.flexWrap = "wrap";
        setStyleImportant(rowEl, "row-gap", currentPaddingBetweenRows(rowEl) + "px");
        rowEl.style.justifyContent = "";
        rowEl.style.width = "100%";
        rowEl.style.minWidth = "0";
        if (forcedPerRow > 0) {
          const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb"));
          const cs = getComputedStyle(rowEl);
          const gap = Number.parseFloat(cs.columnGap || cs.gap || "5") || 5;
          const count = Math.max(1, forcedPerRow);
          const widthExpr = "calc((100% - " + (gap * Math.max(0, count - 1)) + "px) / " + count + ")";
          cards.forEach((card) => {
            card.style.width = widthExpr;
            card.style.maxWidth = widthExpr;
            card.style.minWidth = "0";
            card.style.flex = "0 0 " + widthExpr;
          });
          applyRowTextSizing(rowEl);
        }
        const next = viewport.nextElementSibling;
        if (next && next.classList && next.classList.contains("mgps-more-popup-wrap")) next.remove();
        viewport.style.maxHeight = "";
        setRowFitVisibility(rowEl, true);
        return false;
      }

      if (rowDisplayType === "wrap_more_popup") {
        viewport.dataset.rowDisplayType = "wrap_more_popup";
        rowEl.dataset.rowDisplayType = "wrap_more_popup";
        setStyleImportant(rowEl, "row-gap", currentPaddingBetweenRows(rowEl) + "px");
        applyWrapMorePopup(rowEl, rowEl.__rowSpec || {});
        setRowFitVisibility(rowEl, true);
        return false;
      }

      const next = viewport.nextElementSibling;
      if (next && next.classList && next.classList.contains("mgps-more-popup-wrap")) next.remove();
      viewport.style.maxHeight = "";
      viewport.dataset.rowDisplayType = "scale_to_fit";
      rowEl.dataset.rowDisplayType = "scale_to_fit";
      rowEl.style.flexWrap = "nowrap";
      setStyleImportant(rowEl, "row-gap", "0px");
      rowEl.style.justifyContent = "";
      rowEl.style.width = "100%";
      rowEl.style.minWidth = "0";
    } catch (_) { }

    const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb"));
    if (!cards.length) {
      setRowFitVisibility(rowEl, true);
      return false;
    }

    const cs = getComputedStyle(rowEl);
    const gap = Number.parseFloat(cs.columnGap || cs.gap || "5") || 5;
    const innerWidth = Math.max(0, Math.floor(viewport.clientWidth));
    if (!(innerWidth > 0)) {
      setRowFitVisibility(rowEl, false);
      return false;
    }

    const ratio = parseImgRatio(rowEl.dataset.imgRatio || "1:1");
    const aspect = Math.max(0.01, ratio.w / ratio.h);
    const rowHeight = currentRowHeight(rowEl);

    let width = Math.max(1, Math.floor((innerWidth - (gap * Math.max(0, cards.length - 1))) / cards.length));
    if (rowHeight > 0) width = Math.min(width, Math.max(1, Math.floor(rowHeight * aspect)));

    cards.forEach((card) => {
      card.style.width = width + "px";
      card.style.maxWidth = width + "px";
      card.style.minWidth = "0px";
      card.style.flex = "0 0 " + width + "px";
    });
    applyRowTextSizing(rowEl);
    setRowFitVisibility(rowEl, true);
    return true;
  }

  function openRowPopup(rowSpec) {
    const modal = ensureModal();
    try { if (modal && modal.node && !modal.node.hidden && modal.node.style.display !== "none" && typeof modal.push === "function") modal.push(); } catch (_) { }
    rememberModalOpenScrollPosition(modal);
    const headingText = plainTextFromMaybeHtml(rowSpec?.heading || "");
    modal.title.textContent = headingText;
    try {
      if (modal.dialog) {
        modal.dialog.style.position = "relative";
        modal.dialog.classList.remove("is-header-hidden");
      }
      if (modal.header) {
        modal.header.style.display = "";
        modal.header.style.padding = "";
        modal.header.style.margin = "";
        modal.header.style.minHeight = "";
        modal.header.style.height = "";
        modal.header.style.borderBottom = "";
        modal.header.style.overflow = "";
      }
      if (modal.title) modal.title.style.display = "";
      if (modal.closeBtn) {
        modal.closeBtn.style.position = "";
        modal.closeBtn.style.top = "";
        modal.closeBtn.style.right = "";
        modal.closeBtn.style.left = "";
        modal.closeBtn.style.bottom = "";
        modal.closeBtn.style.display = "";
        modal.closeBtn.style.alignItems = "";
        modal.closeBtn.style.justifyContent = "";
        modal.closeBtn.style.width = "";
        modal.closeBtn.style.height = "";
        modal.closeBtn.style.padding = "";
        modal.closeBtn.style.margin = "";
        modal.closeBtn.style.border = "";
        modal.closeBtn.style.borderRadius = "";
        modal.closeBtn.style.background = "";
        modal.closeBtn.style.boxShadow = "";
        modal.closeBtn.style.color = "";
        modal.closeBtn.style.fontSize = "";
        modal.closeBtn.style.fontWeight = "";
        modal.closeBtn.style.lineHeight = "";
        modal.closeBtn.style.zIndex = "";
      }
    } catch (_) { }
    modal.body.innerHTML = "";

    const popupRow = Object.assign({}, rowSpec || {});
    popupRow.heading = "";
    popupRow.subheading = "";
    popupRow.row_display_type = "wrap";
    popupRow.row_display_type_mobile = "wrap";
    popupRow.row_display_type_desktop = "wrap";
    popupRow.fit_row = false;

    popupRow.__appearance = rowSpec && rowSpec.__appearance;
    popupRow.__selectedAppearance = rowSpec && rowSpec.__selectedAppearance;
    modal.body.appendChild(renderRows([popupRow], { inModal: true, appearance: popupRow.__appearance, selectedAppearance: popupRow.__selectedAppearance, matchSettingsPresetKey: rowSpec && rowSpec.__rootMatchSettingsPresetKey }));
    try { modal.node.hidden = false; } catch (_) { }
    try { modal.node.setAttribute("aria-hidden", "false"); } catch (_) { }
    try { modal.node.style.display = "flex"; } catch (_) { }
    try { modal.node.style.pointerEvents = "auto"; } catch (_) { }
    try { document.documentElement.classList.add("mgps-modal-open"); } catch (_) { }
    try { document.body.classList.add("mgps-modal-open"); } catch (_) { }
  }

  function applyWrapMorePopup(rowEl, rowSpec) {
    if (!rowEl) return;
    const viewport = rowEl.parentElement && rowEl.parentElement.classList.contains("mgps-row-viewport")
      ? rowEl.parentElement
      : null;
    if (!viewport) return;

    let wrap = viewport.nextElementSibling;
    if (!(wrap && wrap.classList && wrap.classList.contains("mgps-more-popup-wrap"))) {
      wrap = null;
    }

    try {
      rowEl.style.flexWrap = "wrap";
      rowEl.style.justifyContent = "";
      rowEl.style.width = "100%";
      rowEl.style.minWidth = "0";
    } catch (_) { }

    const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb"));
    if (!cards.length) return;

    const firstTop = cards[0].offsetTop;
    let firstRowBottom = firstTop;
    for (const card of cards) {
      if (card.offsetTop === firstTop) {
        firstRowBottom = Math.max(firstRowBottom, card.offsetTop + card.offsetHeight);
      }
    }
    const collapsedHeight = Math.max(1, firstRowBottom);
    const needsMore = cards.some((card) => card.offsetTop > firstTop);

    if (!needsMore) {
      try { viewport.style.maxHeight = ""; } catch (_) { }
      if (wrap) wrap.remove();
      return;
    }

    try { viewport.style.maxHeight = collapsedHeight + "px"; } catch (_) { }

    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "mgps-more-popup-wrap";
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "mgps-more-popup-btn button button--secondary";
      btn.textContent = String(rowSpec?.more_popup_text || rowEl.dataset.morePopupText || "More");
      btn.addEventListener("click", (event) => {
        try { event.preventDefault(); } catch (_) { }
        try { event.stopPropagation(); } catch (_) { }
        openRowPopup(rowSpec);
      });
      wrap.appendChild(btn);
      viewport.insertAdjacentElement("afterend", wrap);
    } else {
      const btn = wrap.querySelector(".mgps-more-popup-btn");
      if (btn) btn.textContent = String(rowSpec?.more_popup_text || rowEl.dataset.morePopupText || "More");
    }
  }


  function makeSwatchPopupButton(meta, rowSpec, popupItems) {
    const rawButtonStyle = normalizePresetButtonStyle(meta?.button_style || "dropdown_box", "dropdown_box");
    const isSwatchLikeButton = rawButtonStyle === "swatch";
    const widthPercent = normalizePresetButtonWidthPercent(meta?.button_width_percent, 100);
    const buttonHeightPx = Math.max(0, Number(meta?.button_height_px || 0) || 0);
    const buttonMaxWidthPx = parsePixelValue(meta?.button_max_width_px ?? meta?.preset_button_max_width_px, 0);
    const buttonJustify = String(meta?.button_justify || "left").trim().toLowerCase() || "left";
    const openPopup = (event) => {
      try { event.preventDefault(); } catch (_) { }
      try { event.stopPropagation(); } catch (_) { }
      openSwatchPopup(rowSpec, popupItems, meta, event && event.currentTarget ? event.currentTarget : null);
    };

    if (isSwatchLikeButton) {
      const buttonAppearanceSource = String(meta?.button_appearance_source || "inherit_from_parent").trim().toLowerCase() || "inherit_from_parent";
      const useCustomSwatchAppearanceOnly = buttonAppearanceSource === "custom";
      const swatchButtonAppearance = {
        border_color: collapseWhitespace(meta?.preset_button_border_color || "") || "#000000",
        border_size: clampNumber(meta?.preset_button_border_size, 0, 20, 1),
        shadow_size: clampNumber(meta?.preset_button_shadow_size, 0, 60, 0),
        text_color: collapseWhitespace(meta?.preset_button_text_color || ""),
        text_size_mobile: clampNumber(meta?.preset_button_text_size_mobile, 0, 48, 0),
        text_size_desktop: clampNumber(meta?.preset_button_text_size_desktop, 0, 48, 0),
        text_behavior: String(meta?.preset_button_text_behavior || "wrap_text").trim().toLowerCase() || "wrap_text",
        border_radius_px: clampNumber(meta?.preset_button_border_radius_px, 0, 240, rowSpec?.corner_radius_px ?? 12),
        image_radius_px: clampNumber(meta?.preset_button_image_radius_px, 0, 240, rowSpec?.corner_radius_px ?? 12),
        background_color: collapseWhitespace(meta?.preset_button_background_color || "") || "transparent",
        gradient_color: collapseWhitespace(meta?.preset_button_gradient_color || ""),
        gradient_angle: clampNumber(meta?.preset_button_gradient_angle, 0, 360, 180),
        background_image: safeSrc(meta?.preset_button_background_image || ""),
        background_image_style: normalizeBackgroundImageStyle(meta?.preset_button_background_image_style, "center"),
        product_image_padding: clampNumber(meta?.preset_button_product_image_padding, 0, 120, 0),
        border_scope: normalizeBorderScope(meta?.preset_button_border_scope, "image"),
        text_style: String(meta?.preset_button_text_style || "normal").trim().toLowerCase() || "normal"
      };
      const swatchMeta = {
        type: "image",
        title: plainTextFromMaybeHtml(meta?.button_text || "View All"),
        alt: String(meta?.preset_button_image_alt || meta?.button_image_alt || plainTextFromMaybeHtml(meta?.button_text || "View All")),
        thumbnail: meta?.preset_button_image || meta?.button_image || "",
        corner_radius_px: rowSpec?.__rootCornerRadiusPx ?? rowSpec?.__cornerRadiusPx ?? rowSpec?.corner_radius_px ?? 12,
        __rowSwatchVerticalJustify: rowSpec?.swatch_vertical_justify || "bottom"
      };
      const swatchButtonRow = Object.assign({}, rowSpec || {}, {
        fit_row: false,
        row_display_type_mobile: "scale_to_fit",
        row_display_type_desktop: "scale_to_fit",
        row_display_type: "scale_to_fit",
        __forceRootAppearance: false,
        __forceRootBorderAppearance: false,
        __force_root_appearance: false,
        appearance: swatchButtonAppearance,
        selected_appearance: Object.assign({}, swatchButtonAppearance),
        __appearance: swatchButtonAppearance,
        __selectedAppearance: Object.assign({}, swatchButtonAppearance),
        corner_radius_px: swatchButtonAppearance.border_radius_px,
        __cornerRadiusPx: swatchButtonAppearance.border_radius_px
      });
      if (useCustomSwatchAppearanceOnly) {
        swatchButtonRow.__rootAppearance = null;
        swatchButtonRow.__rootSelectedAppearance = null;
        swatchButtonRow.__rootCornerRadiusPx = swatchButtonAppearance.border_radius_px;
        swatchButtonRow.__rootTextBehaviorOverride = "";
      }
      const card = makeSwatchCard(swatchMeta, swatchButtonRow, {});
      const block = card && card.__mgpsRefs ? card.__mgpsRefs.block : (card ? card.querySelector(".mgps-thumb-block") : null);
      if (card) {
        card.classList.add("mgps-swatch-popup-btn--swatch");
        card.style.removeProperty("width");
        card.style.removeProperty("max-width");
        card.style.removeProperty("min-width");
        card.style.removeProperty("flex");
        card.style.margin = "0";
      }
      if (block) {
        block.setAttribute("role", "button");
        block.setAttribute("tabindex", "0");
        block.setAttribute("aria-label", plainTextFromMaybeHtml(meta?.button_text || "View All swatches") || "View All swatches");
        block.style.cursor = "pointer";
        if (buttonHeightPx > 0) {
          const slot = card.__mgpsRefs && card.__mgpsRefs.slot ? card.__mgpsRefs.slot : card.querySelector(".mgps-thumb-slot");
          const imgWrap = card.__mgpsRefs && card.__mgpsRefs.imgWrap ? card.__mgpsRefs.imgWrap : card.querySelector(".mgps-img-wrap");
          if (slot) slot.style.minHeight = buttonHeightPx + "px";
          if (imgWrap) {
            imgWrap.classList.add("is-fixed-height");
            imgWrap.style.setProperty("--mgps-row-height", buttonHeightPx + "px");
          }
        }
        block.addEventListener("click", openPopup);
        block.addEventListener("keydown", (event) => {
          const key = String(event && event.key || "");
          if (key === "Enter" || key === " ") openPopup(event);
        });
      }
      return card;
    }

    const fakeRow = {
      preset_button: true,
      preset_button_set: "__mgps_popup__",
      preset_button_text: typeof meta?.button_text === "string" ? meta.button_text : "<p>View All</p>",
      preset_button_style: rawButtonStyle,
      preset_button_image: meta?.preset_button_image || meta?.button_image || "",
      preset_button_image_alt: meta?.preset_button_image_alt || meta?.button_image_alt || plainTextFromMaybeHtml(meta?.button_text || "View All"),
      preset_button_image_height_mobile: meta?.preset_button_image_height_mobile ?? meta?.button_image_height_mobile ?? 0,
      preset_button_image_height_desktop: meta?.preset_button_image_height_desktop ?? meta?.button_image_height_desktop ?? 0,
      preset_button_width_percent: widthPercent,
      preset_button_max_width_px: buttonMaxWidthPx,
      preset_button_heading_justify: meta?.preset_button_heading_justify || buttonJustify,
      preset_button_border_color: meta?.preset_button_border_color || "",
      preset_button_border_size: meta?.preset_button_border_size ?? 1,
      preset_button_shadow_size: meta?.preset_button_shadow_size ?? 0,
      preset_button_border_radius_px: meta?.preset_button_border_radius_px ?? 4,
      preset_button_background_color: meta?.preset_button_background_color || "",
      preset_button_text_color: meta?.preset_button_text_color || "",
      preset_button_gradient_color: meta?.preset_button_gradient_color || "",
      preset_button_gradient_angle: meta?.preset_button_gradient_angle ?? 180,
      preset_button_background_image: meta?.preset_button_background_image || "",
      preset_button_background_image_style: meta?.preset_button_background_image_style || "center",
      preset_button_text_size_mobile: meta?.preset_button_text_size_mobile ?? 0,
      preset_button_text_size_desktop: meta?.preset_button_text_size_desktop ?? 0,
      preset_button_text_behavior: meta?.preset_button_text_behavior || "wrap_text",
      preset_button_text_style: meta?.preset_button_text_style || "normal",
      preset_button_image_radius_px: meta?.preset_button_image_radius_px,
      preset_button_product_image_padding: meta?.preset_button_product_image_padding,
      preset_button_border_scope: meta?.preset_button_border_scope || "image_text"
    };
    const scaffold = makePresetButton(fakeRow, []);
    const button = scaffold.cloneNode(true);
    button.type = "button";
    button.removeAttribute("disabled");
    button.removeAttribute("aria-disabled");
    button.setAttribute("data-button-justify", buttonJustify);
    button.style.setProperty("--mgps-swatch-popup-btn-width", widthPercent + "%");
    if (buttonHeightPx > 0) {
      button.style.setProperty("--mgps-swatch-popup-btn-height", buttonHeightPx + "px");
      button.style.minHeight = buttonHeightPx + "px";
    }
    button.style.width = "min(100%, " + widthPercent + "%)";
    button.style.minWidth = "fit-content";
    button.style.flex = "0 0 auto";
    button.style.margin = "0";
    try { applyPresetButtonTextFit(button); } catch (_) { }

    button.addEventListener("click", openPopup);

    return button;
  }


  function applySwatchPopupGrid(renderedRoot, meta = {}) {
    if (!renderedRoot || !renderedRoot.querySelectorAll) return;

    const mobile = Math.max(0, Number(meta?.popup_swatches_per_row_mobile || 0) || 0);
    const desktop = Math.max(0, Number(meta?.popup_swatches_per_row_desktop || 0) || 0);
    const perRow = window.innerWidth <= 768 ? (mobile || desktop || 0) : (desktop || 0);

    if (!(perRow > 0)) return;

    renderedRoot.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => {
      const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb"));
      if (!cards.length) return;

      const viewport = rowEl.parentElement && rowEl.parentElement.classList.contains("mgps-row-viewport")
        ? rowEl.parentElement
        : null;

      const measureEl = viewport || rowEl;
      const cs = getComputedStyle(rowEl);
      const gap = Number.parseFloat(cs.columnGap || cs.gap || "5") || 5;
      const availableWidth = Math.max(0, Math.floor(measureEl.clientWidth || rowEl.clientWidth));
      if (!(availableWidth > 0)) return;

      const cardWidth = Math.max(1, Math.floor((availableWidth - (gap * Math.max(0, perRow - 1))) / perRow));

      if (viewport) {
        viewport.style.width = "100%";
        viewport.style.maxWidth = "100%";
        viewport.style.minWidth = "0";
        viewport.style.overflowX = "visible";
        viewport.style.overflowY = "visible";
      }

      rowEl.dataset.rowDisplayType = "wrap";
      rowEl.style.display = "flex";
      rowEl.style.flexWrap = "wrap";
      rowEl.style.justifyContent = "flex-start";
      rowEl.style.alignItems = "stretch";
      rowEl.style.width = "100%";
      rowEl.style.maxWidth = "100%";
      rowEl.style.minWidth = "0";
      rowEl.style.overflow = "visible";

      cards.forEach((card) => {
        card.style.width = cardWidth + "px";
        card.style.maxWidth = cardWidth + "px";
        card.style.minWidth = "0px";
        card.style.flex = "0 0 " + cardWidth + "px";
      });
    });
  }

  function stripPopupTriggersFromRows(rows) {
    const sourceRows = Array.isArray(rows) ? rows : [];
    return sourceRows.map((row) => {
      const nextRow = Object.assign({}, row || {});
      const originalItems = Array.isArray(rowItems(nextRow)) ? rowItems(nextRow) : [];
      const filteredItems = originalItems.filter((item) => {
        const itemType = String(item?.type || "").trim().toLowerCase();
        return itemType !== "swatch_popup_trigger" && itemType !== "popup_remaining_swatches_trigger";
      });
      nextRow.videos = filteredItems;
      nextRow.swatches = filteredItems;
      return nextRow;
    });
  }

  function resolvedSectionRowsForPopup(triggerEl) {
    const root = triggerEl && triggerEl.closest ? triggerEl.closest("[data-mg-product-swatches-root]") : null;
    if (!root) return [];

    const cachedRows = root && Array.isArray(root.__mgpsResolvedRows) ? cloneDeep(root.__mgpsResolvedRows) : [];
    if (cachedRows.length) return stripPopupTriggersFromRows(cachedRows);

    const setName = collapseWhitespace(root.getAttribute("data-mg-set") || root.getAttribute("data-vimeo-set") || "");
    if (!setName) return [];

    const matchedSettingsKey = resolveExistingSetKey(root.__mgpsMatchedSettingsKey || root.getAttribute("data-mgps-match-settings-preset-key") || "");
    const resolvedRows = resolveSet(setName, new Set(), { matchSettingsPresetKey: matchedSettingsKey });
    if (!resolvedRows.length) return [];

    return stripPopupTriggersFromRows(cloneDeep(resolvedRows));
  }

  function resolvedSwatchPopupRows(triggerEl, rowSpec, popupItems, meta = {}) {
    const triggerType = String(meta?.type || "").trim().toLowerCase();
    if (triggerType === "popup_remaining_swatches_trigger") {
      const sectionRows = resolvedSectionRowsForPopup(triggerEl);
      if (sectionRows.length) return sectionRows;
    }

    const popupRow = normalizeRow(Object.assign({}, rowSpec || {}, {
      heading: "",
      subheading: "",
      fit_row: false,
      row_display_type_mobile: "wrap",
      row_display_type_desktop: "wrap",
      row_display_type: "wrap",
      videos: popupItems
    }), { matchSettingsPresetKey: rowSpec && rowSpec.__rootMatchSettingsPresetKey });
    popupRow.__appearance = rowSpec && (rowSpec.__rootAppearance || rowSpec.__appearance);
    popupRow.__selectedAppearance = rowSpec && (rowSpec.__rootSelectedAppearance || rowSpec.__selectedAppearance);
    popupRow.__cornerRadiusPx = rowSpec && (rowSpec.__rootCornerRadiusPx ?? rowSpec.__cornerRadiusPx);
    return [popupRow];
  }

  function openSwatchPopup(rowSpec, popupItems, meta = {}, triggerEl = null) {
    const modal = ensureModal();
    try { if (modal && modal.node && !modal.node.hidden && modal.node.style.display !== "none" && typeof modal.push === "function") modal.push(); } catch (_) { }
    rememberModalOpenScrollPosition(modal);
    const hideHeader = (
      String(meta?.type || "").trim().toLowerCase() === "popup_remaining_swatches_trigger"
      || !!meta?.preset_hide_modal_header
      || !!meta?.hide_modal_header
      || !!rowSpec?.preset_hide_modal_header
    );
    const titleText = plainTextFromMaybeHtml((meta && meta.popup_title) || rowSpec?.heading || meta?.button_text || "View All");
    modal.title.textContent = hideHeader ? "" : titleText;

    try {
      if (modal.dialog) {
        modal.dialog.style.position = "relative";
        modal.dialog.classList.toggle("is-header-hidden", hideHeader);
      }
      if (modal.header) {
        if (hideHeader) {
          modal.header.style.display = "block";
          modal.header.style.padding = "0";
          modal.header.style.margin = "0";
          modal.header.style.minHeight = "0";
          modal.header.style.height = "0";
          modal.header.style.borderBottom = "0";
          modal.header.style.overflow = "visible";
        } else {
          modal.header.style.display = "";
          modal.header.style.padding = "";
          modal.header.style.margin = "";
          modal.header.style.minHeight = "";
          modal.header.style.height = "";
          modal.header.style.borderBottom = "";
          modal.header.style.overflow = "";
        }
      }
      if (modal.title) modal.title.style.display = hideHeader ? "none" : "";
      if (modal.closeBtn) {
        if (hideHeader) {
          modal.closeBtn.style.position = "absolute";
          modal.closeBtn.style.top = "12px";
          modal.closeBtn.style.right = "12px";
          modal.closeBtn.style.left = "auto";
          modal.closeBtn.style.bottom = "auto";
          modal.closeBtn.style.display = "inline-flex";
          modal.closeBtn.style.alignItems = "center";
          modal.closeBtn.style.justifyContent = "center";
          modal.closeBtn.style.width = "46px";
          modal.closeBtn.style.height = "46px";
          modal.closeBtn.style.padding = "0";
          modal.closeBtn.style.margin = "0";
          modal.closeBtn.style.border = "1px solid rgba(12, 26, 52, 0.18)";
          modal.closeBtn.style.borderRadius = "999px";
          modal.closeBtn.style.background = "rgba(255, 255, 255, 0.96)";
          modal.closeBtn.style.boxShadow = "0 10px 24px rgba(12, 26, 52, 0.18)";
          modal.closeBtn.style.color = "#102542";
          modal.closeBtn.style.fontSize = "32px";
          modal.closeBtn.style.fontWeight = "400";
          modal.closeBtn.style.lineHeight = "1";
          modal.closeBtn.style.zIndex = "999";
        } else {
          modal.closeBtn.style.position = "";
          modal.closeBtn.style.top = "";
          modal.closeBtn.style.right = "";
          modal.closeBtn.style.left = "";
          modal.closeBtn.style.bottom = "";
          modal.closeBtn.style.display = "";
          modal.closeBtn.style.alignItems = "";
          modal.closeBtn.style.justifyContent = "";
          modal.closeBtn.style.width = "";
          modal.closeBtn.style.height = "";
          modal.closeBtn.style.padding = "";
          modal.closeBtn.style.margin = "";
          modal.closeBtn.style.border = "";
          modal.closeBtn.style.borderRadius = "";
          modal.closeBtn.style.background = "";
          modal.closeBtn.style.boxShadow = "";
          modal.closeBtn.style.color = "";
          modal.closeBtn.style.fontSize = "";
          modal.closeBtn.style.fontWeight = "";
          modal.closeBtn.style.lineHeight = "";
          modal.closeBtn.style.zIndex = "";
        }
      }
    } catch (_) { }

    modal.body.innerHTML = "";
    modal.__swatchPopupMeta = meta;
    const popupRows = resolvedSwatchPopupRows(triggerEl, rowSpec, popupItems, meta);
    const popupRowsForRender = hideHeader
      ? (() => {
        const clonedRows = cloneDeep(popupRows);
        if (Array.isArray(clonedRows) && clonedRows.length) {
          clonedRows[0] = Object.assign({}, clonedRows[0], { heading: "" });
        }
        return clonedRows;
      })()
      : popupRows;
    const popupAppearance = rowSpec && (rowSpec.__rootAppearance || rowSpec.__appearance);
    const popupSelectedAppearance = rowSpec && (rowSpec.__rootSelectedAppearance || rowSpec.__selectedAppearance);
    const popupCornerRadiusPx = rowSpec && (rowSpec.__rootCornerRadiusPx ?? rowSpec.__cornerRadiusPx);
    const rendered = renderRows(popupRowsForRender, {
      inModal: true,
      appearance: popupAppearance,
      selectedAppearance: popupSelectedAppearance,
      cornerRadiusPx: popupCornerRadiusPx,
      forceRootAppearance: false,
      matchSettingsPresetKey: rowSpec && rowSpec.__rootMatchSettingsPresetKey
    });
    try {
      rendered.style.visibility = "hidden";
      rendered.style.opacity = "0";
      rendered.style.pointerEvents = "none";
    } catch (_) { }
    modal.body.appendChild(rendered);

    try { modal.node.hidden = false; } catch (_) { }
    try { modal.node.setAttribute("aria-hidden", "false"); } catch (_) { }
    try { modal.node.style.display = "flex"; } catch (_) { }
    try { modal.node.style.pointerEvents = "auto"; } catch (_) { }
    try { document.documentElement.classList.add("mgps-modal-open"); } catch (_) { }
    try { document.body.classList.add("mgps-modal-open"); } catch (_) { }

    const runLayout = () => {
      try {
        rendered.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => {
          rowEl.dataset.rowDisplayType = "wrap";
          applyFitRow(rowEl);
        });
        applySwatchPopupGrid(rendered, meta);
      } catch (_) { }
    };

    const revealRendered = () => {
      try {
        rendered.style.visibility = "";
        rendered.style.opacity = "";
        rendered.style.pointerEvents = "";
      } catch (_) { }
    };

    const settlePopupLayout = () => {
      const rowEls = Array.from(rendered.querySelectorAll(".mgps-thumb-row"));
      const fitHeightJobs = rowEls.map((rowEl) => {
        try {
          return Promise.resolve(primeRowFitToHeight(rowEl));
        } catch (_) {
          return Promise.resolve();
        }
      });

      Promise.allSettled(fitHeightJobs).finally(() => {
        try {
          requestAnimationFrame(() => {
            runLayout();
            requestAnimationFrame(() => {
              runLayout();
              revealRendered();
              window.setTimeout(() => {
                runLayout();
                revealRendered();
              }, 30);
            });
          });
        } catch (_) {
          runLayout();
          revealRendered();
        }
      });
    };

    try {
      requestAnimationFrame(() => {
        runLayout();
        requestAnimationFrame(() => {
          settlePopupLayout();
        });
      });
    } catch (_) { }
  }

  function renderRows(rows, opts = {}) {
    const rowsRoot = document.createElement("div");
    rowsRoot.className = "mgps-rows";
    if (opts.inModal) rowsRoot.classList.add("is-in-modal");
    let renderedRowIndex = 0;
    let stopInlineRowsAfterPopupRemaining = false;

    for (const rawRow of (Array.isArray(rows) ? rows : [])) {
      if (!opts.inModal && stopInlineRowsAfterPopupRemaining) break;
      if (shouldSkipRowImmediatelyForHandle(rawRow)) continue;
      const rowSpec = normalizeRow(rawRow, { matchSettingsPresetKey: opts && opts.matchSettingsPresetKey });
      if (!rowSpec || rowSpec.__skipRender) continue;
      const rowIndex = String(renderedRowIndex++);
      rowSpec.__rootAppearance = opts.appearance || null;
      rowSpec.__rootSelectedAppearance = opts.selectedAppearance || null;
      rowSpec.__rootCornerRadiusPx = Number.isFinite(Number(opts.cornerRadiusPx)) ? Number(opts.cornerRadiusPx) : null;
      rowSpec.__rootMatchSettingsPresetKey = resolveExistingSetKey(opts.matchSettingsPresetKey || "");
      rowSpec.__rootTextBehaviorOverride = String(opts.textBehaviorOverride || "").trim().toLowerCase();
      rowSpec.__forceRootAppearance = !!((opts && opts.forceRootAppearance) || rowSpec.__force_root_appearance);
      rowSpec.__forceRootBorderAppearance = !!(opts && opts.forceRootBorderAppearance);
      rowSpec.__appearance = rowSpec.__appearance || rowSpec.appearance || null;
      rowSpec.__selectedAppearance = rowSpec.__selectedAppearance || rowSpec.selected_appearance || null;
      rowSpec.__cornerRadiusPx = Number.isFinite(Number(rowSpec.__rootCornerRadiusPx)) ? Number(rowSpec.__rootCornerRadiusPx) : rowSpec.__cornerRadiusPx;
      if (!Number.isFinite(Number(rowSpec.__cornerRadiusPx))) rowSpec.__cornerRadiusPx = rowSpec.corner_radius_px;
      if (rowSpec.__selectedAppearance && rowSpec.__appearance && rowSpec.__appearance.border_scope) {
        rowSpec.__selectedAppearance.border_scope = rowSpec.__selectedAppearance.border_scope || rowSpec.__appearance.border_scope;
      }
      const rowWrap = document.createElement("section");
      rowWrap.className = "mgps-row";
      rowWrap.dataset.rowIndex = rowIndex;
      rowWrap.style.width = "100%";
      rowWrap.style.maxWidth = "100%";
      rowWrap.style.minWidth = "0";
      rowWrap.style.boxSizing = "border-box";
      if (rowSpec.margin_top > 0) rowWrap.style.marginTop = rowSpec.margin_top + "px";
      if (rowSpec.margin_bottom > 0) rowWrap.style.marginBottom = rowSpec.margin_bottom + "px";
      if (opts.inModal && rowSpec.popup_padding_between_rows > 0) rowWrap.style.marginBottom = rowSpec.popup_padding_between_rows + "px";
      rowWrap.dataset.rowJustify = String(rowSpec.row_justify || "center");

      // Preset-button rows already render their label and hint inside the button.
      const heading = rowSpec.preset_button ? null : buildRowHeading(rowSpec);
      if (heading) rowWrap.appendChild(heading);

      const hasCustom = renderCustomRow(rowSpec, rowWrap);
      const allItems = Array.isArray(rowSpec.videos) ? rowSpec.videos : [];
      let popupTrigger = null;
      let popupTriggerType = "";
      let collectPopupItems = false;
      const items = [];
      const popupItems = [];
      allItems.forEach((item) => {
        const itemType = String(item?.type || "").trim().toLowerCase();
        if (itemType === "swatch_popup_trigger" || itemType === "popup_remaining_swatches_trigger") {
          if (!popupTrigger) {
            popupTrigger = item;
            popupTriggerType = itemType;
            collectPopupItems = true;
          }
          return;
        }
        if (collectPopupItems) popupItems.push(item);
        else items.push(item);
      });

        if (rowSpec.preset_button) {
          if (rowSpec.button_switch) {
            const buttonSwitch = makeButtonSwitch(rowSpec);
            if (!buttonSwitch) continue;
            rowWrap.classList.add("is-preset-button");
            rowWrap.style.overflow = "visible";
            rowWrap.style.paddingLeft = "";
            rowWrap.style.paddingRight = "";
            rowWrap.style.marginBottom = "";
            rowWrap.appendChild(buttonSwitch);
            rowsRoot.appendChild(rowWrap);
            continue;
          }
          const presetSet = resolveExistingSetKey(rowSpec.preset_button_set || rowSpec.__import_set || "");
          const presetHref = safeLink(rowSpec.preset_button_href || rowSpec.button_href || "");
          const presetRows = presetSet ? resolveSet(presetSet, new Set()) : [];
          if (!presetRows.length && !presetHref) {
            if (shouldHideControlIfMissingDataset(opts && opts.root)) {
              setControlVisibility(opts && opts.root, false);
              continue;
            }
            rowWrap.appendChild(buildMissingSetMessage(presetSet));
            rowsRoot.appendChild(rowWrap);
            continue;
          }
          rowWrap.classList.add("is-preset-button");
          rowWrap.style.overflow = "visible";
          rowWrap.style.paddingLeft = "";
          rowWrap.style.paddingRight = "";
          rowWrap.style.marginBottom = "";
          const presetButton = makePresetButton(rowSpec, presetRows);
          rowWrap.appendChild(presetButton);
          const presetShadowSize = clampNumber(rowSpec.preset_button_shadow_size, 0, 60, 0);
          if (presetShadowSize > 0) {
            const spacer = document.createElement("div");
            spacer.setAttribute("aria-hidden", "true");
            spacer.style.width = "100%";
            spacer.style.height = presetShadowSize + "px";
            spacer.style.pointerEvents = "none";
            spacer.style.flex = "0 0 auto";
            rowWrap.appendChild(spacer);
          }
          rowsRoot.appendChild(rowWrap);
          continue;
        }

      if (items.length) {
        const rowDisplayTypeDesktop = String(rowSpec.row_display_type_desktop || rowSpec.row_display_type || "scrollable").trim().toLowerCase() || "scrollable";
        const rowDisplayTypeMobile = String(rowSpec.row_display_type_mobile || rowDisplayTypeDesktop).trim().toLowerCase() || rowDisplayTypeDesktop;
        const rowDisplayType = window.innerWidth <= 768 ? rowDisplayTypeMobile : rowDisplayTypeDesktop;

        const viewport = document.createElement("div");
        viewport.className = "mgps-row-viewport";
        viewport.dataset.rowDisplayType = rowDisplayType;
        viewport.dataset.rowDisplayTypeMobile = rowDisplayTypeMobile;
        viewport.dataset.rowDisplayTypeDesktop = rowDisplayTypeDesktop;
        viewport.style.width = "100%";
        viewport.style.maxWidth = "100%";
        viewport.style.minWidth = "0";
        viewport.style.boxSizing = "border-box";

        const rowEl = document.createElement("div");
        rowEl.className = "mgps-thumb-row";
        rowEl.dataset.rowIndex = rowIndex;
        rowEl.dataset.swatchRow = "true";
        rowEl.dataset.fitRow = rowSpec.fit_row ? "true" : "false";
        rowEl.dataset.rowDisplayType = rowDisplayType;
        rowEl.dataset.rowDisplayTypeMobile = rowDisplayTypeMobile;
        rowEl.dataset.rowDisplayTypeDesktop = rowDisplayTypeDesktop;
        rowEl.dataset.morePopupText = String(rowSpec.more_popup_text || "More");
        rowEl.dataset.rowJustify = String(rowSpec.row_justify || "center");
        rowEl.dataset.imgRatio = String(rowSpec.img_ratio || "1:1");
        rowEl.dataset.rowHeight = String(Number(rowSpec.row_height_desktop || rowSpec.row_height || 0) || 0);
        rowEl.dataset.rowHeightMobile = String(Number(rowSpec.row_height_mobile || 0) || 0);
        rowEl.dataset.rowHeightDesktop = String(Number(rowSpec.row_height_desktop || rowSpec.row_height || 0) || 0);
        rowEl.dataset.swatchesPerRowMobile = String(Math.max(0, Number(rowSpec.swatches_per_row_mobile || 0) || 0));
        rowEl.dataset.swatchesPerRowDesktop = String(Math.max(0, Number(rowSpec.swatches_per_row_desktop || rowSpec.swatches_per_row || 0) || 0));
        rowEl.dataset.paddingBetweenRowsMobile = String(Math.max(0, Number(rowSpec.padding_between_rows_mobile || 0) || 0));
        rowEl.dataset.paddingBetweenRowsDesktop = String(Math.max(0, Number(rowSpec.padding_between_rows_desktop || rowSpec.padding_between_rows || 0) || 0));
        rowEl.dataset.swatchVerticalJustify = normalizeSwatchVerticalJustify(rowSpec.swatch_vertical_justify, "bottom");
        rowEl.dataset.swatchesPerRow = rowEl.dataset.swatchesPerRowDesktop;
        rowEl.style.overflow = "visible";
        const _mgpsRowCornerRadius = (() => { const raw = (rowSpec.__cornerRadiusPx ?? rowSpec.corner_radius_px); const v = Number(raw); return Number.isFinite(v) && v >= 0 ? v : 12; })();
        rowEl.dataset.cornerRadiusPx = String(_mgpsRowCornerRadius);
        rowEl.style.setProperty("--mgps-row-corner-radius", String(_mgpsRowCornerRadius) + "px");
        rowEl.__rowSpec = rowSpec;
        rowEl.style.setProperty("--mgps-row-justify", String(rowSpec.row_justify || "center"));
        rowEl.style.setProperty("--mgps-row-aspect", (() => {
          const ratio = parseImgRatio(rowSpec.img_ratio || "1:1");
          return ratio.w + " / " + ratio.h;
        })());
        const initialRowHeight = (window.innerWidth <= 768)
          ? (Number(rowSpec.row_height_mobile || 0) || Number(rowSpec.row_height_desktop || rowSpec.row_height || 0) || 0)
          : (Number(rowSpec.row_height_desktop || rowSpec.row_height || 0) || 0);
        if (initialRowHeight > 0) rowEl.style.setProperty("--mgps-row-height", initialRowHeight + "px");
        const initialPaddingBetweenRows = (window.innerWidth <= 768)
          ? (Number(rowSpec.padding_between_rows_mobile || 0) || Number(rowSpec.padding_between_rows_desktop || rowSpec.padding_between_rows || 0) || 0)
          : (Number(rowSpec.padding_between_rows_desktop || rowSpec.padding_between_rows || 0) || 0);
        rowEl.style.setProperty("--mgps-padding-between-rows", initialPaddingBetweenRows + "px");
        setRowFitToHeightPending(rowEl, rowUsesFitToHeight(rowSpec));
        if (rowDisplayType === "scale_to_fit" && rowSpec.fit_row) {
          setRowFitVisibility(rowEl, false);
        } else {
          setRowFitVisibility(rowEl, true);
        }

        items.forEach((item) => rowEl.appendChild(makeSwatchCard(item, rowSpec, { inModal: !!opts.inModal })));
        const popupTriggerStyle = popupTrigger
          ? normalizePresetButtonStyle(popupTrigger?.button_style || "dropdown_box", "dropdown_box")
          : "";
        if (popupTrigger && popupTriggerStyle === "swatch") {
          const popupModalItems = popupTrigger?.include_visible_swatches_in_popup
            ? items.concat(popupItems)
            : (popupItems.length ? popupItems : items);
          rowEl.appendChild(makeSwatchPopupButton(popupTrigger, rowSpec, popupModalItems));
        }
        applyRowCornerRadius(rowEl);
        viewport.appendChild(rowEl);
        rowWrap.appendChild(viewport);

      }

      if (
        popupTrigger
        && normalizePresetButtonStyle(popupTrigger?.button_style || "dropdown_box", "dropdown_box") !== "swatch"
        && ((items.length + popupItems.length) > 0)
      ) {
        const popupWrap = document.createElement("div");
        popupWrap.className = "mgps-swatch-popup-wrap";
        const popupJustify = String(popupTrigger?.button_justify || "left").trim().toLowerCase() || "left";
        const popupMarginTop = Math.max(0, Number(popupTrigger?.button_margin_top ?? popupTrigger?.margin_top_px ?? 10) || 10);
        const popupModalItems = popupTrigger?.include_visible_swatches_in_popup
          ? items.concat(popupItems)
          : (popupItems.length ? popupItems : items);
        popupWrap.dataset.buttonJustify = popupJustify;
        popupWrap.setAttribute("data-button-justify", popupJustify);
        popupWrap.style.display = "flex";
        popupWrap.style.width = "100%";
        popupWrap.style.maxWidth = "100%";
        popupWrap.style.minWidth = "0";
        popupWrap.style.marginTop = popupMarginTop + "px";
        popupWrap.style.justifyContent =
          popupJustify === "center" ? "center" :
            popupJustify === "right" ? "flex-end" :
              "flex-start";
        popupWrap.appendChild(makeSwatchPopupButton(popupTrigger, rowSpec, popupModalItems));
        rowWrap.appendChild(popupWrap);
      }

      if (heading || hasCustom || items.length || popupTrigger) rowsRoot.appendChild(rowWrap);
      if (!opts.inModal && popupTriggerType === "popup_remaining_swatches_trigger") {
        stopInlineRowsAfterPopupRemaining = true;
      }
    }

    return rowsRoot;
  }


  function applyRowCornerRadius(rowEl) {
    if (!rowEl) return;
    const rowSpec = rowEl.__rowSpec || {};
    const radius = resolvedRowCornerRadiusPx(rowSpec, (() => { const v = Number(rowEl.dataset.cornerRadiusPx); return Number.isFinite(v) && v >= 0 ? v : 12; })());

    try {
      rowEl.dataset.cornerRadiusPx = String(radius);
      rowEl.style.setProperty("--mgps-row-corner-radius", radius + "px");
    } catch (_) { }

    rowEl.querySelectorAll(":scope > .mgps-thumb").forEach((card) => {
      const isSelected = String(card.dataset.currentProduct || "") === "true";
      const appearance = resolvedRowAppearance(rowSpec, isSelected) || {};
      const imageRadius = resolvedAppearanceImageRadiusPx(appearance, rowSpec, radius);
      const blockRadius = resolvedAppearanceBorderRadiusPx(appearance, rowSpec, radius);
      const borderScope = normalizeBorderScope(appearance.border_scope, "image");
      const refs = swatchCardRefs(card);

      try {
        card.style.setProperty("--mgps-corner-radius", imageRadius + "px");
      } catch (_) { }

      const slot = refs.slot;
      if (slot) {
        try {
          slot.style.borderRadius = imageRadius + "px";
          slot.style.overflow = "hidden";
          slot.style.setProperty("--mgps-corner-radius", imageRadius + "px");
          if (imageRadius === 0) {
            slot.style.borderTopLeftRadius = "0";
            slot.style.borderTopRightRadius = "0";
            slot.style.borderBottomLeftRadius = "0";
            slot.style.borderBottomRightRadius = "0";
          }
        } catch (_) { }
      }

      const imgWrap = refs.imgWrap;
      if (imgWrap) {
        try {
          imgWrap.style.borderRadius = imageRadius + "px";
          imgWrap.style.overflow = "hidden";
          imgWrap.style.setProperty("--mgps-corner-radius", imageRadius + "px");
          if (imageRadius === 0) {
            imgWrap.style.borderTopLeftRadius = "0";
            imgWrap.style.borderTopRightRadius = "0";
            imgWrap.style.borderBottomLeftRadius = "0";
            imgWrap.style.borderBottomRightRadius = "0";
          }
        } catch (_) { }
      }

      const imgInner = refs.imgInner;
      if (imgInner) {
        try {
          imgInner.style.borderRadius = imageRadius + "px";
          imgInner.style.overflow = "hidden";
          imgInner.style.setProperty("--mgps-corner-radius", imageRadius + "px");
          if (imageRadius === 0) {
            imgInner.style.borderTopLeftRadius = "0";
            imgInner.style.borderTopRightRadius = "0";
            imgInner.style.borderBottomLeftRadius = "0";
            imgInner.style.borderBottomRightRadius = "0";
          }
        } catch (_) { }
      }

      const block = refs.block;
      if (block) {
        try {
          setStyleImportant(block, "border-radius", borderScope === "image_text" ? (blockRadius + "px") : "0");
        } catch (_) { }
      }
    });
  }

  function applyEditorPreviewSelection(root) {
    if (!root || !window.Shopify || !window.Shopify.designMode) return;
    try {
      root.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => {
        const rowSpec = rowEl.__rowSpec || {};
        if (String(rowSpec.block_type || "").trim().toLowerCase() === "swatch_variant") return;
        const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb[data-kind='product']"));
        if (!cards.length) return;
        const hasCurrent = cards.some((card) => String(card.dataset.currentProduct || "") === "true");
        if (hasCurrent) return;

        const card = cards[0];
        card.dataset.currentProduct = "true";

        const refs = swatchCardRefs(card);
        const block = refs.block;
        const slot = refs.slot;
        const imgWrap = refs.imgWrap;
        const bottom = refs.bottom;
        const img = refs.img;
        if (block && block.tagName === "A") {
          try {
            block.removeAttribute("href");
            block.removeAttribute("target");
            block.setAttribute("aria-current", "page");
            block.setAttribute("aria-disabled", "true");
          } catch (_) { }
        }
        applySwatchAppearance(card, block, slot, imgWrap, bottom, img, rowSpec, true);
      });
      root.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => {
        applyRowTextSizing(rowEl);
      });
    } catch (_) { }
  }

  function relayoutRoot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => {
      applyFitRow(rowEl);
      applyRowSwatchVerticalLayout(rowEl);
      applyRowCornerRadius(rowEl);
      try {
        const rowSpec = rowEl.__rowSpec || {};
        rowEl.querySelectorAll(":scope > .mgps-thumb").forEach((card) => {
          const refs = swatchCardRefs(card);
          applySwatchAppearance(
            card,
            refs.block,
            refs.slot,
            refs.imgWrap,
            refs.bottom,
            refs.img,
            rowSpec,
            String(card.dataset.currentProduct || "") === "true"
          );
        });
      } catch (_) { }
    });
    try { applyPresetButtonTextFit(root); } catch (_) { }
  }

  function scheduleRelayoutRoot(root) {
    if (!root || root.__mgpsRelayoutQueued) return;
    root.__mgpsRelayoutQueued = true;
    const run = () => {
      try { delete root.__mgpsRelayoutQueued; } catch (_) { root.__mgpsRelayoutQueued = false; }
      try { relayoutRoot(root); } catch (_) { }
    };
    try {
      requestAnimationFrame(run);
    } catch (_) {
      run();
    }
  }

  function renderRoot(root) {
    if (!root) return;
    const setName = String(root.getAttribute("data-mg-set") || root.getAttribute("data-vimeo-set") || "").trim();
    if (!setName) {
      root.innerHTML = "";
      return;
    }

    const matchedSettingsKey = resolveExistingSetKey(getDataAttr(root, "data-mgps-match-settings-preset"));
    const isCustomSwatchPickerRoot = !!(root.classList && root.classList.contains("mg-product-swatches"));
    const isSwatchPresetRoot = false;
    const shouldBypassMatchedScaleInheritance = isCustomSwatchPickerRoot || isSwatchPresetRoot;
    const rowResolutionMatchSettingsKey = shouldBypassMatchedScaleInheritance ? "" : matchedSettingsKey;
    const rowResolutionOpts = shouldBypassMatchedScaleInheritance
      ? {
        matchSettingsPresetKey: "",
        ignoreSourceMatchSettings: true,
        disableMatchedPresetRowMerge: true,
        preferMediaGallerySets: isSwatchPresetRoot
      }
      : { matchSettingsPresetKey: matchedSettingsKey };
    const rootAppearance = parseRootSwatchAppearance(root);
    const explicitRootAppearance = matchedSettingsKey ? false : rootHasExplicitAppearance(root);
    const explicitRootBorderAppearance = matchedSettingsKey ? false : rootHasExplicitBorderAppearance(root);
    const resolvedMeta = matchedSettingsKey
      ? resolveSetMeta(matchedSettingsKey, new Set())
      : (explicitRootAppearance ? {} : resolveSetMeta(setName, new Set()));
    const metaAppearance = isNonEmptyObject(resolvedMeta.appearance)
      ? normalizeSwatchAppearance(resolvedMeta.appearance, "image")
      : null;
    const metaSelectedAppearance = isNonEmptyObject(resolvedMeta.selected_appearance)
      ? normalizeSwatchAppearance(resolvedMeta.selected_appearance, (metaAppearance && metaAppearance.border_scope) || "image")
      : null;
    if (metaSelectedAppearance && metaAppearance && metaAppearance.border_scope) {
      metaSelectedAppearance.border_scope = metaSelectedAppearance.border_scope || metaAppearance.border_scope;
    }
    const textBehaviorOverride = matchedSettingsKey ? "" : rootTextBehaviorOverride(root);
    if (textBehaviorOverride) {
      if (metaAppearance) metaAppearance.text_behavior = textBehaviorOverride;
      if (metaSelectedAppearance) metaSelectedAppearance.text_behavior = textBehaviorOverride;
      rootAppearance.appearance.text_behavior = textBehaviorOverride;
      rootAppearance.selectedAppearance.text_behavior = textBehaviorOverride;
    }
    const metaCorner = (() => {
      const v = Number(resolvedMeta.corner_radius_px);
      return Number.isFinite(v) && v >= 0 ? v : null;
    })();

    const mergedRootAppearance = metaAppearance
      ? (
        explicitRootAppearance
          ? mergeSwatchAppearance(metaAppearance, rootAppearance.appearance, metaAppearance.border_scope || "image")
          : normalizeSwatchAppearance(metaAppearance, metaAppearance.border_scope || "image")
      )
      : rootAppearance.appearance;
    const mergedRootSelectedAppearance = metaSelectedAppearance
      ? (
        explicitRootAppearance
          ? mergeSwatchAppearance(metaSelectedAppearance, rootAppearance.selectedAppearance, (mergedRootAppearance && mergedRootAppearance.border_scope) || "image")
          : normalizeSwatchAppearance(metaSelectedAppearance, (mergedRootAppearance && mergedRootAppearance.border_scope) || "image")
      )
      : rootAppearance.selectedAppearance;
    if (mergedRootSelectedAppearance && mergedRootAppearance && mergedRootAppearance.border_scope) {
      mergedRootSelectedAppearance.border_scope = mergedRootSelectedAppearance.border_scope || mergedRootAppearance.border_scope;
    }

    root.__mgpsAppearance = mergedRootAppearance || rootAppearance.appearance;
    root.__mgpsSelectedAppearance = mergedRootSelectedAppearance || rootAppearance.selectedAppearance;
    root.__mgpsCornerRadiusPx = explicitRootAppearance ? rootAppearance.cornerRadiusPx : (metaCorner != null ? metaCorner : rootAppearance.cornerRadiusPx);

    let rows = resolveSet(setName, new Set(), rowResolutionOpts);
    if (!rows.length && registerLocalSpecForRoot(root, setName)) {
      rows = resolveSet(setName, new Set(), rowResolutionOpts);
    }
    root.__mgpsResolvedRows = cloneDeep(rows);

    if (isDebugAppearanceEnabled() && typeof console !== "undefined" && console.info) {
      try {
        const firstRow = Array.isArray(rows) && rows.length ? rows[0] : null;
        const debugPayload = {
          setName,
          matchedSettingsKey,
          explicitRootAppearance,
          explicitRootBorderAppearance,
          rootAppearance: root.__mgpsAppearance,
          rootSelectedAppearance: root.__mgpsSelectedAppearance,
          firstRowAppearance: firstRow && firstRow.appearance,
          firstRowSelectedAppearance: firstRow && firstRow.selected_appearance,
          firstRowForceRootAppearance: !!(firstRow && firstRow.__force_root_appearance)
        };
        console.info("[MGPS][appearance-debug]", debugPayload);
        mountAppearanceDebugBadge(debugPayload);
      } catch (_) { }
    }

    if (!rows.length) {
      root.innerHTML = "";
      if (shouldHideControlIfMissingDataset(root)) {
        setControlVisibility(root, false);
        return;
      }
      if (!shouldHideControlIfMissingDataset(root)) {
        setControlVisibility(root, true);
        root.appendChild(buildMissingSetMessage(setName));
      }
      return;
    }

    const releaseRootHeight = preserveRootHeightDuringSwap(root);
    const rendered = renderRows(rows, {
      appearance: root.__mgpsAppearance,
      selectedAppearance: root.__mgpsSelectedAppearance,
      cornerRadiusPx: root.__mgpsCornerRadiusPx,
      textBehaviorOverride: textBehaviorOverride,
      matchSettingsPresetKey: rowResolutionMatchSettingsKey,
      forceRootAppearance: false,
      forceRootBorderAppearance: explicitRootBorderAppearance,
      root: root
    });
    root.replaceChildren(rendered);
    ensureInitialSwatchSelections(root);
    applyPendingSelectedSwatches(root);
    setControlVisibility(root, true);
    try {
      root.querySelectorAll(".mgps-thumb-row[data-fit-height-pending='true']").forEach((rowEl) => {
        primeRowFitToHeight(rowEl);
      });
    } catch (_) { }
    applyEditorPreviewSelection(root);
    ensureInlineExportUIForRoot(root);
    try {
      requestAnimationFrame(() => {
        try { applyPresetButtonTextFit(root); } catch (_) { }
      });
    } catch (_) { }
    requestAnimationFrame(() => {
      try { relayoutRoot(root); } catch (_) { }
      requestAnimationFrame(() => {
        releaseRootHeight();
      });
    });
  }

  function scheduleRowRelayout(rowEl) {
    if (!rowEl || rowEl.__mgpsRowRelayoutQueued) return;
    rowEl.__mgpsRowRelayoutQueued = true;
    const run = () => {
      try { delete rowEl.__mgpsRowRelayoutQueued; } catch (_) { rowEl.__mgpsRowRelayoutQueued = false; }
      try { applyFitRow(rowEl); } catch (_) { }
      try { applyRowSwatchVerticalLayout(rowEl); } catch (_) { }
    };
    try {
      requestAnimationFrame(run);
    } catch (_) {
      run();
    }
  }

  function initRoot(root) {
    if (!root || root.__mgpsInit) return;
    root.__mgpsInit = true;

    const cleanupFns = [];

    renderRoot(root);

    if (typeof ResizeObserver === "function") {
      const ro = new ResizeObserver(() => {
        scheduleRelayoutRoot(root);
      });
      ro.observe(root);
      cleanupFns.push(() => {
        try { ro.disconnect(); } catch (_) { }
      });
    } else {
      const onResize = () => scheduleRelayoutRoot(root);
      window.addEventListener("resize", onResize);
      cleanupFns.push(() => window.removeEventListener("resize", onResize));
    }

    try {
      if (document.fonts) {
        const onFontsDone = () => scheduleRelayoutRoot(root);
        if (document.fonts.ready && typeof document.fonts.ready.then === "function") {
          document.fonts.ready.then(onFontsDone).catch(() => { });
        }
        if (document.fonts.addEventListener) {
          document.fonts.addEventListener("loadingdone", onFontsDone);
          cleanupFns.push(() => {
            try { document.fonts.removeEventListener("loadingdone", onFontsDone); } catch (_) { }
          });
        }
      }
    } catch (_) { }

    root.__mgpsDestroy = function () {
      cleanupFns.forEach((fn) => {
        try { fn(); } catch (_) { }
      });
      root.innerHTML = "";
      try { delete root.__mgpsInit; } catch (_) { }
      try { delete root.__mgpsDestroy; } catch (_) { }
    };
  }

  function stripInternalsForExport(value) {
    const replacer = (key, currentValue) => {
      if (key && key.startsWith("__")) return undefined;
      if (typeof currentValue === "function") return undefined;
      if (currentValue && typeof currentValue === "object") {
        try {
          if (currentValue === window || currentValue === document) return undefined;
          if (currentValue.nodeType) return undefined;
        } catch (_) { }
      }
      return currentValue;
    };

    try {
      return JSON.parse(JSON.stringify(value, replacer));
    } catch (_) {
      return cloneDeep(value);
    }
  }

  function isExportBlankValue(value) {
    if (value == null) return true;
    if (typeof value === "string") return collapseWhitespace(value) === "";
    if (Array.isArray(value)) return value.length === 0;
    if (value && typeof value === "object") return !Object.keys(value).length;
    return false;
  }

  function pruneBlankRowExportFields(row) {
    const copy = Object.assign({}, row || {});
    pruneDefaultScaleExportFields(copy);
    Object.keys(copy).forEach((key) => {
      if (key === "swatches") return;
      if (isExportBlankValue(copy[key])) delete copy[key];
    });
    return copy;
  }

  function isDefaultScaleExportValue(value) {
    const n = Number(value);
    return Number.isFinite(n) && Math.round(n) === 100;
  }

  function pruneDefaultScaleExportFields(copy) {
    if (!copy || typeof copy !== "object") return copy;
    [
      "swatch_image_zoom",
      "swatchImageZoom",
      "scale",
      "product_image_scale",
      "productImageScale"
    ].forEach((key) => {
      if (!Object.prototype.hasOwnProperty.call(copy, key)) return;
      if (isDefaultScaleExportValue(copy[key])) delete copy[key];
    });
    return copy;
  }

  function pruneRuntimeProductExportFields(copy) {
    if (!copy || typeof copy !== "object") return copy;
    [
      "price",
      "price_num",
      "priceNum",
      "available",
      "product_id",
      "productId",
      "product_image_id",
      "productImageId"
    ].forEach((key) => {
      delete copy[key];
    });
    return copy;
  }

  function pruneItemExportFields(item) {
    const copy = Object.assign({}, item || {});
    pruneRuntimeProductExportFields(copy);
    pruneDefaultScaleExportFields(copy);
    ["product_variant_id", "variant_id", "variantId"].forEach((key) => {
      if (!Object.prototype.hasOwnProperty.call(copy, key)) return;
      if (isExportBlankValue(copy[key])) delete copy[key];
    });
    return copy;
  }

  function prepareRowsForSetExport(rows, rootOrMeta) {
    const cleaned = stripInternalsForExport(rows);
    const normalizedRows = Array.isArray(cleaned) ? cleaned : coerceToRows(cleaned);
    const exportMeta = rootOrMeta && rootOrMeta.nodeType ? readRootAppearanceMeta(rootOrMeta) : (rootOrMeta || {});
    const matchedSettingsKey = collapseWhitespace(exportMeta.match_settings_preset_key || exportMeta.matchPresetSettingsKey || "");
    const shouldPreserveSwatchPresetScaleFields = !!(
      rootOrMeta
      && rootOrMeta.nodeType
      && (
        (rootOrMeta.classList && rootOrMeta.classList.contains("mg-product-swatches"))
      )
    );
    const shouldStripMatchedPresetScaleFields = !!matchedSettingsKey && !shouldPreserveSwatchPresetScaleFields;

    return normalizedRows.map((row) => {
      const copy = Object.assign({}, row || {});
      const items = normalizeItems(rowItems(copy));
      const hasCurrentProductVariantSource = items.some((item) => {
        const itemType = String(item && item.type || "").trim().toLowerCase();
        return itemType === "current_product_variants_source";
      });

      copy.swatches = items;
      if (hasCurrentProductVariantSource) copy.block_type = "swatch_variant";

      delete copy.videos;
      delete copy.items;
      delete copy.cards;
      delete copy.corner_radius_px;
      delete copy.appearance;
      delete copy.selected_appearance;
      delete copy.swatch_appearance;
      delete copy.swatch_selected_appearance;
      delete copy.match_settings_preset_key;
      delete copy.matchPresetSettingsKey;
      delete copy.swatch_image_size_percent;
      delete copy.swatchImageSizePercent;
      if (shouldStripMatchedPresetScaleFields) {
        const strippedRow = stripMatchedPresetRowSettings(copy);
        Object.keys(copy).forEach((key) => {
          if (!Object.prototype.hasOwnProperty.call(strippedRow, key)) delete copy[key];
        });
      }

      copy.swatches = items.map((item) => {
        const rawItem = item || {};
        const rawItemType = String(rawItem.type || "").trim().toLowerCase();
        const itemCopy = shouldStripMatchedPresetScaleFields
          ? (
            rawItemType === "popup_remaining_swatches_trigger"
              ? stripMatchedPresetPopupRemainingTriggerSettings(rawItem)
              : stripMatchedPresetItemSettingsForExport(rawItem)
          )
          : Object.assign({}, rawItem);
        const thumbMode = String(itemCopy.thumb_mode || itemCopy.thumbMode || "").trim().toLowerCase();
        const savedProductImageUrl = collapseWhitespace(itemCopy.product_image_url || itemCopy.productImageUrl || "");
        if (thumbMode !== "override" && savedProductImageUrl) {
          delete itemCopy.thumbnail;
          delete itemCopy.image;
          delete itemCopy.img;
          delete itemCopy.product_image_id;
        }
        delete itemCopy.match_settings_preset_key;
        delete itemCopy.matchPresetSettingsKey;
        return pruneItemExportFields(itemCopy);
      });

      return pruneBlankRowExportFields(copy);
    });
  }

  function readRootAppearanceMeta(root) {
    if (!root) return { appearance: {}, selected_appearance: {}, corner_radius_px: 12 };
    const matchedSettingsKey = collapseWhitespace(root.getAttribute("data-mgps-match-settings-preset"));
    if (matchedSettingsKey) {
      return {
        match_settings_preset_key: matchedSettingsKey
      };
    }
    const parsed = parseRootSwatchAppearance(root);
    const cornerRaw = root.getAttribute("data-mgps-corner-radius");
    const corner = Number(cornerRaw);
    return {
      appearance: Object.assign({}, parsed.appearance || {}),
      selected_appearance: Object.assign({}, parsed.selectedAppearance || {}),
      corner_radius_px: Number.isFinite(corner) && corner >= 0 ? corner : 12
    };
  }

  function normalizeMetaForExport(meta) {
    const source = meta && typeof meta === "object" ? meta : {};
    const matchedSettingsKey = collapseWhitespace(source.match_settings_preset_key || source.matchPresetSettingsKey || "");
    if (matchedSettingsKey) {
      return {
        match_settings_preset_key: matchedSettingsKey
      };
    }
    return Object.assign({}, source);
  }

  function scrubRowLevelSwatchImageSizeFields(rows) {
    const arr = Array.isArray(rows) ? rows : [];
    return arr.map((row) => {
      const copy = Object.assign({}, row || {});
      delete copy.swatch_image_size_percent;
      delete copy.swatchImageSizePercent;
      return copy;
    });
  }

  function prepareSetPayloadForExport(root, rows) {
    const meta = normalizeMetaForExport(readRootAppearanceMeta(root));
    return {
      meta: meta,
      rows: scrubRowLevelSwatchImageSizeFields(prepareRowsForSetExport(rows, meta))
    };
  }

  function rawRowsForExport(key, fallbackRows) {
    const setKey = collapseWhitespace(key);
    if (setKey && Object.prototype.hasOwnProperty.call(R.__rawSpecs, setKey)) {
      return coerceToRows(R.__rawSpecs[setKey] && R.__rawSpecs[setKey].rows);
    }

    const store = getSetStore();
    if (setKey && Object.prototype.hasOwnProperty.call(store, setKey)) {
      const value = store[setKey];
      const payload = getSetPayload(value);
      return coerceToRows(payload ? payload.rows : value);
    }

    return Array.isArray(fallbackRows) ? cloneDeep(fallbackRows) : [];
  }

  function formatSetExport(key, rows, root) {
    try { buildFromDom(document); } catch (_) { }
    const json = JSON.stringify(prepareSetPayloadForExport(root, rows), null, 2);
    const lines = [
      "// MG Product Swatches export: " + key,
      "window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};",
      "window.MG_SWATCH_SETS[" + JSON.stringify(key) + "] = " + json + ";"
    ];

    collectExportDependencyPayloads(key, rows, document).forEach((entry) => {
      lines.push(formatSetInnerExport(entry.key, entry.rows, entry.meta));
    });

    return lines.join("\n");
  }

  function formatSetInnerExport(key, rows, root) {
    const json = JSON.stringify(prepareSetPayloadForExport(root, rows), null, 2);
    return "window.MG_SWATCH_SETS[" + JSON.stringify(String(key || "")) + "] = " + json + ";";
  }

  function collectReferencedSetKeys(rows, seen) {
    const refs = [];
    const visited = seen || new Set();
    const queue = Array.isArray(rows) ? rows.slice() : [];

    while (queue.length) {
      const row = queue.shift();
      if (!row || typeof row !== "object") continue;

      const presetSet = collapseWhitespace(row.preset_button_set || row.__preset_button_set || "");
      if (presetSet && !visited.has(presetSet)) {
        visited.add(presetSet);
        refs.push(presetSet);
      }
    }

    return refs;
  }

  function getExportMetaForKey(key, rootMetaMap, store) {
    if (!key) return {};
    try {
      const rootMeta = rootMetaMap && rootMetaMap[key];
      if (rootMeta && typeof rootMeta === "object") return normalizeMetaForExport(rootMeta);
    } catch (_) { }
    try {
      if (store && Object.prototype.hasOwnProperty.call(store, key)) {
        return normalizeMetaForExport(getSetMeta(store[key]) || {});
      }
    } catch (_) { }
    return {};
  }

  function collectExportDependencyPayloads(primaryKey, primaryRows, context) {
    const store = getSetStore();
    const rootMetaMap = collectRootMetaMap(context);
    const ordered = [];
    const seen = new Set();
    const pending = collectReferencedSetKeys(primaryRows, seen);

    while (pending.length) {
      const refKey = pending.shift();
      if (!refKey || refKey === primaryKey) continue;

      const refRows = rawRowsForExport(refKey, []);
      if (!Array.isArray(refRows) || !refRows.length) continue;

      ordered.push({
        key: refKey,
        rows: refRows,
        meta: getExportMetaForKey(refKey, rootMetaMap, store)
      });

      collectReferencedSetKeys(refRows, seen).forEach((nestedKey) => {
        if (nestedKey && nestedKey !== primaryKey) pending.push(nestedKey);
      });
    }

    return ordered;
  }

  function collectRootMetaMap(context) {
    const scope = context && context.querySelectorAll ? context : document;
    const map = Object.create(null);
    getRoots(scope).forEach((root) => {
      try {
        const key = collapseWhitespace(root && root.getAttribute && root.getAttribute("data-mg-set"));
        if (!key) return;
        map[key] = readRootAppearanceMeta(root);
      } catch (_) { }
    });
    return map;
  }

  function formatAllExport(context) {
    try { buildFromDom(context && context.querySelectorAll ? context : document); } catch (_) { }
    const store = getSetStore();
    const rootMetaMap = collectRootMetaMap(context);
    const cleaned = Object.create(null);
    Object.keys(store).sort().forEach((key) => {
      const payload = getSetPayload(store[key]);
      const meta = normalizeMetaForExport(rootMetaMap[key] || getSetMeta(store[key]) || {});
      const exportRows = rawRowsForExport(
        key,
        payload ? coerceToRows(payload.rows) : coerceToRows(store[key])
      );
      cleaned[key] = payload
        ? { meta: meta, rows: prepareRowsForSetExport(exportRows, meta) }
        : { meta: meta, rows: prepareRowsForSetExport(exportRows, meta) };
    });
    return [
      "// MG Product Swatches export: all sets",
      "window.MG_SWATCH_SETS = " + JSON.stringify(cleaned, null, 2) + ";"
    ].join("\n");
  }

  function formatPageSectionExport(context) {
    const scope = context && context.querySelectorAll ? context : document;
    try { buildFromDom(scope); } catch (_) { }

    const rootMetaMap = collectRootMetaMap(scope);
    const store = getSetStore();
    const ordered = [];
    const seen = new Set();

    function appendEntry(key, rows, rootOrMeta) {
      const setKey = collapseWhitespace(key || "");
      if (!setKey || seen.has(setKey)) return;
      const exportRows = rawRowsForExport(setKey, Array.isArray(rows) ? rows : []);
      seen.add(setKey);
      ordered.push({
        key: setKey,
        payload: prepareSetPayloadForExport(rootOrMeta, exportRows)
      });
    }

    scope.querySelectorAll('script[data-vimeo-control-spec][data-mg-product-swatches-spec][type="application/json"]').forEach((node) => {
      try {
        const spec = JSON.parse(node.textContent || "{}");
        const key = collapseWhitespace(spec && spec.targetSet);
        if (!key) return;
        const section = node.closest ? node.closest(".shopify-section") : null;
        const root = section && section.querySelector
          ? section.querySelector('.mg-product-swatches, [data-mg-set]')
          : null;
        const rows = rawRowsForExport(key, coerceToRows(spec && spec.rows));
        appendEntry(key, rows, root || rootMetaMap[key] || getExportMetaForKey(key, rootMetaMap, store));
        collectExportDependencyPayloads(key, rows, scope).forEach((entry) => {
          appendEntry(entry.key, entry.rows, entry.meta);
        });
      } catch (_) { }
    });

    const lines = [
      "// MG Product Swatches export: page Swatch Picker sections",
      "window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};"
    ];
    ordered.forEach((entry) => {
      lines.push("window.MG_SWATCH_SETS[" + JSON.stringify(entry.key) + "] = " + JSON.stringify(entry.payload, null, 2) + ";");
    });
    return lines.join("\n");
  }

  function mountExportUI(exportBox) {
    if (!exportBox || exportBox.__mgpsMounted) return;
    exportBox.__mgpsMounted = true;

    const sourceSet = String(exportBox.getAttribute("data-source-set") || "").trim();
    exportBox.innerHTML = [
      '<button class="mgps-export__toggle" type="button" data-mgps-toggle>Export JSON</button>',
      '<div class="mgps-export__panel" data-mgps-panel hidden>',
      '  <div class="mgps-export__bar">',
      '    <span class="mgps-export__label">Set:</span>',
      '    <input class="mgps-export__input" data-mgps-set />',
      '    <button class="mgps-export__btn" type="button" data-mgps-copy-all>Copy All</button>',
      '    <button class="mgps-export__btn" type="button" data-mgps-copy-page>Copy Page Sections</button>',
      '    <button class="mgps-export__btn" type="button" data-mgps-copy-set>Copy Media Set</button>',
      '    <button class="mgps-export__btn mgps-export__btn--close" type="button" data-mgps-close aria-label="Close">✕</button>',
      '  </div>',
      '  <textarea class="mgps-export__textarea" data-mgps-out rows="14" readonly></textarea>',
      '</div>'
    ].join("");

    const toggle = exportBox.querySelector("[data-mgps-toggle]");
    const panel = exportBox.querySelector("[data-mgps-panel]");
    const close = exportBox.querySelector("[data-mgps-close]");
    const copyAll = exportBox.querySelector("[data-mgps-copy-all]");
    const copyPage = exportBox.querySelector("[data-mgps-copy-page]");
    const copySet = exportBox.querySelector("[data-mgps-copy-set]");
    const out = exportBox.querySelector("[data-mgps-out]");
    const setInput = exportBox.querySelector("[data-mgps-set]");
    if (close) close.textContent = "\u2715";
    if (setInput) setInput.value = sourceSet;

    function currentKey() {
      const raw = collapseWhitespace(setInput ? setInput.value : sourceSet);
      return raw || sourceSet;
    }

    function currentRoot() {
      const explicitRootId = String(exportBox.getAttribute("data-mgps-root-id") || "").trim();
      if (explicitRootId) {
        const linked = document.getElementById(explicitRootId);
        if (linked) return linked;
      }
      const section = exportBox.closest ? exportBox.closest(".shopify-section") : null;
      if (section && section.querySelector) {
        const sectionRoot = section.querySelector('.mg-product-swatches, .mg-swatch-presets, [data-mg-set]');
        if (sectionRoot) return sectionRoot;
      }
      let root = exportBox.closest('.mg-product-swatches, .mg-swatch-presets, [data-mg-set]');
      if (root) return root;
      let probe = exportBox.previousElementSibling;
      while (probe) {
        if (probe.matches && probe.matches('.mg-product-swatches, .mg-swatch-presets, [data-mg-set]')) return probe;
        probe = probe.previousElementSibling;
      }
      probe = exportBox.parentElement;
      while (probe) {
        const found = probe.querySelector && probe.querySelector('.mg-product-swatches, .mg-swatch-presets, [data-mg-set]');
        if (found) return found;
        probe = probe.parentElement;
      }
      return null;
    }

    function currentRows() {
      const key = currentKey();
      const root = currentRoot();
      try { buildFromDom(document); } catch (_) { }
      const raw = rawRowsForExport(key, []);
      if (raw && raw.length) return raw;
      const resolved = key ? resolveSet(key, new Set()) : [];
      if (resolved && resolved.length) return resolved;
      if (root && Array.isArray(root.__mgpsResolvedRows) && root.__mgpsResolvedRows.length) return cloneDeep(root.__mgpsResolvedRows);
      return [];
    }

    function refreshTextarea() {
      const key = currentKey();
      out.value = key ? formatSetExport(key, currentRows(), currentRoot()) : "";
    }

    toggle.addEventListener("click", () => {
      const isHidden = !!panel.hidden;
      panel.hidden = !isHidden;
      if (isHidden) refreshTextarea();
    });

    close.addEventListener("click", () => {
      panel.hidden = true;
    });

    if (setInput) {
      setInput.addEventListener("input", refreshTextarea);
      setInput.addEventListener("change", refreshTextarea);
    }

    copySet.addEventListener("click", async () => {
      const key = currentKey();
      out.value = key ? formatSetInnerExport(key, currentRows(), currentRoot()) : "";
      try {
        await mgSelectAndCopyText(out);
        copySet.textContent = "Copied";
        window.setTimeout(() => { copySet.textContent = "Copy Media Set"; refreshTextarea(); }, 1200);
      } catch (_) { }
    });

    copyAll.addEventListener("click", async () => {
      out.value = formatAllExport(document);
      try {
        await mgSelectAndCopyText(out);
        copyAll.textContent = "Copied";
        window.setTimeout(() => { copyAll.textContent = "Copy All"; refreshTextarea(); }, 1200);
      } catch (_) { }
    });

    copyPage.addEventListener("click", async () => {
      out.value = formatPageSectionExport(document);
      try {
        await mgSelectAndCopyText(out);
        copyPage.textContent = "Copied";
        window.setTimeout(() => { copyPage.textContent = "Copy Page Sections"; refreshTextarea(); }, 1200);
      } catch (_) { }
    });

    refreshTextarea();
  }

  function ensureInlineExportUIForRoot(root) {
    if (!root) return;
    if (!shouldShowEditorExportForRoot(root)) {
      try {
        root.querySelectorAll(':scope > .mgps-export[data-mgps-inline-export]').forEach((box) => box.remove());
      } catch (_) { }
      return;
    }
    const setName = collapseWhitespace(root.getAttribute("data-mg-set") || root.getAttribute("data-vimeo-set") || "");
    if (!setName) return;

    let exportBox = null;
    try {
      exportBox = root.querySelector(':scope > .mgps-export[data-mgps-inline-export]');
    } catch (_) { }

    if (!exportBox) {
      exportBox = document.createElement("div");
      exportBox.className = "mgps-export";
      exportBox.setAttribute("data-mgps-export-box", "");
      exportBox.setAttribute("data-mgps-inline-export", "true");
      try { root.appendChild(exportBox); } catch (_) { return; }
    }

    try {
      exportBox.setAttribute("data-source-set", setName);
      if (root.id) exportBox.setAttribute("data-mgps-root-id", root.id);
    } catch (_) { }

    try { mountExportUI(exportBox); } catch (_) { }

    try {
      const section = root.closest ? root.closest(".shopify-section") : null;
      if (section && section.querySelectorAll) {
        section.querySelectorAll('.mgps-export[data-mgps-export-box]:not([data-mgps-inline-export])').forEach((box) => {
          try { box.style.display = "none"; } catch (_) { }
          try { box.setAttribute("hidden", "hidden"); } catch (_) { }
        });
      }
    } catch (_) { }
  }

  function initAll(context) {
    ensureDesignModeExportBoxes(context);
    const roots = getRoots(context);
    const deferredRoots = roots.filter((root) => {
      try {
        return rootHasAsyncProductDataDependency(root);
      } catch (_) {
        return false;
      }
    });
    const immediateRoots = roots.filter((root) => deferredRoots.indexOf(root) < 0);

    immediateRoots.forEach(scheduleInitRoot);
    deferredRoots.forEach((root) => {
      Promise.resolve(preloadRootAsyncProductData(root))
        .catch(() => null)
        .finally(() => {
          scheduleInitRoot(root);
        });
    });
    getExportBoxes(context).forEach(mountExportUI);
  }

  R.ensure = function (context) {
    const scope = context && context.querySelectorAll ? context : document;
    try { buildFromDom(scope); } catch (_) { }
    ensureDesignModeExportBoxes(scope);
    initAll(scope);
  };

  function initSpecificRoots(roots) {
    const list = Array.isArray(roots) ? roots.filter(Boolean) : [];
    list.forEach(scheduleInitRoot);
  }

  function preserveRootHeightDuringSwap(root) {
    if (!root || !root.style) return function () { };
    const previousMinHeight = root.style.minHeight;
    const currentHeight = Math.ceil(root.getBoundingClientRect ? (root.getBoundingClientRect().height || 0) : 0);
    if (currentHeight > 0) root.style.minHeight = currentHeight + "px";
    let released = false;
    return function release() {
      if (released) return;
      released = true;
      try {
        if (previousMinHeight) root.style.minHeight = previousMinHeight;
        else root.style.removeProperty("min-height");
      } catch (_) { }
    };
  }

  function rootContainsCurrentProductVariantSource(root) {
    if (!root) return false;
    try {
      const setName = String(root.getAttribute("data-mg-set") || root.getAttribute("data-vimeo-set") || "").trim();
      if (!setName) return false;
      return setContainsCurrentProductVariantSourceRaw(setName, new Set());
    } catch (_) {
      return false;
    }
  }

  function rootHasAsyncProductDataDependency(root) {
    if (!root) return false;
    try {
      const setName = String(root.getAttribute("data-mg-set") || root.getAttribute("data-vimeo-set") || "").trim();
      if (!setName) return false;
      return setHasAsyncProductDataDependencyRaw(setName, new Set());
    } catch (_) {
      return false;
    }
  }

  function preloadRootAsyncProductData(root) {
    if (!root) return Promise.resolve();
    try {
      const setName = String(root.getAttribute("data-mg-set") || root.getAttribute("data-vimeo-set") || "").trim();
      if (!setName) return Promise.resolve();

      const deps = collectAsyncProductDependenciesFromSetRows(rawRowsForSetLookup(setName), createAsyncProductDependencyBucket(), new Set([setName]));
      const jobs = [];

      if (deps.needsCurrentProduct && !currentStorefrontProductData()) {
        jobs.push(Promise.resolve(loadCurrentStorefrontProductData()).catch(() => null));
      }

      deps.handles.forEach((handle) => {
        const normalizedHandle = collapseWhitespace(handle || "");
        if (!normalizedHandle) return;
        if (cachedProductDataForHandle(normalizedHandle)) return;
        jobs.push(Promise.resolve(loadProductDataForHandle(normalizedHandle)).catch(() => null));
      });

      return jobs.length ? Promise.allSettled(jobs) : Promise.resolve();
    } catch (_) {
      return Promise.resolve();
    }
  }

  function refreshAsyncProductDataRoots(context) {
    const scope = context && context.querySelectorAll ? context : document;
    try {
      const roots = getRoots(scope).filter((root) => {
        try {
          return !!root.__mgpsInit && rootHasAsyncProductDataDependency(root);
        } catch (_) {
          return false;
        }
      });
      if (roots.length) refreshSpecificRoots(roots);
    } catch (_) { }
  }

  function refreshSpecificRoots(roots) {
    const list = Array.isArray(roots) ? roots.filter(Boolean) : [];
    if (!list.length) return;
    list.forEach((root) => {
      clearScheduledRoot(root);
    });
    try { buildFromDom(document); } catch (_) { }
    list.forEach((root) => {
      try {
        if (root.__mgpsInit) {
          renderRoot(root);
          return;
        }
      } catch (_) { }
      scheduleInitRoot(root);
    });
  }

  let mgpsLazyRootObserver = null;

  function clearScheduledRoot(root) {
    if (!root) return;
    try {
      if (mgpsLazyRootObserver) mgpsLazyRootObserver.unobserve(root);
    } catch (_) { }
    try { delete root.__mgpsLazyQueued; } catch (_) { }
  }

  function shouldLazyInitRoot(root) {
    if (!root || !root.getAttribute) return false;
    const raw = String(root.getAttribute("data-mgps-lazy") || "").trim().toLowerCase();
    if (!raw) return false;
    return raw !== "false" && raw !== "0" && raw !== "off" && raw !== "no";
  }

  function getLazyRootObserver() {
    if (mgpsLazyRootObserver || typeof IntersectionObserver !== "function") return mgpsLazyRootObserver;
    mgpsLazyRootObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry || !entry.target || !entry.isIntersecting) return;
        const root = entry.target;
        clearScheduledRoot(root);
        initRoot(root);
      });
    }, {
      rootMargin: "300px 0px"
    });
    return mgpsLazyRootObserver;
  }

  function scheduleInitRoot(root) {
    if (!root || root.__mgpsInit) return;
    if (!shouldLazyInitRoot(root)) {
      clearScheduledRoot(root);
      initRoot(root);
      return;
    }
    const observer = getLazyRootObserver();
    if (!observer) {
      initRoot(root);
      return;
    }
    if (root.__mgpsLazyQueued) return;
    root.__mgpsLazyQueued = true;
    observer.observe(root);
  }

  R.refresh = function (context) {
    const scope = context && context.querySelectorAll ? context : document;
    try { buildFromDom(document); } catch (_) { }
    getRoots(scope).forEach((root) => {
      clearScheduledRoot(root);
      try {
        if (root.__mgpsInit) {
          renderRoot(root);
          scheduleRelayoutRoot(root);
          return;
        }
      } catch (_) { }
      scheduleInitRoot(root);
    });
    getExportBoxes(scope).forEach(mountExportUI);
  };

  R.destroy = function (context) {
    const scope = context && context.querySelectorAll ? context : document;
    getRoots(scope).forEach((root) => {
      clearScheduledRoot(root);
      try {
        if (typeof root.__mgpsDestroy === "function") root.__mgpsDestroy();
      } catch (_) { }
    });
    try {
      if (R.__modal && typeof R.__modal.close === "function") {
        R.__modal.close();
      }
    } catch (_) { }
  };

  function scheduleSectionRefresh(context) {
    const scope = context && context.querySelectorAll ? context : document;
    if (!scope) return;
    try {
      if (scope.__mgpsSectionRefreshTimer) clearTimeout(scope.__mgpsSectionRefreshTimer);
    } catch (_) { }

    const run = () => {
      try {
        if (scope.__mgpsSectionRefreshFrame) cancelAnimationFrame(scope.__mgpsSectionRefreshFrame);
      } catch (_) { }
      try {
        scope.__mgpsSectionRefreshFrame = requestAnimationFrame(() => {
          try { R.refresh(scope); } catch (_) { }
        });
      } catch (_) {
        try { R.refresh(scope); } catch (_) { }
      }
    };

    try {
      scope.__mgpsSectionRefreshTimer = setTimeout(run, 0);
    } catch (_) {
      run();
    }
  }

  ready(() => {
    applyPendingViewportScrollPosition();
    try { buildFromDom(document); } catch (_) { }
    initAll(document);
  });

  document.addEventListener("variant:changed", () => {
    scheduleCurrentStorefrontProductRefresh();
    scheduleStableSlotRefresh(currentMainProductSection(document) || document);
  });

  document.addEventListener("media_gallery_sets_ready", () => {
    try {
      if (R.__dispatchingSetsReady) return;
    } catch (_) { }
    scheduleSectionRefresh(document);
  });

  window.addEventListener("popstate", () => {
    scheduleCurrentStorefrontProductRefresh();
  });

  try {
    const originalReplaceState = history.replaceState;
    if (typeof originalReplaceState === "function" && !R.__patchedReplaceState) {
      history.replaceState = function () {
        const result = originalReplaceState.apply(this, arguments);
        try { scheduleCurrentStorefrontProductRefresh(); } catch (_) { }
        return result;
      };
      R.__patchedReplaceState = true;
    }
  } catch (_) { }

  try {
    const originalPushState = history.pushState;
    if (typeof originalPushState === "function" && !R.__patchedPushState) {
      history.pushState = function () {
        const result = originalPushState.apply(this, arguments);
        try { scheduleCurrentStorefrontProductRefresh(); } catch (_) { }
        return result;
      };
      R.__patchedPushState = true;
    }
  } catch (_) { }

  document.addEventListener("shopify:section:load", (event) => {
    if (!event || !event.target) return;
    scheduleStableSlotRefresh(event.target);
    scheduleSectionRefresh(event.target);
  });

  document.addEventListener("shopify:section:reorder", (event) => {
    if (!event || !event.target) return;
    scheduleStableSlotRefresh(event.target);
    scheduleSectionRefresh(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    if (!event || !event.target) return;
    R.destroy(event.target);
  });

  ready(() => {
    scheduleStableSlotRefresh(document);
  });
})();
